//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const BILLING_API_BASE_URL = new InjectionToken<string>('BILLING_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class BillingFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BILLING_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProgramConfigHistoryById(programConfigId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/{programConfigId}/history";
        if (programConfigId === undefined || programConfigId === null)
            throw new Error("The parameter 'programConfigId' must be defined.");
        url_ = url_.replace("{programConfigId}", encodeURIComponent("" + programConfigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramConfigHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramConfigHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetProgramConfigHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    ingestBulkAdjustments(body?: BulkAdjustmentsIngestionDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustment/bulkingest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngestBulkAdjustments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngestBulkAdjustments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processIngestBulkAdjustments(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param supressWwlWarning (optional) 
     * @param body (optional) 
     * @return Success
     */
    createProcessAdjustment(supressWwlWarning?: boolean | undefined, body?: AdjustmentProcessorDetailsDto[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustment/create?";
        if (supressWwlWarning === null)
            throw new Error("The parameter 'supressWwlWarning' cannot be null.");
        else if (supressWwlWarning !== undefined)
            url_ += "supressWwlWarning=" + encodeURIComponent("" + supressWwlWarning) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProcessAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProcessAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateProcessAdjustment(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAdjustmentNotes(body?: AdjustmentNotes[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustment/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAdjustmentNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAdjustmentNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateAdjustmentNotes(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAdjustmentNotesByTcn(body?: string | undefined): Observable<AdjustmentNotes[]> {
        let url_ = this.baseUrl + "/api/adjustment/notes/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdjustmentNotesByTcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdjustmentNotesByTcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentNotes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentNotes[]>;
        }));
    }

    protected processGetAdjustmentNotesByTcn(response: HttpResponseBase): Observable<AdjustmentNotes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdjustmentNotes.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ccnUpdateProceed(body?: CcnRefreshProceedRequestDto[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustmentclaims/ccnupdateproceed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCcnUpdateProceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCcnUpdateProceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCcnUpdateProceed(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAdjustmentClaims(body?: AdjustmentClaimsPublishRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustmentclaims/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAdjustmentClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAdjustmentClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportAdjustmentClaims(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAsDraftForAdjustmentProcessor(body?: AdjustmentProcessorDetailsDto[] | undefined): Observable<SaveAsDraftForAdjustmentResponse> {
        let url_ = this.baseUrl + "/api/adjustmentclaims/saveasdraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAsDraftForAdjustmentProcessor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAsDraftForAdjustmentProcessor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveAsDraftForAdjustmentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveAsDraftForAdjustmentResponse>;
        }));
    }

    protected processSaveAsDraftForAdjustmentProcessor(response: HttpResponseBase): Observable<SaveAsDraftForAdjustmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveAsDraftForAdjustmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateAdjustmentCode(body?: AdjustmentCodeDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustmentcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateAdjustmentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateAdjustmentCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateAdjustmentCode(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteAdjustmentCode(body?: number[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustmentcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAdjustmentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAdjustmentCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteAdjustmentCode(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param codeQuery (optional) 
     * @return Success
     */
    getAdjustmentCodesByCode(codePath: string, codeQuery?: string | undefined): Observable<AdjustmentCodeDto[]> {
        let url_ = this.baseUrl + "/api/adjustmentcode/{code}?";
        if (codePath === undefined || codePath === null)
            throw new Error("The parameter 'codePath' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + codePath));
        if (codeQuery === null)
            throw new Error("The parameter 'codeQuery' cannot be null.");
        else if (codeQuery !== undefined)
            url_ += "code=" + encodeURIComponent("" + codeQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdjustmentCodesByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdjustmentCodesByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentCodeDto[]>;
        }));
    }

    protected processGetAdjustmentCodesByCode(response: HttpResponseBase): Observable<AdjustmentCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdjustmentCodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAdjustmentCodes(body?: AdjustmentCodeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustmentcode/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAdjustmentCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAdjustmentCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportAdjustmentCodes(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllAdjustmentCodes(body?: AdjustmentCodeRequestDto | undefined): Observable<AdjustmentCodesResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/adjustmentcodes/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdjustmentCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdjustmentCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentCodesResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentCodesResponseDtoGridResponseBase>;
        }));
    }

    protected processGetAllAdjustmentCodes(response: HttpResponseBase): Observable<AdjustmentCodesResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdjustmentCodesResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    adjustmentOptionsForSystemRead(systemusageid: number): Observable<AdjustmentOptionUsageDto[]> {
        let url_ = this.baseUrl + "/api/adjustmentoptionvalues/{systemusageid}";
        if (systemusageid === undefined || systemusageid === null)
            throw new Error("The parameter 'systemusageid' must be defined.");
        url_ = url_.replace("{systemusageid}", encodeURIComponent("" + systemusageid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustmentOptionsForSystemRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustmentOptionsForSystemRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentOptionUsageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentOptionUsageDto[]>;
        }));
    }

    protected processAdjustmentOptionsForSystemRead(response: HttpResponseBase): Observable<AdjustmentOptionUsageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdjustmentOptionUsageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adjustmentReasonCreate(body?: AdjustmentReasonRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/AdjustmentReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustmentReasonCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustmentReasonCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processAdjustmentReasonCreate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    adjustmentReasonRead(adjustmentReasonId: number): Observable<AdjustmentReasonRequest> {
        let url_ = this.baseUrl + "/api/AdjustmentReason/{adjustmentReasonId}";
        if (adjustmentReasonId === undefined || adjustmentReasonId === null)
            throw new Error("The parameter 'adjustmentReasonId' must be defined.");
        url_ = url_.replace("{adjustmentReasonId}", encodeURIComponent("" + adjustmentReasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustmentReasonRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustmentReasonRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentReasonRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentReasonRequest>;
        }));
    }

    protected processAdjustmentReasonRead(response: HttpResponseBase): Observable<AdjustmentReasonRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdjustmentReasonRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adjustmentReasonUpdate(adjustmentReasonId: number, body?: AdjustmentReasonRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/AdjustmentReason/{adjustmentReasonId}";
        if (adjustmentReasonId === undefined || adjustmentReasonId === null)
            throw new Error("The parameter 'adjustmentReasonId' must be defined.");
        url_ = url_.replace("{adjustmentReasonId}", encodeURIComponent("" + adjustmentReasonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustmentReasonUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustmentReasonUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processAdjustmentReasonUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeDeleted (optional) 
     * @return Success
     */
    adjustmentReasonListRead(includeDeleted?: boolean | undefined): Observable<AdjustmentReasonRequest[]> {
        let url_ = this.baseUrl + "/api/adjustmentreasons?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustmentReasonListRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustmentReasonListRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentReasonRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentReasonRequest[]>;
        }));
    }

    protected processAdjustmentReasonListRead(response: HttpResponseBase): Observable<AdjustmentReasonRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdjustmentReasonRequest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adjustmentReasonListUpdate(body?: AdjustmentReasonRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/adjustmentreasons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustmentReasonListUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustmentReasonListUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processAdjustmentReasonListUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    fetchAdjustmentReasons(systemusage: string, adjustmentOptionName: string): Observable<AdjustmentReasonUsageDto[]> {
        let url_ = this.baseUrl + "/api/adjustmentreasonvalues/{systemusage}/{adjustmentOptionName}";
        if (systemusage === undefined || systemusage === null)
            throw new Error("The parameter 'systemusage' must be defined.");
        url_ = url_.replace("{systemusage}", encodeURIComponent("" + systemusage));
        if (adjustmentOptionName === undefined || adjustmentOptionName === null)
            throw new Error("The parameter 'adjustmentOptionName' must be defined.");
        url_ = url_.replace("{adjustmentOptionName}", encodeURIComponent("" + adjustmentOptionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetchAdjustmentReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetchAdjustmentReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentReasonUsageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentReasonUsageDto[]>;
        }));
    }

    protected processFetchAdjustmentReasons(response: HttpResponseBase): Observable<AdjustmentReasonUsageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdjustmentReasonUsageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param systemusageidQuery (optional) 
     * @return Success
     */
    adjustmentReasonForSystemRead(systemusageidPath: string, systemusageidQuery?: number | undefined): Observable<AdjustmentReasonUsageDto[]> {
        let url_ = this.baseUrl + "/api/adjustmentreasonvalues/{systemusageid}?";
        if (systemusageidPath === undefined || systemusageidPath === null)
            throw new Error("The parameter 'systemusageidPath' must be defined.");
        url_ = url_.replace("{systemusageid}", encodeURIComponent("" + systemusageidPath));
        if (systemusageidQuery === null)
            throw new Error("The parameter 'systemusageidQuery' cannot be null.");
        else if (systemusageidQuery !== undefined)
            url_ += "systemusageid=" + encodeURIComponent("" + systemusageidQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustmentReasonForSystemRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustmentReasonForSystemRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentReasonUsageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentReasonUsageDto[]>;
        }));
    }

    protected processAdjustmentReasonForSystemRead(response: HttpResponseBase): Observable<AdjustmentReasonUsageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdjustmentReasonUsageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllLogDetailsBySearchCriteria(body?: AgreementLogHeaderRequest | undefined): Observable<AgreementLogSummary> {
        let url_ = this.baseUrl + "/api/Auth/log/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLogDetailsBySearchCriteria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLogDetailsBySearchCriteria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementLogSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementLogSummary>;
        }));
    }

    protected processGetAllLogDetailsBySearchCriteria(response: HttpResponseBase): Observable<AgreementLogSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementLogSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertIntegrationInboundCoPay(body?: CoPayUpsertRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/authint/inbound/copay/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertIntegrationInboundCoPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertIntegrationInboundCoPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertIntegrationInboundCoPay(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBillingStatus(category: string): Observable<BillingStatusDetailsDto[]> {
        let url_ = this.baseUrl + "/api/billing/status/{category}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingStatusDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingStatusDetailsDto[]>;
        }));
    }

    protected processGetBillingStatus(response: HttpResponseBase): Observable<BillingStatusDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingStatusDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBcnFromTcn(body?: VoidInjectorDto[] | undefined): Observable<AdjustmentProcessorDetailsDto[]> {
        let url_ = this.baseUrl + "/api/billingadjustments/bcn/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBcnFromTcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBcnFromTcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdjustmentProcessorDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdjustmentProcessorDetailsDto[]>;
        }));
    }

    protected processGetBcnFromTcn(response: HttpResponseBase): Observable<AdjustmentProcessorDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdjustmentProcessorDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBCNForAdjustment(body?: BcnAdjustmentsFilterRequest | undefined): Observable<BcnAdjustmentsGridResponse> {
        let url_ = this.baseUrl + "/api/billingadjustments/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBCNForAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBCNForAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BcnAdjustmentsGridResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BcnAdjustmentsGridResponse>;
        }));
    }

    protected processGetBCNForAdjustment(response: HttpResponseBase): Observable<BcnAdjustmentsGridResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BcnAdjustmentsGridResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportGhaBcnAdjustmentClaims(body?: BcnAdjustmentsFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/billingadjustments/gha/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGhaBcnAdjustmentClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGhaBcnAdjustmentClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportGhaBcnAdjustmentClaims(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getGhaBcnForAdjustment(body?: BcnAdjustmentsFilterRequest | undefined): Observable<BcnAdjustmentsGridResponse> {
        let url_ = this.baseUrl + "/api/billingadjustments/gha/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGhaBcnForAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGhaBcnForAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BcnAdjustmentsGridResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BcnAdjustmentsGridResponse>;
        }));
    }

    protected processGetGhaBcnForAdjustment(response: HttpResponseBase): Observable<BcnAdjustmentsGridResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BcnAdjustmentsGridResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBillingParticipantByParticipantId(participantId: string): Observable<BillingParticipantResponseDto> {
        let url_ = this.baseUrl + "/api/billingparticipant/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingParticipantByParticipantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingParticipantByParticipantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingParticipantResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingParticipantResponseDto>;
        }));
    }

    protected processGetBillingParticipantByParticipantId(response: HttpResponseBase): Observable<BillingParticipantResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingParticipantResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantDetailsHistory(participantId: string, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/billingparticipant/{participantId}/history";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantDetailsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantDetailsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetParticipantDetailsHistory(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertBillingParticipant(body?: BillingParticipantRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/billingparticipant/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertBillingParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertBillingParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertBillingParticipant(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingDashboardAging(body?: BillingDashboardRequest | undefined): Observable<BillingDashboardAgingResponse[]> {
        let url_ = this.baseUrl + "/api/BilllingDashboard/aging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDashboardAging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDashboardAging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDashboardAgingResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDashboardAgingResponse[]>;
        }));
    }

    protected processGetBillingDashboardAging(response: HttpResponseBase): Observable<BillingDashboardAgingResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingDashboardAgingResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingDashboardBatches(body?: BillingDashboardRequest | undefined): Observable<BillingDashboardBatchesResponse[]> {
        let url_ = this.baseUrl + "/api/BilllingDashboard/batches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDashboardBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDashboardBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDashboardBatchesResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDashboardBatchesResponse[]>;
        }));
    }

    protected processGetBillingDashboardBatches(response: HttpResponseBase): Observable<BillingDashboardBatchesResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingDashboardBatchesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingDashboadClaimStatus(body?: BillingDashboardRequest | undefined): Observable<BillingDashboardClaimStatusResponse[]> {
        let url_ = this.baseUrl + "/api/BilllingDashboard/claimstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDashboadClaimStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDashboadClaimStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDashboardClaimStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDashboardClaimStatusResponse[]>;
        }));
    }

    protected processGetBillingDashboadClaimStatus(response: HttpResponseBase): Observable<BillingDashboardClaimStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingDashboardClaimStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingDashboardPayments(body?: BillingDashboardRequest | undefined): Observable<BillingDashboardPaymentResponse[]> {
        let url_ = this.baseUrl + "/api/BilllingDashboard/payments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDashboardPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDashboardPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDashboardPaymentResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDashboardPaymentResponse[]>;
        }));
    }

    protected processGetBillingDashboardPayments(response: HttpResponseBase): Observable<BillingDashboardPaymentResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingDashboardPaymentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBillingDashboardDefaultTemplate(): Observable<number> {
        let url_ = this.baseUrl + "/api/BilllingDashboard/template/default";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDashboardDefaultTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDashboardDefaultTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetBillingDashboardDefaultTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingDashboardTemplateDetails(body?: PostRequestBase | undefined): Observable<BillingDashboardTemplate> {
        let url_ = this.baseUrl + "/api/BilllingDashboard/template/details/id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDashboardTemplateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDashboardTemplateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDashboardTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDashboardTemplate>;
        }));
    }

    protected processGetBillingDashboardTemplateDetails(response: HttpResponseBase): Observable<BillingDashboardTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingDashboardTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingDashboadTemplate(body?: BillingDashboardTemplateRequest | undefined): Observable<BillingDashboardTemplateGridResponseBase> {
        let url_ = this.baseUrl + "/api/BilllingDashboard/template/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDashboadTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDashboadTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDashboardTemplateGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDashboardTemplateGridResponseBase>;
        }));
    }

    protected processGetBillingDashboadTemplate(response: HttpResponseBase): Observable<BillingDashboardTemplateGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingDashboardTemplateGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBillingDashboardTemplate(body?: BillingDashboardTemplate | undefined): Observable<Int64NullableApiResponse> {
        let url_ = this.baseUrl + "/api/BilllingDashboard/template/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBillingDashboardTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBillingDashboardTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int64NullableApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int64NullableApiResponse>;
        }));
    }

    protected processSaveBillingDashboardTemplate(response: HttpResponseBase): Observable<Int64NullableApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int64NullableApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param claim (optional) 
     * @return Success
     */
    paymentByClaim(ccn: string, claim?: string | undefined): Observable<Payment[]> {
        let url_ = this.baseUrl + "/api/claim/{ccn}/payments?";
        if (ccn === undefined || ccn === null)
            throw new Error("The parameter 'ccn' must be defined.");
        url_ = url_.replace("{ccn}", encodeURIComponent("" + ccn));
        if (claim === null)
            throw new Error("The parameter 'claim' cannot be null.");
        else if (claim !== undefined)
            url_ += "claim=" + encodeURIComponent("" + claim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentByClaim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentByClaim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Payment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Payment[]>;
        }));
    }

    protected processPaymentByClaim(response: HttpResponseBase): Observable<Payment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Payment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteClaimBatch(body?: BatchReason | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClaimBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClaimBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteClaimBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRelatedCCNIds(batchId: string, ccnId: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/claimbatch/{batchId}/{ccnId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (ccnId === undefined || ccnId === null)
            throw new Error("The parameter 'ccnId' must be defined.");
        url_ = url_.replace("{ccnId}", encodeURIComponent("" + ccnId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatedCCNIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedCCNIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetRelatedCCNIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveClaimBatch(body?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimbatch/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveClaimBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveClaimBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processApproveClaimBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCCNGridData(body?: CustomGridFilterRequest | undefined): Observable<CCNDTOGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimbatch/ccndata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCCNGridData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCCNGridData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CCNDTOGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CCNDTOGridResponseBase>;
        }));
    }

    protected processGetCCNGridData(response: HttpResponseBase): Observable<CCNDTOGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CCNDTOGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchIdQuery (optional) 
     * @return Success
     */
    getAllExcludedCCN(batchIdPath: string, batchIdQuery?: string | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/claimbatch/excludedccns/{batchId}?";
        if (batchIdPath === undefined || batchIdPath === null)
            throw new Error("The parameter 'batchIdPath' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchIdPath));
        if (batchIdQuery === null)
            throw new Error("The parameter 'batchIdQuery' cannot be null.");
        else if (batchIdQuery !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExcludedCCN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExcludedCCN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllExcludedCCN(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getExcludedClaims(body?: CustomGridFilterRequest | undefined): Observable<ExcludedClaimsDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimbatch/excludedclaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcludedClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcludedClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcludedClaimsDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcludedClaimsDtoGridResponseBase>;
        }));
    }

    protected processGetExcludedClaims(response: HttpResponseBase): Observable<ExcludedClaimsDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcludedClaimsDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    claimBatchExcludedFromJsonExport(body?: SearchParamsForReviewDTO | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimbatch/excludedfromjson/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClaimBatchExcludedFromJsonExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClaimBatchExcludedFromJsonExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processClaimBatchExcludedFromJsonExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getExcludedVoidedCCNGridData(body?: CustomGridFilterRequest | undefined): Observable<ExcludedVoidedCCNDTOGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimbatch/excludedvoidedccndata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcludedVoidedCCNGridData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcludedVoidedCCNGridData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcludedVoidedCCNDTOGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcludedVoidedCCNDTOGridResponseBase>;
        }));
    }

    protected processGetExcludedVoidedCCNGridData(response: HttpResponseBase): Observable<ExcludedVoidedCCNDTOGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcludedVoidedCCNDTOGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    claimBatchExport(body?: SearchParamsForReviewDTO | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimbatch/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClaimBatchExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClaimBatchExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processClaimBatchExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllClaimBatch(body?: GetClaimBatchFilterRequest | undefined): Observable<ClaimBatchDTOGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimbatch/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClaimBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClaimBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimBatchDTOGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimBatchDTOGridResponseBase>;
        }));
    }

    protected processGetAllClaimBatch(response: HttpResponseBase): Observable<ClaimBatchDTOGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimBatchDTOGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchIdQuery (optional) 
     * @return Success
     */
    getGlXmlData(batchIdPath: string, batchIdQuery?: string | undefined): Observable<GlXmlGridResponse[]> {
        let url_ = this.baseUrl + "/api/claimbatch/getglxmldata/{batchId}?";
        if (batchIdPath === undefined || batchIdPath === null)
            throw new Error("The parameter 'batchIdPath' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchIdPath));
        if (batchIdQuery === null)
            throw new Error("The parameter 'batchIdQuery' cannot be null.");
        else if (batchIdQuery !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlXmlData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlXmlData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlXmlGridResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlXmlGridResponse[]>;
        }));
    }

    protected processGetGlXmlData(response: HttpResponseBase): Observable<GlXmlGridResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlXmlGridResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getManualClaimsBatchLookup(body?: BatchLookupRequestDto | undefined): Observable<ManualClaimBatchLookupResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimbatch/manualclaimsbatchlookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualClaimsBatchLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualClaimsBatchLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualClaimBatchLookupResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualClaimBatchLookupResponseDtoGridResponseBase>;
        }));
    }

    protected processGetManualClaimsBatchLookup(response: HttpResponseBase): Observable<ManualClaimBatchLookupResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualClaimBatchLookupResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectCCNData(body?: BatchReason | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimbatch/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectCCNData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectCCNData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processRejectCCNData(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCCNData(body?: BatchReason | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimbatch/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCCNData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCCNData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveCCNData(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSearchParamsForBatchReview(id: string): Observable<SearchParamsForReviewDTO> {
        let url_ = this.baseUrl + "/api/claimbatch/searchparams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchParamsForBatchReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchParamsForBatchReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchParamsForReviewDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchParamsForReviewDTO>;
        }));
    }

    protected processGetSearchParamsForBatchReview(response: HttpResponseBase): Observable<SearchParamsForReviewDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchParamsForReviewDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCcnDetails(body?: UpdateCcnDetailsDTO | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCcnDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCcnDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCcnDetails(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getClaimAuthDetailsByCcn(ccn: string, flag: boolean): Observable<ClaimAuth[]> {
        let url_ = this.baseUrl + "/api/claimdetails/{ccn}/auth/fetch/{flag}";
        if (ccn === undefined || ccn === null)
            throw new Error("The parameter 'ccn' must be defined.");
        url_ = url_.replace("{ccn}", encodeURIComponent("" + ccn));
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined.");
        url_ = url_.replace("{flag}", encodeURIComponent("" + flag));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaimAuthDetailsByCcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaimAuthDetailsByCcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimAuth[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimAuth[]>;
        }));
    }

    protected processGetClaimAuthDetailsByCcn(response: HttpResponseBase): Observable<ClaimAuth[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimAuth.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateClaimlinesDenialReasonsBulk(body?: ClaimlineDenialReasonsRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails/addclaimlinedenialreasonsbulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateClaimlinesDenialReasonsBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateClaimlinesDenialReasonsBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateClaimlinesDenialReasonsBulk(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateClaimlinesNoteBulk(body?: ClaimlineDenialReasonsRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails/addclaimlinenote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateClaimlinesNoteBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateClaimlinesNoteBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateClaimlinesNoteBulk(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAdjustmentHistoryByCcn(body?: LCNFilterRequest | undefined): Observable<CcnHistoryDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimdetails/adjustment/history/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdjustmentHistoryByCcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdjustmentHistoryByCcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcnHistoryDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcnHistoryDtoGridResponseBase>;
        }));
    }

    protected processGetAdjustmentHistoryByCcn(response: HttpResponseBase): Observable<CcnHistoryDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcnHistoryDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBatchHistoryById(body?: PostRequestBase | undefined): Observable<BCCNStatusStatusHistoryGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimdetails/batchhistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BCCNStatusStatusHistoryGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BCCNStatusStatusHistoryGridResponseBase>;
        }));
    }

    protected processGetBatchHistoryById(response: HttpResponseBase): Observable<BCCNStatusStatusHistoryGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BCCNStatusStatusHistoryGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBCNDetailsById(body?: FilterRequestWithId | undefined): Observable<BcnDetailsDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimdetails/bcndetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBCNDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBCNDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BcnDetailsDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BcnDetailsDtoGridResponseBase>;
        }));
    }

    protected processGetBCNDetailsById(response: HttpResponseBase): Observable<BcnDetailsDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BcnDetailsDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCCNDetailsById(ccn: string): Observable<CcnDetailsDto> {
        let url_ = this.baseUrl + "/api/claimdetails/ccndetails/{ccn}";
        if (ccn === undefined || ccn === null)
            throw new Error("The parameter 'ccn' must be defined.");
        url_ = url_.replace("{ccn}", encodeURIComponent("" + ccn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCCNDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCCNDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcnDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcnDetailsDto>;
        }));
    }

    protected processGetCCNDetailsById(response: HttpResponseBase): Observable<CcnDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcnDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCcnListExport(body?: CcnSearchRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails/ccnlist/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCcnListExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCcnListExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processGetCcnListExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCCNList(body?: CcnSearchRequest | undefined): Observable<CcnDetailDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimdetails/ccnlist/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCCNList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCCNList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcnDetailDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcnDetailDtoGridResponseBase>;
        }));
    }

    protected processGetCCNList(response: HttpResponseBase): Observable<CcnDetailDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcnDetailDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLcnListExport(body?: LCNUpdateSearchRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails/claimlines/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLcnListExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLcnListExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processGetLcnListExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllClaimSummaryInquiry(body?: ClaimSummaryRequestDto | undefined): Observable<ClaimSummaryInquiryDetailDtoClaimSummaryGridResponse> {
        let url_ = this.baseUrl + "/api/claimdetails/claimsummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClaimSummaryInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClaimSummaryInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimSummaryInquiryDetailDtoClaimSummaryGridResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimSummaryInquiryDetailDtoClaimSummaryGridResponse>;
        }));
    }

    protected processGetAllClaimSummaryInquiry(response: HttpResponseBase): Observable<ClaimSummaryInquiryDetailDtoClaimSummaryGridResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimSummaryInquiryDetailDtoClaimSummaryGridResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    claimSummaryExport(body?: ClaimSummaryRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails/claimsummary/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClaimSummaryExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClaimSummaryExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processClaimSummaryExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportGlXml(body?: GlXmlExportRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails/glxmlgriddata/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGlXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGlXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportGlXml(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllIcnByCcn(body?: ClaimDetailFlyoutRequest | undefined): Observable<IcnResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimdetails/icn/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIcnByCcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIcnByCcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IcnResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IcnResponseGridResponseBase>;
        }));
    }

    protected processGetAllIcnByCcn(response: HttpResponseBase): Observable<IcnResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IcnResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIcnForClaimRecord(body?: UpdateIcnRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails/icnbulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIcnForClaimRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIcnForClaimRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateIcnForClaimRecord(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLCNDetailsById(body?: LCNFilterRequest | undefined): Observable<LcnDetailsDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimdetails/lcndetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLCNDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLCNDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LcnDetailsDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LcnDetailsDtoGridResponseBase>;
        }));
    }

    protected processGetLCNDetailsById(response: HttpResponseBase): Observable<LcnDetailsDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LcnDetailsDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClaimlinesStatusBulk(body?: ClaimlineOverrideStatusRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimdetails/updateclaimlinestatusbulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClaimlinesStatusBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClaimlinesStatusBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateClaimlinesStatusBulk(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param lcnQuery (optional) 
     * @return Success
     */
    getLcnHistoryByLcn(lcnPath: string, lcnQuery?: string | undefined): Observable<LCNHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/claimlines/history/{lcn}?";
        if (lcnPath === undefined || lcnPath === null)
            throw new Error("The parameter 'lcnPath' must be defined.");
        url_ = url_.replace("{lcn}", encodeURIComponent("" + lcnPath));
        if (lcnQuery === null)
            throw new Error("The parameter 'lcnQuery' cannot be null.");
        else if (lcnQuery !== undefined)
            url_ += "lcn=" + encodeURIComponent("" + lcnQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLcnHistoryByLcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLcnHistoryByLcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LCNHistoryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LCNHistoryResponse[]>;
        }));
    }

    protected processGetLcnHistoryByLcn(response: HttpResponseBase): Observable<LCNHistoryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LCNHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLcnUpdateDetails(body?: LCNUpdateSearchRequest | undefined): Observable<LCNUpdateDetailsResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimlines/updatedetails/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLcnUpdateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLcnUpdateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LCNUpdateDetailsResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LCNUpdateDetailsResponseGridResponseBase>;
        }));
    }

    protected processGetLcnUpdateDetails(response: HttpResponseBase): Observable<LCNUpdateDetailsResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LCNUpdateDetailsResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentApplicationData(body?: ApplicationQueryReversalRequestDto | undefined): Observable<ApplicationQueryReversalResponseDto> {
        let url_ = this.baseUrl + "/api/claimpayment/application/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentApplicationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentApplicationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationQueryReversalResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationQueryReversalResponseDto>;
        }));
    }

    protected processGetPaymentApplicationData(response: HttpResponseBase): Observable<ApplicationQueryReversalResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationQueryReversalResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processPaymentApplication(body?: PaymentApplicationRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/application/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessPaymentApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessPaymentApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processProcessPaymentApplication(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentBatchHistoryById(body?: PostRequestBase | undefined): Observable<PaymentBatchHistoryDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimpayment/batchhistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBatchHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBatchHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBatchHistoryDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBatchHistoryDtoGridResponseBase>;
        }));
    }

    protected processGetPaymentBatchHistoryById(response: HttpResponseBase): Observable<PaymentBatchHistoryDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentBatchHistoryDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentBatchId(body?: PaymentsBatchRequestDto | undefined): Observable<PaymentsBatchDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimpayment/batchid/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentsBatchDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentsBatchDtoGridResponseBase>;
        }));
    }

    protected processGetPaymentBatchId(response: HttpResponseBase): Observable<PaymentsBatchDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentsBatchDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentBatchExport(body?: PaymentBatchExportRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBatchExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBatchExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processGetPaymentBatchExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchNumber (optional) 
     * @param body (optional) 
     * @return Success
     */
    getMcnForParticipant(batchNumber?: string | undefined, body?: PaymentsBatchRequestDto | undefined): Observable<McnLookupResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimpayment/mcn/fetch?";
        if (batchNumber === null)
            throw new Error("The parameter 'batchNumber' cannot be null.");
        else if (batchNumber !== undefined)
            url_ += "batchNumber=" + encodeURIComponent("" + batchNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMcnForParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMcnForParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<McnLookupResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<McnLookupResponseDtoGridResponseBase>;
        }));
    }

    protected processGetMcnForParticipant(response: HttpResponseBase): Observable<McnLookupResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = McnLookupResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAutoBatchNumber(): Observable<string> {
        let url_ = this.baseUrl + "/api/claimpayment/newbatchnumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoBatchNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoBatchNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAutoBatchNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentBatchOrphansExport(body?: PaymentBatchExportRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/orphans/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBatchOrphansExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBatchOrphansExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processGetPaymentBatchOrphansExport(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantPaymentsData(body?: ParticipantPaymentsDataRequestDto | undefined): Observable<ParticipantPaymentsDataDto[]> {
        let url_ = this.baseUrl + "/api/claimpayment/participantpaymentsdata/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantPaymentsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantPaymentsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantPaymentsDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantPaymentsDataDto[]>;
        }));
    }

    protected processGetParticipantPaymentsData(response: HttpResponseBase): Observable<ParticipantPaymentsDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantPaymentsDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePaymentBatch(body?: PaymentsBatchDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePaymentBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePaymentBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSavePaymentBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approvePaymentBatch(body?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatch/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovePaymentBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovePaymentBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processApprovePaymentBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePaymentBatch(body?: PaymentBatchDeleteRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatch/deletebatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePaymentBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaymentBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeletePaymentBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentBatch(body?: PaymentsBatchRequestDto | undefined): Observable<PaymentsBatchDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatch/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentsBatchDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentsBatchDtoGridResponseBase>;
        }));
    }

    protected processGetPaymentBatch(response: HttpResponseBase): Observable<PaymentsBatchDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentsBatchDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentBatchById(body?: PostRequestBase | undefined): Observable<PaymentsBatchDto> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatch/fetch/id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBatchById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBatchById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentsBatchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentsBatchDto>;
        }));
    }

    protected processGetPaymentBatchById(response: HttpResponseBase): Observable<PaymentsBatchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentsBatchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectPaymentBatch(body?: PaymentBatchRejectRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatch/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectPaymentBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectPaymentBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processRejectPaymentBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitPaymentBatch(body?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatch/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitPaymentBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitPaymentBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSubmitPaymentBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentBatchLookup(body?: BatchLookupRequestDto | undefined): Observable<BatchLookupResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatchlookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBatchLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBatchLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchLookupResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchLookupResponseDtoGridResponseBase>;
        }));
    }

    protected processGetPaymentBatchLookup(response: HttpResponseBase): Observable<BatchLookupResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchLookupResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePaymentBatchUpdate(body?: PaymentsBatchDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/paymentbatchupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePaymentBatchUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePaymentBatchUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSavePaymentBatchUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUnappliedMcnForPayor(body?: PaymentsBatchRequestDto | undefined): Observable<McnLookupResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimpayment/payor-mcn/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnappliedMcnForPayor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnappliedMcnForPayor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<McnLookupResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<McnLookupResponseDtoGridResponseBase>;
        }));
    }

    protected processGetUnappliedMcnForPayor(response: HttpResponseBase): Observable<McnLookupResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = McnLookupResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePendingPayments(body?: PendingPaymentsDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/pendingpayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePendingPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePendingPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSavePendingPayments(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPendingPayments(body?: PendingPaymentsRequestDto | undefined): Observable<ParticipantPendingPayment> {
        let url_ = this.baseUrl + "/api/claimpayment/pendingpayments/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantPendingPayment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantPendingPayment>;
        }));
    }

    protected processGetPendingPayments(response: HttpResponseBase): Observable<ParticipantPendingPayment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantPendingPayment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processPaymentReclassify(body?: PaymentReclassifyRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimpayment/reclassify/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessPaymentReclassify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessPaymentReclassify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processProcessPaymentReclassify(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeMultiplePayments(body?: MultiplePaymentsForLcnDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/claimpayment/removemultiplepayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMultiplePayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMultiplePayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemoveMultiplePayments(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUnappliedPaymentDetailsByMcnId(mcnId: number, payorId: string): Observable<UnappliedPaymentSummaryDetails> {
        let url_ = this.baseUrl + "/api/claimpayment/unappliedpayment/{mcnId}/payor/{payorId}/details";
        if (mcnId === undefined || mcnId === null)
            throw new Error("The parameter 'mcnId' must be defined.");
        url_ = url_.replace("{mcnId}", encodeURIComponent("" + mcnId));
        if (payorId === undefined || payorId === null)
            throw new Error("The parameter 'payorId' must be defined.");
        url_ = url_.replace("{payorId}", encodeURIComponent("" + payorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnappliedPaymentDetailsByMcnId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnappliedPaymentDetailsByMcnId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnappliedPaymentSummaryDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnappliedPaymentSummaryDetails>;
        }));
    }

    protected processGetUnappliedPaymentDetailsByMcnId(response: HttpResponseBase): Observable<UnappliedPaymentSummaryDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnappliedPaymentSummaryDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitCCNData(body?: BatchReason | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimsbatch/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitCCNData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitCCNData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSubmitCCNData(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createClaimsProgramConfig(body?: ClaimsProgramConfigRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClaimsProgramConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClaimsProgramConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateClaimsProgramConfig(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClaimsProgramConfig(body?: ClaimsProgramConfigRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClaimsProgramConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClaimsProgramConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateClaimsProgramConfig(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteClaimsProgramConfig(body?: number[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClaimsProgramConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClaimsProgramConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteClaimsProgramConfig(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkProgramConfig(body?: number[] | undefined): Observable<ProgramTemplateMappingResponse> {
        let url_ = this.baseUrl + "/api/claimsProgramConfig-Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckProgramConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProgramConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramTemplateMappingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramTemplateMappingResponse>;
        }));
    }

    protected processCheckProgramConfig(response: HttpResponseBase): Observable<ProgramTemplateMappingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramTemplateMappingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return Success
     */
    getById(idPath: string, idQuery?: number | undefined): Observable<ClaimsProgramConfigurationResponseDto> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimsProgramConfigurationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimsProgramConfigurationResponseDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ClaimsProgramConfigurationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimsProgramConfigurationResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllClaimsCreationTypes(): Observable<ClaimCreationTypeResponse[]> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig/claimscreationtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClaimsCreationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClaimsCreationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimCreationTypeResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimCreationTypeResponse[]>;
        }));
    }

    protected processGetAllClaimsCreationTypes(response: HttpResponseBase): Observable<ClaimCreationTypeResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimCreationTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportAllProgramConfig(): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAllProgramConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAllProgramConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportAllProgramConfig(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportClaimsProgramConfig(id: number): Observable<FileResultDto> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig/export/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportClaimsProgramConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportClaimsProgramConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResultDto>;
        }));
    }

    protected processExportClaimsProgramConfig(response: HttpResponseBase): Observable<FileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(body?: CustomFilterRequest | undefined): Observable<ClaimsProgramConfigResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimsProgramConfigResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimsProgramConfigResponseDtoGridResponseBase>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClaimsProgramConfigResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimsProgramConfigResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProgramConfigurationByProgram(payorId: number, body?: ClaimsProgramConfigFilterRequest | undefined): Observable<ProgramConfigurationResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimsprogramconfig/program/{payorId}";
        if (payorId === undefined || payorId === null)
            throw new Error("The parameter 'payorId' must be defined.");
        url_ = url_.replace("{payorId}", encodeURIComponent("" + payorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramConfigurationByProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramConfigurationByProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramConfigurationResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramConfigurationResponseDtoGridResponseBase>;
        }));
    }

    protected processGetProgramConfigurationByProgram(response: HttpResponseBase): Observable<ProgramConfigurationResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramConfigurationResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveClaimsWriteOff(body?: SaveClaimsWriteOffRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimswriteoff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveClaimsWriteOff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveClaimsWriteOff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveClaimsWriteOff(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportBulkWriteOff(body?: BulkWriteOffSearchRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimswriteoff/bulk/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBulkWriteOff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBulkWriteOff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportBulkWriteOff(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllClaimsBulkWriteOffDetails(body?: BulkWriteOffSearchRequestDto | undefined): Observable<BulkWriteOffGridDataDtoBulkWriteOffGridResponse> {
        let url_ = this.baseUrl + "/api/claimswriteoff/bulk/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClaimsBulkWriteOffDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClaimsBulkWriteOffDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkWriteOffGridDataDtoBulkWriteOffGridResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkWriteOffGridDataDtoBulkWriteOffGridResponse>;
        }));
    }

    protected processGetAllClaimsBulkWriteOffDetails(response: HttpResponseBase): Observable<BulkWriteOffGridDataDtoBulkWriteOffGridResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkWriteOffGridDataDtoBulkWriteOffGridResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBulkWriteOffBatch(body?: BulkWriteOffCreateBatchRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/claimswriteoff/bulk/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBulkWriteOffBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBulkWriteOffBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateBulkWriteOffBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllWriteOffByCcn(body?: ClaimDetailFlyoutRequest | undefined): Observable<WriteOffResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/claimswriteoff/details/ccn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWriteOffByCcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWriteOffByCcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffResponseGridResponseBase>;
        }));
    }

    protected processGetAllWriteOffByCcn(response: HttpResponseBase): Observable<WriteOffResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WriteOffResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllWriteOffCauseByBatchCcn(body?: ClaimsWriteOffDto | undefined): Observable<ClaimsWriteOffDto[]> {
        let url_ = this.baseUrl + "/api/claimswriteoff/writeoffcauses/batch/ccn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWriteOffCauseByBatchCcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWriteOffCauseByBatchCcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimsWriteOffDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimsWriteOffDto[]>;
        }));
    }

    protected processGetAllWriteOffCauseByBatchCcn(response: HttpResponseBase): Observable<ClaimsWriteOffDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimsWriteOffDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateClaimTemplate(body?: ClaimTemplateRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ClaimTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateClaimTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateClaimTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateClaimTemplate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return Success
     */
    getClaimTemplateById(idPath: string, idQuery?: number | undefined): Observable<ClaimTemplateResponseByIdDto> {
        let url_ = this.baseUrl + "/api/ClaimTemplate/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaimTemplateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaimTemplateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimTemplateResponseByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimTemplateResponseByIdDto>;
        }));
    }

    protected processGetClaimTemplateById(response: HttpResponseBase): Observable<ClaimTemplateResponseByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimTemplateResponseByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idsQuery (optional) 
     * @return Success
     */
    deleteClaimTemplate(idsPath: string, idsQuery?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ClaimTemplate/{ids}?";
        if (idsPath === undefined || idsPath === null)
            throw new Error("The parameter 'idsPath' must be defined.");
        url_ = url_.replace("{ids}", encodeURIComponent("" + idsPath));
        if (idsQuery === null)
            throw new Error("The parameter 'idsQuery' cannot be null.");
        else if (idsQuery !== undefined)
            url_ += "ids=" + encodeURIComponent("" + idsQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClaimTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClaimTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteClaimTemplate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportClaimTemplate(body?: ClaimTemplateSearchRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ClaimTemplate/batch/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportClaimTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportClaimTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportClaimTemplate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllBcnByFilter(body?: BatchFilterRequest | undefined): Observable<BCNByClaimTemplateResponseDtoBcnGridResponse> {
        let url_ = this.baseUrl + "/api/ClaimTemplate/batch/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBcnByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBcnByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BCNByClaimTemplateResponseDtoBcnGridResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BCNByClaimTemplateResponseDtoBcnGridResponse>;
        }));
    }

    protected processGetAllBcnByFilter(response: HttpResponseBase): Observable<BCNByClaimTemplateResponseDtoBcnGridResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BCNByClaimTemplateResponseDtoBcnGridResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportClaimTemplates(body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ClaimTemplate/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportClaimTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportClaimTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportClaimTemplates(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllClaimTemplate(body?: CustomFilterRequest | undefined): Observable<ClaimTemplateResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/ClaimTemplate/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClaimTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClaimTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimTemplateResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimTemplateResponseDtoGridResponseBase>;
        }));
    }

    protected processGetAllClaimTemplate(response: HttpResponseBase): Observable<ClaimTemplateResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimTemplateResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMBCCNBatch(body?: MbccnCreateRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ClaimTemplate/mbccnbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMBCCNBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMBCCNBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateMBCCNBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGroupCodes(body?: CodesRequestDto | undefined): Observable<GroupCodeResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/GroupCodes/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroupCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroupCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupCodeResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupCodeResponseDtoGridResponseBase>;
        }));
    }

    protected processGetAllGroupCodes(response: HttpResponseBase): Observable<GroupCodeResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupCodeResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addManualClaims(body?: AddManualClaimRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ManualClaim/addmanualclaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processAddManualClaims(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createManualClaims(body?: CreateManualClaimsRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ManualClaim/createmanualclaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateManualClaims(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteManualClaims(body?: DeleteManualClaimRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ManualClaim/deletemanualclaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteManualClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteManualClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteManualClaims(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getManualClaimsGridData(body?: CustomGridFilterRequest | undefined): Observable<ManualClaimsDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/ManualClaim/getmanualclaimsgriddata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualClaimsGridData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualClaimsGridData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualClaimsDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualClaimsDtoGridResponseBase>;
        }));
    }

    protected processGetManualClaimsGridData(response: HttpResponseBase): Observable<ManualClaimsDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualClaimsDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateManualClaims(body?: UpdateManualClaimRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ManualClaim/updatemanualclaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateManualClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateManualClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateManualClaims(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMcnWriteOff(body?: SaveMcnWriteOffRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/mcnwriteoff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMcnWriteOff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMcnWriteOff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveMcnWriteOff(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCoPay(participantPersonId: string): Observable<CoPayListResponse> {
        let url_ = this.baseUrl + "/api/participant/copay/{participantPersonId}";
        if (participantPersonId === undefined || participantPersonId === null)
            throw new Error("The parameter 'participantPersonId' must be defined.");
        url_ = url_.replace("{participantPersonId}", encodeURIComponent("" + participantPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoPayListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoPayListResponse>;
        }));
    }

    protected processGetAllCoPay(response: HttpResponseBase): Observable<CoPayListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoPayListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCoPay(body?: number[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/participant/copay/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCoPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCoPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteCoPay(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getHistoryCoPay(body?: CoPayHistoryRequest | undefined): Observable<CoPayHistoryResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/participant/copay/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoryCoPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoryCoPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoPayHistoryResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoPayHistoryResponseGridResponseBase>;
        }));
    }

    protected processGetHistoryCoPay(response: HttpResponseBase): Observable<CoPayHistoryResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoPayHistoryResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertParticipantCopay(body?: CoPayListRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/participant/copay/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertParticipantCopay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertParticipantCopay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertParticipantCopay(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportSummaryMcn(body?: CcnExcelExportRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payment/unappliedpaymentsummary/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSummaryMcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSummaryMcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportSummaryMcn(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllUnappliedPaymentSummary(body?: UnappliedPaymentSummaryRequest | undefined): Observable<UnappliedPaymentSummaryDetailsUnappliedPaymentSummary> {
        let url_ = this.baseUrl + "/api/payment/unappliedpaymentsummary/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnappliedPaymentSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnappliedPaymentSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnappliedPaymentSummaryDetailsUnappliedPaymentSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnappliedPaymentSummaryDetailsUnappliedPaymentSummary>;
        }));
    }

    protected processGetAllUnappliedPaymentSummary(response: HttpResponseBase): Observable<UnappliedPaymentSummaryDetailsUnappliedPaymentSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnappliedPaymentSummaryDetailsUnappliedPaymentSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateProgramEdiConfig(body?: ProgramEDIConfigRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ProgramEdiConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateProgramEdiConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateProgramEdiConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateProgramEdiConfig(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProgramEdi(body?: number[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ProgramEdiConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProgramEdi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProgramEdi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteProgramEdi(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProgramEdiConfigurationById(id: number): Observable<ProgramEdiConfigurationResponseByIdDto> {
        let url_ = this.baseUrl + "/api/ProgramEdiConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramEdiConfigurationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramEdiConfigurationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramEdiConfigurationResponseByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramEdiConfigurationResponseByIdDto>;
        }));
    }

    protected processGetProgramEdiConfigurationById(response: HttpResponseBase): Observable<ProgramEdiConfigurationResponseByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramEdiConfigurationResponseByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportProgramEdi(id: number): Observable<FileResultDto> {
        let url_ = this.baseUrl + "/api/ProgramEdiConfig/export/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProgramEdi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProgramEdi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResultDto>;
        }));
    }

    protected processExportProgramEdi(response: HttpResponseBase): Observable<FileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllProgramEdiConfiguration(body?: EdiConfigurationFilterRequest | undefined): Observable<ProgramEdiConfigurationResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/ProgramEdiConfig/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProgramEdiConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProgramEdiConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramEdiConfigurationResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramEdiConfigurationResponseDtoGridResponseBase>;
        }));
    }

    protected processGetAllProgramEdiConfiguration(response: HttpResponseBase): Observable<ProgramEdiConfigurationResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramEdiConfigurationResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertRemarkCode(body?: RemarkCodeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/remarkcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertRemarkCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertRemarkCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertRemarkCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRemarkCodes(body?: number[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/remarkcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRemarkCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRemarkCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteRemarkCodes(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    exportRemarkCodes(body?: CustomFilterRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/remarkcode/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRemarkCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRemarkCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportRemarkCodes(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRemarkCodes(body?: RemarkCodeRequestDto | undefined): Observable<RemarkCodeDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/remarkcodes/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemarkCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemarkCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemarkCodeDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemarkCodeDtoGridResponseBase>;
        }));
    }

    protected processGetRemarkCodes(response: HttpResponseBase): Observable<RemarkCodeDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemarkCodeDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getServCodeDetailsByTCN(body?: GetServCodeDetailsByTcnRequest | undefined): Observable<StringGridResponseBase> {
        let url_ = this.baseUrl + "/api/servCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServCodeDetailsByTCN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServCodeDetailsByTCN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringGridResponseBase>;
        }));
    }

    protected processGetServCodeDetailsByTCN(response: HttpResponseBase): Observable<StringGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param typeQuery (optional) 
     * @return Success
     */
    downloadSampleShiftTemplate(typePath: string, typeQuery?: number | undefined): Observable<FileResultDto> {
        let url_ = this.baseUrl + "/api/ShiftInjector/downloadsample/{type}?";
        if (typePath === undefined || typePath === null)
            throw new Error("The parameter 'typePath' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + typePath));
        if (typeQuery === null)
            throw new Error("The parameter 'typeQuery' cannot be null.");
        else if (typeQuery !== undefined)
            url_ += "type=" + encodeURIComponent("" + typeQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSampleShiftTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSampleShiftTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResultDto>;
        }));
    }

    protected processDownloadSampleShiftTemplate(response: HttpResponseBase): Observable<FileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param typeQuery (optional) 
     * @return Success
     */
    uploadShifts(typePath: string, typeQuery?: number | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ShiftInjector/uploadshift/{type}?";
        if (typePath === undefined || typePath === null)
            throw new Error("The parameter 'typePath' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + typePath));
        if (typeQuery === null)
            throw new Error("The parameter 'typeQuery' cannot be null.");
        else if (typeQuery !== undefined)
            url_ += "type=" + encodeURIComponent("" + typeQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUploadShifts(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSyncStatus(body?: UpdateBillingSyncDto[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/SyncStatus/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSyncStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSyncStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateSyncStatus(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    systemUsagesGet(): Observable<SystemUsageDto[]> {
        let url_ = this.baseUrl + "/api/systemusages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSystemUsagesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSystemUsagesGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemUsageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemUsageDto[]>;
        }));
    }

    protected processSystemUsagesGet(response: HttpResponseBase): Observable<SystemUsageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemUsageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportTransactionLog(body?: AgreementLogHeaderRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/transactionlog/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTransactionLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTransactionLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportTransactionLog(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMcnHistoryById(mcnId: number): Observable<McnStatusStatusHistoryGridResponseBase> {
        let url_ = this.baseUrl + "/api/unappliedpayment/mcn/{mcnId}/history";
        if (mcnId === undefined || mcnId === null)
            throw new Error("The parameter 'mcnId' must be defined.");
        url_ = url_.replace("{mcnId}", encodeURIComponent("" + mcnId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMcnHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMcnHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<McnStatusStatusHistoryGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<McnStatusStatusHistoryGridResponseBase>;
        }));
    }

    protected processGetMcnHistoryById(response: HttpResponseBase): Observable<McnStatusStatusHistoryGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = McnStatusStatusHistoryGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchIdQuery (optional) 
     * @return Success
     */
    getMcnIdByBatchId(batchIdPath: string, batchIdQuery?: string | undefined): Observable<McnIdResponse> {
        let url_ = this.baseUrl + "/api/unappliedpayment/mcnId/{batchId}?";
        if (batchIdPath === undefined || batchIdPath === null)
            throw new Error("The parameter 'batchIdPath' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchIdPath));
        if (batchIdQuery === null)
            throw new Error("The parameter 'batchIdQuery' cannot be null.");
        else if (batchIdQuery !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMcnIdByBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMcnIdByBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<McnIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<McnIdResponse>;
        }));
    }

    protected processGetMcnIdByBatchId(response: HttpResponseBase): Observable<McnIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = McnIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param onlyActive (optional) 
     * @param searchParameter (optional) 
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param filterColumn (optional) 
     * @param filterValue (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getAllWriteOffErrorTypes(onlyActive?: boolean | undefined, searchParameter?: string | undefined, sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined): Observable<WriteOffErrorTypeResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/writeofferrortype?";
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        if (searchParameter === null)
            throw new Error("The parameter 'searchParameter' cannot be null.");
        else if (searchParameter !== undefined)
            url_ += "SearchParameter=" + encodeURIComponent("" + searchParameter) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWriteOffErrorTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWriteOffErrorTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffErrorTypeResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffErrorTypeResponseDtoGridResponseBase>;
        }));
    }

    protected processGetAllWriteOffErrorTypes(response: HttpResponseBase): Observable<WriteOffErrorTypeResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WriteOffErrorTypeResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWriteOffErrorType(body?: WriteOffErrorTypeRequestDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/writeofferrortype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWriteOffErrorType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWriteOffErrorType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateWriteOffErrorType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param writeoffErrorTypeId (optional) 
     * @return Success
     */
    deleteWriteOffErrorType(writeoffErrorTypeId?: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/writeofferrortype?";
        if (writeoffErrorTypeId === null)
            throw new Error("The parameter 'writeoffErrorTypeId' cannot be null.");
        else if (writeoffErrorTypeId !== undefined)
            url_ += "writeoffErrorTypeId=" + encodeURIComponent("" + writeoffErrorTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWriteOffErrorType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWriteOffErrorType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteWriteOffErrorType(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportWriteOffErrorType(): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/writeofferrortype/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportWriteOffErrorType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportWriteOffErrorType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportWriteOffErrorType(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWriteOffErrorTypeById(id: number): Observable<WriteOffErrorTypeByIdResponseDto> {
        let url_ = this.baseUrl + "/api/writeofferrortype/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWriteOffErrorTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteOffErrorTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffErrorTypeByIdResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffErrorTypeByIdResponseDto>;
        }));
    }

    protected processGetWriteOffErrorTypeById(response: HttpResponseBase): Observable<WriteOffErrorTypeByIdResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WriteOffErrorTypeByIdResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddManualClaimRequest implements IAddManualClaimRequest {
    payorId?: string | undefined;
    programId?: string | undefined;
    participantId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    billCode?: string | undefined;
    authCode?: string | undefined;
    serviceCode?: string | undefined;
    billUnit?: number;
    billAmount?: number;
    submitterDetail?: SubmitterDetails[] | undefined;
    receiverDetail?: ReceiverDetails[] | undefined;
    billingProviderDetail?: BillingProvider[] | undefined;
    subscriberDetailInfo?: ClaimBatchSubscriberDetail[] | undefined;
    payorInfo?: PayorInfo[] | undefined;
    billingAreaInfo?: BillingAreaInfo[] | undefined;
    billCodeDetailsInfo?: BillCodeDetail[] | undefined;
    placeOfService?: number | undefined;
    revenueCode?: string | undefined;
    diagCode?: string | undefined;
    batchNumber?: string | undefined;

    constructor(data?: IAddManualClaimRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.participantId = _data["participantId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.billCode = _data["billCode"];
            this.authCode = _data["authCode"];
            this.serviceCode = _data["serviceCode"];
            this.billUnit = _data["billUnit"];
            this.billAmount = _data["billAmount"];
            if (Array.isArray(_data["submitterDetail"])) {
                this.submitterDetail = [] as any;
                for (let item of _data["submitterDetail"])
                    this.submitterDetail!.push(SubmitterDetails.fromJS(item));
            }
            if (Array.isArray(_data["receiverDetail"])) {
                this.receiverDetail = [] as any;
                for (let item of _data["receiverDetail"])
                    this.receiverDetail!.push(ReceiverDetails.fromJS(item));
            }
            if (Array.isArray(_data["billingProviderDetail"])) {
                this.billingProviderDetail = [] as any;
                for (let item of _data["billingProviderDetail"])
                    this.billingProviderDetail!.push(BillingProvider.fromJS(item));
            }
            if (Array.isArray(_data["subscriberDetailInfo"])) {
                this.subscriberDetailInfo = [] as any;
                for (let item of _data["subscriberDetailInfo"])
                    this.subscriberDetailInfo!.push(ClaimBatchSubscriberDetail.fromJS(item));
            }
            if (Array.isArray(_data["payorInfo"])) {
                this.payorInfo = [] as any;
                for (let item of _data["payorInfo"])
                    this.payorInfo!.push(PayorInfo.fromJS(item));
            }
            if (Array.isArray(_data["billingAreaInfo"])) {
                this.billingAreaInfo = [] as any;
                for (let item of _data["billingAreaInfo"])
                    this.billingAreaInfo!.push(BillingAreaInfo.fromJS(item));
            }
            if (Array.isArray(_data["billCodeDetailsInfo"])) {
                this.billCodeDetailsInfo = [] as any;
                for (let item of _data["billCodeDetailsInfo"])
                    this.billCodeDetailsInfo!.push(BillCodeDetail.fromJS(item));
            }
            this.placeOfService = _data["placeOfService"];
            this.revenueCode = _data["revenueCode"];
            this.diagCode = _data["diagCode"];
            this.batchNumber = _data["batchNumber"];
        }
    }

    static fromJS(data: any): AddManualClaimRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddManualClaimRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["participantId"] = this.participantId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["billCode"] = this.billCode;
        data["authCode"] = this.authCode;
        data["serviceCode"] = this.serviceCode;
        data["billUnit"] = this.billUnit;
        data["billAmount"] = this.billAmount;
        if (Array.isArray(this.submitterDetail)) {
            data["submitterDetail"] = [];
            for (let item of this.submitterDetail)
                data["submitterDetail"].push(item.toJSON());
        }
        if (Array.isArray(this.receiverDetail)) {
            data["receiverDetail"] = [];
            for (let item of this.receiverDetail)
                data["receiverDetail"].push(item.toJSON());
        }
        if (Array.isArray(this.billingProviderDetail)) {
            data["billingProviderDetail"] = [];
            for (let item of this.billingProviderDetail)
                data["billingProviderDetail"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriberDetailInfo)) {
            data["subscriberDetailInfo"] = [];
            for (let item of this.subscriberDetailInfo)
                data["subscriberDetailInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.payorInfo)) {
            data["payorInfo"] = [];
            for (let item of this.payorInfo)
                data["payorInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.billingAreaInfo)) {
            data["billingAreaInfo"] = [];
            for (let item of this.billingAreaInfo)
                data["billingAreaInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.billCodeDetailsInfo)) {
            data["billCodeDetailsInfo"] = [];
            for (let item of this.billCodeDetailsInfo)
                data["billCodeDetailsInfo"].push(item.toJSON());
        }
        data["placeOfService"] = this.placeOfService;
        data["revenueCode"] = this.revenueCode;
        data["diagCode"] = this.diagCode;
        data["batchNumber"] = this.batchNumber;
        return data;
    }
}

export interface IAddManualClaimRequest {
    payorId?: string | undefined;
    programId?: string | undefined;
    participantId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    billCode?: string | undefined;
    authCode?: string | undefined;
    serviceCode?: string | undefined;
    billUnit?: number;
    billAmount?: number;
    submitterDetail?: SubmitterDetails[] | undefined;
    receiverDetail?: ReceiverDetails[] | undefined;
    billingProviderDetail?: BillingProvider[] | undefined;
    subscriberDetailInfo?: ClaimBatchSubscriberDetail[] | undefined;
    payorInfo?: PayorInfo[] | undefined;
    billingAreaInfo?: BillingAreaInfo[] | undefined;
    billCodeDetailsInfo?: BillCodeDetail[] | undefined;
    placeOfService?: number | undefined;
    revenueCode?: string | undefined;
    diagCode?: string | undefined;
    batchNumber?: string | undefined;
}

export class AdjustmentClaimsPublishRequest implements IAdjustmentClaimsPublishRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    batchId?: string;
    ccn?: string | undefined;
    removeShift?: boolean;
    adjustedShift?: boolean;
    payor?: string | undefined;
    userMail?: string | undefined;
    companyId?: number;
    companyCodeInfo?: string | undefined;

    constructor(data?: IAdjustmentClaimsPublishRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.servCode = _data["servCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.batchId = _data["batchId"];
            this.ccn = _data["ccn"];
            this.removeShift = _data["removeShift"];
            this.adjustedShift = _data["adjustedShift"];
            this.payor = _data["payor"];
            this.userMail = _data["userMail"];
            this.companyId = _data["companyId"];
            this.companyCodeInfo = _data["companyCodeInfo"];
        }
    }

    static fromJS(data: any): AdjustmentClaimsPublishRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentClaimsPublishRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["servCode"] = this.servCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["batchId"] = this.batchId;
        data["ccn"] = this.ccn;
        data["removeShift"] = this.removeShift;
        data["adjustedShift"] = this.adjustedShift;
        data["payor"] = this.payor;
        data["userMail"] = this.userMail;
        data["companyId"] = this.companyId;
        data["companyCodeInfo"] = this.companyCodeInfo;
        return data;
    }
}

export interface IAdjustmentClaimsPublishRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    batchId?: string;
    ccn?: string | undefined;
    removeShift?: boolean;
    adjustedShift?: boolean;
    payor?: string | undefined;
    userMail?: string | undefined;
    companyId?: number;
    companyCodeInfo?: string | undefined;
}

export class AdjustmentCodeDto implements IAdjustmentCodeDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    adjustmentCodeId?: number | undefined;
    adjustmentCode?: string | undefined;
    description?: string | undefined;
    status?: number;
    textValue?: string | undefined;

    constructor(data?: IAdjustmentCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.adjustmentCodeId = _data["adjustmentCodeId"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.textValue = _data["textValue"];
        }
    }

    static fromJS(data: any): AdjustmentCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["adjustmentCodeId"] = this.adjustmentCodeId;
        data["adjustmentCode"] = this.adjustmentCode;
        data["description"] = this.description;
        data["status"] = this.status;
        data["textValue"] = this.textValue;
        return data;
    }
}

export interface IAdjustmentCodeDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    adjustmentCodeId?: number | undefined;
    adjustmentCode?: string | undefined;
    description?: string | undefined;
    status?: number;
    textValue?: string | undefined;
}

export class AdjustmentCodeRequestDto implements IAdjustmentCodeRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    onlyActive?: number | undefined;

    constructor(data?: IAdjustmentCodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.searchParameter = _data["searchParameter"];
            this.onlyActive = _data["onlyActive"];
        }
    }

    static fromJS(data: any): AdjustmentCodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentCodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["searchParameter"] = this.searchParameter;
        data["onlyActive"] = this.onlyActive;
        return data;
    }
}

export interface IAdjustmentCodeRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    onlyActive?: number | undefined;
}

export class AdjustmentCodesResponseDto implements IAdjustmentCodesResponseDto {
    adjustmentCodeId?: number;
    adjustmentCode?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IAdjustmentCodesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adjustmentCodeId = _data["adjustmentCodeId"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdjustmentCodesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentCodesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustmentCodeId"] = this.adjustmentCodeId;
        data["adjustmentCode"] = this.adjustmentCode;
        data["description"] = this.description;
        data["status"] = this.status;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdjustmentCodesResponseDto {
    adjustmentCodeId?: number;
    adjustmentCode?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class AdjustmentCodesResponseDtoGridResponseBase implements IAdjustmentCodesResponseDtoGridResponseBase {
    items?: AdjustmentCodesResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: AdjustmentCodesResponseDto;

    constructor(data?: IAdjustmentCodesResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdjustmentCodesResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? AdjustmentCodesResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdjustmentCodesResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentCodesResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdjustmentCodesResponseDtoGridResponseBase {
    items?: AdjustmentCodesResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: AdjustmentCodesResponseDto;
}

export class AdjustmentNotes implements IAdjustmentNotes {
    tcn?: string | undefined;
    adjustmentType?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    note?: string | undefined;
    adjustmentReason?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;

    constructor(data?: IAdjustmentNotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcn = _data["tcn"];
            this.adjustmentType = _data["adjustmentType"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.note = _data["note"];
            this.adjustmentReason = _data["adjustmentReason"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): AdjustmentNotes {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentNotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcn"] = this.tcn;
        data["adjustmentType"] = this.adjustmentType;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["note"] = this.note;
        data["adjustmentReason"] = this.adjustmentReason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IAdjustmentNotes {
    tcn?: string | undefined;
    adjustmentType?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    note?: string | undefined;
    adjustmentReason?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
}

export class AdjustmentOptionUsageDto implements IAdjustmentOptionUsageDto {
    adjustmentOptionId?: number;
    adjustmentOption?: string | undefined;

    constructor(data?: IAdjustmentOptionUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adjustmentOptionId = _data["adjustmentOptionId"];
            this.adjustmentOption = _data["adjustmentOption"];
        }
    }

    static fromJS(data: any): AdjustmentOptionUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentOptionUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustmentOptionId"] = this.adjustmentOptionId;
        data["adjustmentOption"] = this.adjustmentOption;
        return data;
    }
}

export interface IAdjustmentOptionUsageDto {
    adjustmentOptionId?: number;
    adjustmentOption?: string | undefined;
}

export class AdjustmentProcessorDetailsDto implements IAdjustmentProcessorDetailsDto {
    id?: number;
    bcnID?: number;
    tcn?: string | undefined;
    serviceDate?: Date;
    inTime?: Date;
    outTime?: Date;
    payUnit?: number | undefined;
    payRate?: number | undefined;
    billRate?: number;
    billUnit?: number;
    servCode?: string | undefined;
    status?: number;
    billingRecordsStatus?: number;
    acn?: string | undefined;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    adjustmentProcessStatus?: string | undefined;
    pcnStatus?: PcnStatus;
    readonly pcnStatusText?: string | undefined;
    payDate?: Date | undefined;
    tcnSource?: string | undefined;
    bcnStatus?: boolean;
    createdBy?: string | undefined;
    payRateUnitMethod?: UnitMethod;
    billRateUnitMethod?: UnitMethod;
    comment?: string | undefined;
    validationError?: string | undefined;
    adjustments?: AdjustmentsEnum;
    companyId?: number;
    docType?: string | undefined;
    isAdjustment?: boolean | undefined;
    isRemoveTime?: boolean | undefined;
    adjustmentReasonId?: number;
    adjustmentReason?: string | undefined;
    adjustmentSource?: AdjustmentSourceEnum;
    transStatus?: number;

    constructor(data?: IAdjustmentProcessorDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bcnID = _data["bcnID"];
            this.tcn = _data["tcn"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.payUnit = _data["payUnit"];
            this.payRate = _data["payRate"];
            this.billRate = _data["billRate"];
            this.billUnit = _data["billUnit"];
            this.servCode = _data["servCode"];
            this.status = _data["status"];
            this.billingRecordsStatus = _data["billingRecordsStatus"];
            this.acn = _data["acn"];
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.adjustmentProcessStatus = _data["adjustmentProcessStatus"];
            this.pcnStatus = _data["pcnStatus"];
            (<any>this).pcnStatusText = _data["pcnStatusText"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.tcnSource = _data["tcnSource"];
            this.bcnStatus = _data["bcnStatus"];
            this.createdBy = _data["createdBy"];
            this.payRateUnitMethod = _data["payRateUnitMethod"];
            this.billRateUnitMethod = _data["billRateUnitMethod"];
            this.comment = _data["comment"];
            this.validationError = _data["validationError"];
            this.adjustments = _data["adjustments"];
            this.companyId = _data["companyId"];
            this.docType = _data["docType"];
            this.isAdjustment = _data["isAdjustment"];
            this.isRemoveTime = _data["isRemoveTime"];
            this.adjustmentReasonId = _data["adjustmentReasonId"];
            this.adjustmentReason = _data["adjustmentReason"];
            this.adjustmentSource = _data["adjustmentSource"];
            this.transStatus = _data["transStatus"];
        }
    }

    static fromJS(data: any): AdjustmentProcessorDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentProcessorDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bcnID"] = this.bcnID;
        data["tcn"] = this.tcn;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["payUnit"] = this.payUnit;
        data["payRate"] = this.payRate;
        data["billRate"] = this.billRate;
        data["billUnit"] = this.billUnit;
        data["servCode"] = this.servCode;
        data["status"] = this.status;
        data["billingRecordsStatus"] = this.billingRecordsStatus;
        data["acn"] = this.acn;
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["adjustmentProcessStatus"] = this.adjustmentProcessStatus;
        data["pcnStatus"] = this.pcnStatus;
        data["pcnStatusText"] = this.pcnStatusText;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["tcnSource"] = this.tcnSource;
        data["bcnStatus"] = this.bcnStatus;
        data["createdBy"] = this.createdBy;
        data["payRateUnitMethod"] = this.payRateUnitMethod;
        data["billRateUnitMethod"] = this.billRateUnitMethod;
        data["comment"] = this.comment;
        data["validationError"] = this.validationError;
        data["adjustments"] = this.adjustments;
        data["companyId"] = this.companyId;
        data["docType"] = this.docType;
        data["isAdjustment"] = this.isAdjustment;
        data["isRemoveTime"] = this.isRemoveTime;
        data["adjustmentReasonId"] = this.adjustmentReasonId;
        data["adjustmentReason"] = this.adjustmentReason;
        data["adjustmentSource"] = this.adjustmentSource;
        data["transStatus"] = this.transStatus;
        return data;
    }
}

export interface IAdjustmentProcessorDetailsDto {
    id?: number;
    bcnID?: number;
    tcn?: string | undefined;
    serviceDate?: Date;
    inTime?: Date;
    outTime?: Date;
    payUnit?: number | undefined;
    payRate?: number | undefined;
    billRate?: number;
    billUnit?: number;
    servCode?: string | undefined;
    status?: number;
    billingRecordsStatus?: number;
    acn?: string | undefined;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    adjustmentProcessStatus?: string | undefined;
    pcnStatus?: PcnStatus;
    pcnStatusText?: string | undefined;
    payDate?: Date | undefined;
    tcnSource?: string | undefined;
    bcnStatus?: boolean;
    createdBy?: string | undefined;
    payRateUnitMethod?: UnitMethod;
    billRateUnitMethod?: UnitMethod;
    comment?: string | undefined;
    validationError?: string | undefined;
    adjustments?: AdjustmentsEnum;
    companyId?: number;
    docType?: string | undefined;
    isAdjustment?: boolean | undefined;
    isRemoveTime?: boolean | undefined;
    adjustmentReasonId?: number;
    adjustmentReason?: string | undefined;
    adjustmentSource?: AdjustmentSourceEnum;
    transStatus?: number;
}

export class AdjustmentReasonRequest implements IAdjustmentReasonRequest {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    adjustmentReasonId?: number | undefined;
    adjustmentReason?: string | undefined;
    readonly adjustmentOptionMappings?: number[] | undefined;
    readonly systemUsageMappings?: number[] | undefined;
    isDeleted?: boolean;
    updatedByName?: string | undefined;

    constructor(data?: IAdjustmentReasonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.adjustmentReasonId = _data["adjustmentReasonId"];
            this.adjustmentReason = _data["adjustmentReason"];
            if (Array.isArray(_data["adjustmentOptionMappings"])) {
                (<any>this).adjustmentOptionMappings = [] as any;
                for (let item of _data["adjustmentOptionMappings"])
                    (<any>this).adjustmentOptionMappings!.push(item);
            }
            if (Array.isArray(_data["systemUsageMappings"])) {
                (<any>this).systemUsageMappings = [] as any;
                for (let item of _data["systemUsageMappings"])
                    (<any>this).systemUsageMappings!.push(item);
            }
            this.isDeleted = _data["isDeleted"];
            this.updatedByName = _data["updatedByName"];
        }
    }

    static fromJS(data: any): AdjustmentReasonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentReasonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["adjustmentReasonId"] = this.adjustmentReasonId;
        data["adjustmentReason"] = this.adjustmentReason;
        if (Array.isArray(this.adjustmentOptionMappings)) {
            data["adjustmentOptionMappings"] = [];
            for (let item of this.adjustmentOptionMappings)
                data["adjustmentOptionMappings"].push(item);
        }
        if (Array.isArray(this.systemUsageMappings)) {
            data["systemUsageMappings"] = [];
            for (let item of this.systemUsageMappings)
                data["systemUsageMappings"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["updatedByName"] = this.updatedByName;
        return data;
    }
}

export interface IAdjustmentReasonRequest {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    adjustmentReasonId?: number | undefined;
    adjustmentReason?: string | undefined;
    adjustmentOptionMappings?: number[] | undefined;
    systemUsageMappings?: number[] | undefined;
    isDeleted?: boolean;
    updatedByName?: string | undefined;
}

export class AdjustmentReasonUsageDto implements IAdjustmentReasonUsageDto {
    adjustmentOptionId?: number;
    adjustmentReasonId?: number;
    adjustmentReason?: string | undefined;

    constructor(data?: IAdjustmentReasonUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adjustmentOptionId = _data["adjustmentOptionId"];
            this.adjustmentReasonId = _data["adjustmentReasonId"];
            this.adjustmentReason = _data["adjustmentReason"];
        }
    }

    static fromJS(data: any): AdjustmentReasonUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentReasonUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustmentOptionId"] = this.adjustmentOptionId;
        data["adjustmentReasonId"] = this.adjustmentReasonId;
        data["adjustmentReason"] = this.adjustmentReason;
        return data;
    }
}

export interface IAdjustmentReasonUsageDto {
    adjustmentOptionId?: number;
    adjustmentReasonId?: number;
    adjustmentReason?: string | undefined;
}

export enum AdjustmentSourceEnum {
    U2 = "U2",
    V4 = "V4",
}

export enum AdjustmentsEnum {
    ACN = "ACN",
    BillRate = "BillRate",
    PayRate = "PayRate",
    ChangeTime = "ChangeTime",
    RemoveTime = "RemoveTime",
    ServiceCode = "ServiceCode",
    Hold = "Hold",
    Unhold = "Unhold",
    ServiceDate = "ServiceDate",
    RulesSkip = "RulesSkip",
}

export class AgreementLogHeaderRequest implements IAgreementLogHeaderRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    acn?: string | undefined;

    constructor(data?: IAgreementLogHeaderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : <any>undefined;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : <any>undefined;
            this.acn = _data["acn"];
        }
    }

    static fromJS(data: any): AgreementLogHeaderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementLogHeaderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : <any>undefined;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : <any>undefined;
        data["acn"] = this.acn;
        return data;
    }
}

export interface IAgreementLogHeaderRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    acn?: string | undefined;
}

export class AgreementLogResponse implements IAgreementLogResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caregiverId?: string | undefined;
    caregiverName?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
    timeIn?: Date;
    timeOut?: Date;
    payUnits?: number | undefined;
    billUnits?: number;
    billStatus?: number;
    billStatusText?: string | undefined;
    payStatus?: string | undefined;
    payRate?: number | undefined;
    payTotal?: number | undefined;
    billRate?: number | undefined;
    billTotal?: number;
    billCode?: string | undefined;
    recordId?: string | undefined;
    user?: string | undefined;
    lastUpdate?: Date | undefined;
    isPositive?: boolean;
    payDate?: Date | undefined;
    isAdjustment?: boolean;

    constructor(data?: IAgreementLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverName = _data["caregiverName"];
            this.servCode = _data["servCode"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
            this.timeIn = _data["timeIn"] ? new Date(_data["timeIn"].toString()) : <any>undefined;
            this.timeOut = _data["timeOut"] ? new Date(_data["timeOut"].toString()) : <any>undefined;
            this.payUnits = _data["payUnits"];
            this.billUnits = _data["billUnits"];
            this.billStatus = _data["billStatus"];
            this.billStatusText = _data["billStatusText"];
            this.payStatus = _data["payStatus"];
            this.payRate = _data["payRate"];
            this.payTotal = _data["payTotal"];
            this.billRate = _data["billRate"];
            this.billTotal = _data["billTotal"];
            this.billCode = _data["billCode"];
            this.recordId = _data["recordId"];
            this.user = _data["user"];
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.isPositive = _data["isPositive"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.isAdjustment = _data["isAdjustment"];
        }
    }

    static fromJS(data: any): AgreementLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["caregiverId"] = this.caregiverId;
        data["caregiverName"] = this.caregiverName;
        data["servCode"] = this.servCode;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : <any>undefined;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : <any>undefined;
        data["payUnits"] = this.payUnits;
        data["billUnits"] = this.billUnits;
        data["billStatus"] = this.billStatus;
        data["billStatusText"] = this.billStatusText;
        data["payStatus"] = this.payStatus;
        data["payRate"] = this.payRate;
        data["payTotal"] = this.payTotal;
        data["billRate"] = this.billRate;
        data["billTotal"] = this.billTotal;
        data["billCode"] = this.billCode;
        data["recordId"] = this.recordId;
        data["user"] = this.user;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["isPositive"] = this.isPositive;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["isAdjustment"] = this.isAdjustment;
        return data;
    }
}

export interface IAgreementLogResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caregiverId?: string | undefined;
    caregiverName?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
    timeIn?: Date;
    timeOut?: Date;
    payUnits?: number | undefined;
    billUnits?: number;
    billStatus?: number;
    billStatusText?: string | undefined;
    payStatus?: string | undefined;
    payRate?: number | undefined;
    payTotal?: number | undefined;
    billRate?: number | undefined;
    billTotal?: number;
    billCode?: string | undefined;
    recordId?: string | undefined;
    user?: string | undefined;
    lastUpdate?: Date | undefined;
    isPositive?: boolean;
    payDate?: Date | undefined;
    isAdjustment?: boolean;
}

export class AgreementLogResponseGridResponseBase implements IAgreementLogResponseGridResponseBase {
    items?: AgreementLogResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: AgreementLogResponse;

    constructor(data?: IAgreementLogResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgreementLogResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? AgreementLogResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AgreementLogResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementLogResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgreementLogResponseGridResponseBase {
    items?: AgreementLogResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: AgreementLogResponse;
}

export class AgreementLogSummary implements IAgreementLogSummary {
    payUnitSummary?: number | undefined;
    billUnitSummary?: number | undefined;
    payTotalSummary?: number | undefined;
    billTotalSummary?: number | undefined;
    agreementLogResponse?: AgreementLogResponseGridResponseBase;

    constructor(data?: IAgreementLogSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payUnitSummary = _data["payUnitSummary"];
            this.billUnitSummary = _data["billUnitSummary"];
            this.payTotalSummary = _data["payTotalSummary"];
            this.billTotalSummary = _data["billTotalSummary"];
            this.agreementLogResponse = _data["agreementLogResponse"] ? AgreementLogResponseGridResponseBase.fromJS(_data["agreementLogResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AgreementLogSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementLogSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payUnitSummary"] = this.payUnitSummary;
        data["billUnitSummary"] = this.billUnitSummary;
        data["payTotalSummary"] = this.payTotalSummary;
        data["billTotalSummary"] = this.billTotalSummary;
        data["agreementLogResponse"] = this.agreementLogResponse ? this.agreementLogResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgreementLogSummary {
    payUnitSummary?: number | undefined;
    billUnitSummary?: number | undefined;
    payTotalSummary?: number | undefined;
    billTotalSummary?: number | undefined;
    agreementLogResponse?: AgreementLogResponseGridResponseBase;
}

export class ApplicationQueryReversalRequestDto implements IApplicationQueryReversalRequestDto {
    participantId?: string | undefined;
    mcn?: string | undefined;
    batchNumber?: string | undefined;
    companyId?: number;
    showPaidClaims?: boolean;
    fromDate?: Date;
    toDate?: Date;

    constructor(data?: IApplicationQueryReversalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.mcn = _data["mcn"];
            this.batchNumber = _data["batchNumber"];
            this.companyId = _data["companyId"];
            this.showPaidClaims = _data["showPaidClaims"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationQueryReversalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationQueryReversalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["mcn"] = this.mcn;
        data["batchNumber"] = this.batchNumber;
        data["companyId"] = this.companyId;
        data["showPaidClaims"] = this.showPaidClaims;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApplicationQueryReversalRequestDto {
    participantId?: string | undefined;
    mcn?: string | undefined;
    batchNumber?: string | undefined;
    companyId?: number;
    showPaidClaims?: boolean;
    fromDate?: Date;
    toDate?: Date;
}

export class ApplicationQueryReversalResponseDto implements IApplicationQueryReversalResponseDto {
    items?: PaymentApplicationResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PaymentApplicationResponseDto;
    participantId?: string | undefined;
    mcnId?: number;
    mcnCode?: string | undefined;
    batchId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    participantName?: string | undefined;
    checkNumber?: string | undefined;
    checkDate?: Date | undefined;
    payor?: string | undefined;
    depRefNumber?: string | undefined;
    checkAmount?: number | undefined;
    originalAmount?: number | undefined;
    remainingAmount?: number | undefined;
    appliedAmount?: number | undefined;

    constructor(data?: IApplicationQueryReversalResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentApplicationResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PaymentApplicationResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.participantId = _data["participantId"];
            this.mcnId = _data["mcnId"];
            this.mcnCode = _data["mcnCode"];
            this.batchId = _data["batchId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.participantName = _data["participantName"];
            this.checkNumber = _data["checkNumber"];
            this.checkDate = _data["checkDate"] ? new Date(_data["checkDate"].toString()) : <any>undefined;
            this.payor = _data["payor"];
            this.depRefNumber = _data["depRefNumber"];
            this.checkAmount = _data["checkAmount"];
            this.originalAmount = _data["originalAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.appliedAmount = _data["appliedAmount"];
        }
    }

    static fromJS(data: any): ApplicationQueryReversalResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationQueryReversalResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["participantId"] = this.participantId;
        data["mcnId"] = this.mcnId;
        data["mcnCode"] = this.mcnCode;
        data["batchId"] = this.batchId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["participantName"] = this.participantName;
        data["checkNumber"] = this.checkNumber;
        data["checkDate"] = this.checkDate ? this.checkDate.toISOString() : <any>undefined;
        data["payor"] = this.payor;
        data["depRefNumber"] = this.depRefNumber;
        data["checkAmount"] = this.checkAmount;
        data["originalAmount"] = this.originalAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["appliedAmount"] = this.appliedAmount;
        return data;
    }
}

export interface IApplicationQueryReversalResponseDto {
    items?: PaymentApplicationResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PaymentApplicationResponseDto;
    participantId?: string | undefined;
    mcnId?: number;
    mcnCode?: string | undefined;
    batchId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    participantName?: string | undefined;
    checkNumber?: string | undefined;
    checkDate?: Date | undefined;
    payor?: string | undefined;
    depRefNumber?: string | undefined;
    checkAmount?: number | undefined;
    originalAmount?: number | undefined;
    remainingAmount?: number | undefined;
    appliedAmount?: number | undefined;
}

export class BCCNStatusStatusHistory implements IBCCNStatusStatusHistory {
    status?: number;
    timeStamp?: Date;
    userDetails?: string | undefined;
    readonly statusText?: string | undefined;

    constructor(data?: IBCCNStatusStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.userDetails = _data["userDetails"];
            (<any>this).statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): BCCNStatusStatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new BCCNStatusStatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["userDetails"] = this.userDetails;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IBCCNStatusStatusHistory {
    status?: number;
    timeStamp?: Date;
    userDetails?: string | undefined;
    statusText?: string | undefined;
}

export class BCCNStatusStatusHistoryGridResponseBase implements IBCCNStatusStatusHistoryGridResponseBase {
    items?: BCCNStatusStatusHistory[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BCCNStatusStatusHistory;

    constructor(data?: IBCCNStatusStatusHistoryGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BCCNStatusStatusHistory.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? BCCNStatusStatusHistory.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BCCNStatusStatusHistoryGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new BCCNStatusStatusHistoryGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBCCNStatusStatusHistoryGridResponseBase {
    items?: BCCNStatusStatusHistory[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BCCNStatusStatusHistory;
}

export class BCNByClaimTemplateResponseDto implements IBCNByClaimTemplateResponseDto {
    id?: number;
    bcn?: string | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    participantId?: string | undefined;
    participant?: string | undefined;
    caregiverNPI?: string | undefined;
    caregiverAPI?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    billCode?: string | undefined;
    serviceDate?: Date;
    payUnit?: number;
    billUnit?: number;
    billRate?: number;
    totalBillAmount?: number;
    isLocked?: boolean;

    constructor(data?: IBCNByClaimTemplateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bcn = _data["bcn"];
            this.payor = _data["payor"];
            this.program = _data["program"];
            this.participantId = _data["participantId"];
            this.participant = _data["participant"];
            this.caregiverNPI = _data["caregiverNPI"];
            this.caregiverAPI = _data["caregiverAPI"];
            this.authCode = _data["authCode"];
            this.servCode = _data["servCode"];
            this.billCode = _data["billCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.payUnit = _data["payUnit"];
            this.billUnit = _data["billUnit"];
            this.billRate = _data["billRate"];
            this.totalBillAmount = _data["totalBillAmount"];
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): BCNByClaimTemplateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BCNByClaimTemplateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bcn"] = this.bcn;
        data["payor"] = this.payor;
        data["program"] = this.program;
        data["participantId"] = this.participantId;
        data["participant"] = this.participant;
        data["caregiverNPI"] = this.caregiverNPI;
        data["caregiverAPI"] = this.caregiverAPI;
        data["authCode"] = this.authCode;
        data["servCode"] = this.servCode;
        data["billCode"] = this.billCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["payUnit"] = this.payUnit;
        data["billUnit"] = this.billUnit;
        data["billRate"] = this.billRate;
        data["totalBillAmount"] = this.totalBillAmount;
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IBCNByClaimTemplateResponseDto {
    id?: number;
    bcn?: string | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    participantId?: string | undefined;
    participant?: string | undefined;
    caregiverNPI?: string | undefined;
    caregiverAPI?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    billCode?: string | undefined;
    serviceDate?: Date;
    payUnit?: number;
    billUnit?: number;
    billRate?: number;
    totalBillAmount?: number;
    isLocked?: boolean;
}

export class BCNByClaimTemplateResponseDtoBcnGridResponse implements IBCNByClaimTemplateResponseDtoBcnGridResponse {
    items?: BCNByClaimTemplateResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BCNByClaimTemplateResponseDto;
    tileResultData?: BcnTileResult;
    searchTime?: Date;

    constructor(data?: IBCNByClaimTemplateResponseDtoBcnGridResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BCNByClaimTemplateResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? BCNByClaimTemplateResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.tileResultData = _data["tileResultData"] ? BcnTileResult.fromJS(_data["tileResultData"]) : <any>undefined;
            this.searchTime = _data["searchTime"] ? new Date(_data["searchTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BCNByClaimTemplateResponseDtoBcnGridResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BCNByClaimTemplateResponseDtoBcnGridResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["tileResultData"] = this.tileResultData ? this.tileResultData.toJSON() : <any>undefined;
        data["searchTime"] = this.searchTime ? this.searchTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBCNByClaimTemplateResponseDtoBcnGridResponse {
    items?: BCNByClaimTemplateResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BCNByClaimTemplateResponseDto;
    tileResultData?: BcnTileResult;
    searchTime?: Date;
}

export class BatchFilterRequest implements IBatchFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string | undefined;
    program?: string | undefined;
    timeOnly?: boolean;
    claimTypes?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    participantId?: string | undefined;
    authCode?: string | undefined;
    serviceCode?: ServiceCode[] | undefined;
    documentTypes?: string[] | undefined;
    cutoffDateTime?: Date | undefined;
    icn?: string | undefined;
    filteredParticipant?: string | undefined;
    programConfigurations?: ProgramConfigurationResponseDto[] | undefined;

    constructor(data?: IBatchFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.payor = _data["payor"];
            this.program = _data["program"];
            this.timeOnly = _data["timeOnly"];
            this.claimTypes = _data["claimTypes"];
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.participantId = _data["participantId"];
            this.authCode = _data["authCode"];
            if (Array.isArray(_data["serviceCode"])) {
                this.serviceCode = [] as any;
                for (let item of _data["serviceCode"])
                    this.serviceCode!.push(ServiceCode.fromJS(item));
            }
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            this.cutoffDateTime = _data["cutoffDateTime"] ? new Date(_data["cutoffDateTime"].toString()) : <any>undefined;
            this.icn = _data["icn"];
            this.filteredParticipant = _data["filteredParticipant"];
            if (Array.isArray(_data["programConfigurations"])) {
                this.programConfigurations = [] as any;
                for (let item of _data["programConfigurations"])
                    this.programConfigurations!.push(ProgramConfigurationResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["payor"] = this.payor;
        data["program"] = this.program;
        data["timeOnly"] = this.timeOnly;
        data["claimTypes"] = this.claimTypes;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["participantId"] = this.participantId;
        data["authCode"] = this.authCode;
        if (Array.isArray(this.serviceCode)) {
            data["serviceCode"] = [];
            for (let item of this.serviceCode)
                data["serviceCode"].push(item.toJSON());
        }
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        data["cutoffDateTime"] = this.cutoffDateTime ? this.cutoffDateTime.toISOString() : <any>undefined;
        data["icn"] = this.icn;
        data["filteredParticipant"] = this.filteredParticipant;
        if (Array.isArray(this.programConfigurations)) {
            data["programConfigurations"] = [];
            for (let item of this.programConfigurations)
                data["programConfigurations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string | undefined;
    program?: string | undefined;
    timeOnly?: boolean;
    claimTypes?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    participantId?: string | undefined;
    authCode?: string | undefined;
    serviceCode?: ServiceCode[] | undefined;
    documentTypes?: string[] | undefined;
    cutoffDateTime?: Date | undefined;
    icn?: string | undefined;
    filteredParticipant?: string | undefined;
    programConfigurations?: ProgramConfigurationResponseDto[] | undefined;
}

export class BatchLookupRequestDto implements IBatchLookupRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    batchStatus?: string[] | undefined;
    companyId?: number;
    payorId?: number | undefined;

    constructor(data?: IBatchLookupRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["batchStatus"])) {
                this.batchStatus = [] as any;
                for (let item of _data["batchStatus"])
                    this.batchStatus!.push(item);
            }
            this.companyId = _data["companyId"];
            this.payorId = _data["payorId"];
        }
    }

    static fromJS(data: any): BatchLookupRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLookupRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.batchStatus)) {
            data["batchStatus"] = [];
            for (let item of this.batchStatus)
                data["batchStatus"].push(item);
        }
        data["companyId"] = this.companyId;
        data["payorId"] = this.payorId;
        return data;
    }
}

export interface IBatchLookupRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    batchStatus?: string[] | undefined;
    companyId?: number;
    payorId?: number | undefined;
}

export class BatchLookupResponseDto implements IBatchLookupResponseDto {
    id?: number | undefined;
    batchId?: string | undefined;
    description?: string | undefined;

    constructor(data?: IBatchLookupResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.batchId = _data["batchId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BatchLookupResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLookupResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["batchId"] = this.batchId;
        data["description"] = this.description;
        return data;
    }
}

export interface IBatchLookupResponseDto {
    id?: number | undefined;
    batchId?: string | undefined;
    description?: string | undefined;
}

export class BatchLookupResponseDtoGridResponseBase implements IBatchLookupResponseDtoGridResponseBase {
    items?: BatchLookupResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BatchLookupResponseDto;

    constructor(data?: IBatchLookupResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BatchLookupResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? BatchLookupResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchLookupResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLookupResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchLookupResponseDtoGridResponseBase {
    items?: BatchLookupResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BatchLookupResponseDto;
}

export class BatchReason implements IBatchReason {
    batchId?: string | undefined;
    ids?: number[] | undefined;
    reason?: string | undefined;
    batchIds?: string[] | undefined;
    emailId?: string | undefined;
    companyCode?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IBatchReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.reason = _data["reason"];
            if (Array.isArray(_data["batchIds"])) {
                this.batchIds = [] as any;
                for (let item of _data["batchIds"])
                    this.batchIds!.push(item);
            }
            this.emailId = _data["emailId"];
            this.companyCode = _data["companyCode"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): BatchReason {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["reason"] = this.reason;
        if (Array.isArray(this.batchIds)) {
            data["batchIds"] = [];
            for (let item of this.batchIds)
                data["batchIds"].push(item);
        }
        data["emailId"] = this.emailId;
        data["companyCode"] = this.companyCode;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IBatchReason {
    batchId?: string | undefined;
    ids?: number[] | undefined;
    reason?: string | undefined;
    batchIds?: string[] | undefined;
    emailId?: string | undefined;
    companyCode?: string | undefined;
    fileName?: string | undefined;
}

export class BcnAdjustmentsFilterRequest implements IBcnAdjustmentsFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    batchId?: string;
    ccn?: string | undefined;
    removeShift?: boolean;
    adjustedShift?: boolean;
    payor?: string | undefined;

    constructor(data?: IBcnAdjustmentsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.servCode = _data["servCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.batchId = _data["batchId"];
            this.ccn = _data["ccn"];
            this.removeShift = _data["removeShift"];
            this.adjustedShift = _data["adjustedShift"];
            this.payor = _data["payor"];
        }
    }

    static fromJS(data: any): BcnAdjustmentsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BcnAdjustmentsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["servCode"] = this.servCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["batchId"] = this.batchId;
        data["ccn"] = this.ccn;
        data["removeShift"] = this.removeShift;
        data["adjustedShift"] = this.adjustedShift;
        data["payor"] = this.payor;
        return data;
    }
}

export interface IBcnAdjustmentsFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    batchId?: string;
    ccn?: string | undefined;
    removeShift?: boolean;
    adjustedShift?: boolean;
    payor?: string | undefined;
}

export class BcnAdjustmentsGridResponse implements IBcnAdjustmentsGridResponse {
    bcns?: BcnDetailsDto[] | undefined;
    error?: ResponseModel;

    constructor(data?: IBcnAdjustmentsGridResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bcns"])) {
                this.bcns = [] as any;
                for (let item of _data["bcns"])
                    this.bcns!.push(BcnDetailsDto.fromJS(item));
            }
            this.error = _data["error"] ? ResponseModel.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BcnAdjustmentsGridResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BcnAdjustmentsGridResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bcns)) {
            data["bcns"] = [];
            for (let item of this.bcns)
                data["bcns"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBcnAdjustmentsGridResponse {
    bcns?: BcnDetailsDto[] | undefined;
    error?: ResponseModel;
}

export class BcnDetailsDto implements IBcnDetailsDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    bcn?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    acn?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    serviceDate?: Date | undefined;
    inTime?: Date | undefined;
    outTime?: Date | undefined;
    calHrs?: number | undefined;
    diagCode?: string | undefined;
    billCode?: string | undefined;
    billAmount?: number | undefined;
    payrollAmount?: number | undefined;
    billUnit?: number | undefined;
    billRate?: number | undefined;
    payUnit?: number | undefined;
    payRate?: number | undefined;
    status?: number;
    tcn?: string | undefined;
    readonly statusText?: string | undefined;
    readonly pcnStatusText?: string | undefined;
    payDate?: Date | undefined;
    tcnSource?: string | undefined;
    bcnSubStatus?: number | undefined;
    ccn?: string | undefined;
    programCode?: string | undefined;
    pcnStatus?: PcnStatus;
    action?: string | undefined;
    removeShift?: boolean;
    adjustedShift?: boolean;
    positiveShift?: boolean;
    docType?: string | undefined;
    employer?: string | undefined;
    isLocked?: string | undefined;

    constructor(data?: IBcnDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.bcn = _data["bcn"];
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.acn = _data["acn"];
            this.authCode = _data["authCode"];
            this.servCode = _data["servCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.calHrs = _data["calHrs"];
            this.diagCode = _data["diagCode"];
            this.billCode = _data["billCode"];
            this.billAmount = _data["billAmount"];
            this.payrollAmount = _data["payrollAmount"];
            this.billUnit = _data["billUnit"];
            this.billRate = _data["billRate"];
            this.payUnit = _data["payUnit"];
            this.payRate = _data["payRate"];
            this.status = _data["status"];
            this.tcn = _data["tcn"];
            (<any>this).statusText = _data["statusText"];
            (<any>this).pcnStatusText = _data["pcnStatusText"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.tcnSource = _data["tcnSource"];
            this.bcnSubStatus = _data["bcnSubStatus"];
            this.ccn = _data["ccn"];
            this.programCode = _data["programCode"];
            this.pcnStatus = _data["pcnStatus"];
            this.action = _data["action"];
            this.removeShift = _data["removeShift"];
            this.adjustedShift = _data["adjustedShift"];
            this.positiveShift = _data["positiveShift"];
            this.docType = _data["docType"];
            this.employer = _data["employer"];
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): BcnDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BcnDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["bcn"] = this.bcn;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["acn"] = this.acn;
        data["authCode"] = this.authCode;
        data["servCode"] = this.servCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["calHrs"] = this.calHrs;
        data["diagCode"] = this.diagCode;
        data["billCode"] = this.billCode;
        data["billAmount"] = this.billAmount;
        data["payrollAmount"] = this.payrollAmount;
        data["billUnit"] = this.billUnit;
        data["billRate"] = this.billRate;
        data["payUnit"] = this.payUnit;
        data["payRate"] = this.payRate;
        data["status"] = this.status;
        data["tcn"] = this.tcn;
        data["statusText"] = this.statusText;
        data["pcnStatusText"] = this.pcnStatusText;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["tcnSource"] = this.tcnSource;
        data["bcnSubStatus"] = this.bcnSubStatus;
        data["ccn"] = this.ccn;
        data["programCode"] = this.programCode;
        data["pcnStatus"] = this.pcnStatus;
        data["action"] = this.action;
        data["removeShift"] = this.removeShift;
        data["adjustedShift"] = this.adjustedShift;
        data["positiveShift"] = this.positiveShift;
        data["docType"] = this.docType;
        data["employer"] = this.employer;
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IBcnDetailsDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    bcn?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    acn?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    serviceDate?: Date | undefined;
    inTime?: Date | undefined;
    outTime?: Date | undefined;
    calHrs?: number | undefined;
    diagCode?: string | undefined;
    billCode?: string | undefined;
    billAmount?: number | undefined;
    payrollAmount?: number | undefined;
    billUnit?: number | undefined;
    billRate?: number | undefined;
    payUnit?: number | undefined;
    payRate?: number | undefined;
    status?: number;
    tcn?: string | undefined;
    statusText?: string | undefined;
    pcnStatusText?: string | undefined;
    payDate?: Date | undefined;
    tcnSource?: string | undefined;
    bcnSubStatus?: number | undefined;
    ccn?: string | undefined;
    programCode?: string | undefined;
    pcnStatus?: PcnStatus;
    action?: string | undefined;
    removeShift?: boolean;
    adjustedShift?: boolean;
    positiveShift?: boolean;
    docType?: string | undefined;
    employer?: string | undefined;
    isLocked?: string | undefined;
}

export class BcnDetailsDtoGridResponseBase implements IBcnDetailsDtoGridResponseBase {
    items?: BcnDetailsDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BcnDetailsDto;

    constructor(data?: IBcnDetailsDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BcnDetailsDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? BcnDetailsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BcnDetailsDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new BcnDetailsDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBcnDetailsDtoGridResponseBase {
    items?: BcnDetailsDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BcnDetailsDto;
}

export class BcnTileResult implements IBcnTileResult {
    participant?: string | undefined;
    payUnit?: number;
    billUnit?: number;
    totalPayAmount?: number;
    participantCount?: number;
    recordCount?: number;

    constructor(data?: IBcnTileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participant = _data["participant"];
            this.payUnit = _data["payUnit"];
            this.billUnit = _data["billUnit"];
            this.totalPayAmount = _data["totalPayAmount"];
            this.participantCount = _data["participantCount"];
            this.recordCount = _data["recordCount"];
        }
    }

    static fromJS(data: any): BcnTileResult {
        data = typeof data === 'object' ? data : {};
        let result = new BcnTileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participant"] = this.participant;
        data["payUnit"] = this.payUnit;
        data["billUnit"] = this.billUnit;
        data["totalPayAmount"] = this.totalPayAmount;
        data["participantCount"] = this.participantCount;
        data["recordCount"] = this.recordCount;
        return data;
    }
}

export interface IBcnTileResult {
    participant?: string | undefined;
    payUnit?: number;
    billUnit?: number;
    totalPayAmount?: number;
    participantCount?: number;
    recordCount?: number;
}

export class BillAmtUpdateRequest implements IBillAmtUpdateRequest {
    transactionId?: string | undefined;
    billAmt?: number;

    constructor(data?: IBillAmtUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.billAmt = _data["billAmt"];
        }
    }

    static fromJS(data: any): BillAmtUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BillAmtUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["billAmt"] = this.billAmt;
        return data;
    }
}

export interface IBillAmtUpdateRequest {
    transactionId?: string | undefined;
    billAmt?: number;
}

export class BillCodeDetail implements IBillCodeDetail {
    billCode?: string | undefined;
    hcpcs?: string | undefined;
    mod1?: string | undefined;
    mod2?: string | undefined;
    mod3?: string | undefined;
    mod4?: string | undefined;
    description?: string | undefined;
    isOvertime?: boolean;
    revenueCode?: string | undefined;

    constructor(data?: IBillCodeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billCode = _data["billCode"];
            this.hcpcs = _data["hcpcs"];
            this.mod1 = _data["mod1"];
            this.mod2 = _data["mod2"];
            this.mod3 = _data["mod3"];
            this.mod4 = _data["mod4"];
            this.description = _data["description"];
            this.isOvertime = _data["isOvertime"];
            this.revenueCode = _data["revenueCode"];
        }
    }

    static fromJS(data: any): BillCodeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new BillCodeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billCode"] = this.billCode;
        data["hcpcs"] = this.hcpcs;
        data["mod1"] = this.mod1;
        data["mod2"] = this.mod2;
        data["mod3"] = this.mod3;
        data["mod4"] = this.mod4;
        data["description"] = this.description;
        data["isOvertime"] = this.isOvertime;
        data["revenueCode"] = this.revenueCode;
        return data;
    }
}

export interface IBillCodeDetail {
    billCode?: string | undefined;
    hcpcs?: string | undefined;
    mod1?: string | undefined;
    mod2?: string | undefined;
    mod3?: string | undefined;
    mod4?: string | undefined;
    description?: string | undefined;
    isOvertime?: boolean;
    revenueCode?: string | undefined;
}

export class BillingAreaInfo implements IBillingAreaInfo {
    participantId?: number;
    area?: string | undefined;
    state?: string | undefined;
    areaStartDate?: Date;
    areaEndDate?: Date;

    constructor(data?: IBillingAreaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.area = _data["area"];
            this.state = _data["state"];
            this.areaStartDate = _data["areaStartDate"] ? new Date(_data["areaStartDate"].toString()) : <any>undefined;
            this.areaEndDate = _data["areaEndDate"] ? new Date(_data["areaEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillingAreaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BillingAreaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["area"] = this.area;
        data["state"] = this.state;
        data["areaStartDate"] = this.areaStartDate ? this.areaStartDate.toISOString() : <any>undefined;
        data["areaEndDate"] = this.areaEndDate ? this.areaEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillingAreaInfo {
    participantId?: number;
    area?: string | undefined;
    state?: string | undefined;
    areaStartDate?: Date;
    areaEndDate?: Date;
}

export class BillingDashboardAgingResponse implements IBillingDashboardAgingResponse {
    payorId?: number | undefined;
    programId?: number | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    rangeAmountLessThanThirty?: number | undefined;
    rangeAmountThirtyToSixty?: number | undefined;
    rangeAmountSixtyToNinety?: number | undefined;
    rangeAmountNinetyToOneTwenty?: number | undefined;
    rangeAmountGreaterThanOneTwenty?: number | undefined;
    totalAmount?: number | undefined;
    updatedOn?: Date;
    agingDetails?: BillingDashboardAgingResponse[] | undefined;

    constructor(data?: IBillingDashboardAgingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.payorName = _data["payorName"];
            this.programName = _data["programName"];
            this.rangeAmountLessThanThirty = _data["rangeAmountLessThanThirty"];
            this.rangeAmountThirtyToSixty = _data["rangeAmountThirtyToSixty"];
            this.rangeAmountSixtyToNinety = _data["rangeAmountSixtyToNinety"];
            this.rangeAmountNinetyToOneTwenty = _data["rangeAmountNinetyToOneTwenty"];
            this.rangeAmountGreaterThanOneTwenty = _data["rangeAmountGreaterThanOneTwenty"];
            this.totalAmount = _data["totalAmount"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["agingDetails"])) {
                this.agingDetails = [] as any;
                for (let item of _data["agingDetails"])
                    this.agingDetails!.push(BillingDashboardAgingResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillingDashboardAgingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardAgingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["payorName"] = this.payorName;
        data["programName"] = this.programName;
        data["rangeAmountLessThanThirty"] = this.rangeAmountLessThanThirty;
        data["rangeAmountThirtyToSixty"] = this.rangeAmountThirtyToSixty;
        data["rangeAmountSixtyToNinety"] = this.rangeAmountSixtyToNinety;
        data["rangeAmountNinetyToOneTwenty"] = this.rangeAmountNinetyToOneTwenty;
        data["rangeAmountGreaterThanOneTwenty"] = this.rangeAmountGreaterThanOneTwenty;
        data["totalAmount"] = this.totalAmount;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.agingDetails)) {
            data["agingDetails"] = [];
            for (let item of this.agingDetails)
                data["agingDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBillingDashboardAgingResponse {
    payorId?: number | undefined;
    programId?: number | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    rangeAmountLessThanThirty?: number | undefined;
    rangeAmountThirtyToSixty?: number | undefined;
    rangeAmountSixtyToNinety?: number | undefined;
    rangeAmountNinetyToOneTwenty?: number | undefined;
    rangeAmountGreaterThanOneTwenty?: number | undefined;
    totalAmount?: number | undefined;
    updatedOn?: Date;
    agingDetails?: BillingDashboardAgingResponse[] | undefined;
}

export class BillingDashboardBatchesResponse implements IBillingDashboardBatchesResponse {
    payorId?: number | undefined;
    programId?: number | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    batchStatus?: string | undefined;
    batchType?: string | undefined;
    batchNumber?: string | undefined;
    updatedOn?: Date;
    batchesDetails?: BillingDashboardBatchesResponse[] | undefined;

    constructor(data?: IBillingDashboardBatchesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.payorName = _data["payorName"];
            this.programName = _data["programName"];
            this.batchStatus = _data["batchStatus"];
            this.batchType = _data["batchType"];
            this.batchNumber = _data["batchNumber"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["batchesDetails"])) {
                this.batchesDetails = [] as any;
                for (let item of _data["batchesDetails"])
                    this.batchesDetails!.push(BillingDashboardBatchesResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillingDashboardBatchesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardBatchesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["payorName"] = this.payorName;
        data["programName"] = this.programName;
        data["batchStatus"] = this.batchStatus;
        data["batchType"] = this.batchType;
        data["batchNumber"] = this.batchNumber;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.batchesDetails)) {
            data["batchesDetails"] = [];
            for (let item of this.batchesDetails)
                data["batchesDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBillingDashboardBatchesResponse {
    payorId?: number | undefined;
    programId?: number | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    batchStatus?: string | undefined;
    batchType?: string | undefined;
    batchNumber?: string | undefined;
    updatedOn?: Date;
    batchesDetails?: BillingDashboardBatchesResponse[] | undefined;
}

export class BillingDashboardClaimStatusResponse implements IBillingDashboardClaimStatusResponse {
    payorId?: number | undefined;
    programId?: number | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    status?: CCNStatus;
    count?: number | undefined;
    amount?: number | undefined;
    updatedOn?: Date;

    constructor(data?: IBillingDashboardClaimStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.payorName = _data["payorName"];
            this.programName = _data["programName"];
            this.status = _data["status"];
            this.count = _data["count"];
            this.amount = _data["amount"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillingDashboardClaimStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardClaimStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["payorName"] = this.payorName;
        data["programName"] = this.programName;
        data["status"] = this.status;
        data["count"] = this.count;
        data["amount"] = this.amount;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillingDashboardClaimStatusResponse {
    payorId?: number | undefined;
    programId?: number | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    status?: CCNStatus;
    count?: number | undefined;
    amount?: number | undefined;
    updatedOn?: Date;
}

export class BillingDashboardPaymentResponse implements IBillingDashboardPaymentResponse {
    payorId?: number | undefined;
    programId?: number | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    status?: string | undefined;
    amount?: number | undefined;
    updatedOn?: Date;
    paymentDetails?: BillingDashboardPaymentResponse[] | undefined;

    constructor(data?: IBillingDashboardPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.payorName = _data["payorName"];
            this.programName = _data["programName"];
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["paymentDetails"])) {
                this.paymentDetails = [] as any;
                for (let item of _data["paymentDetails"])
                    this.paymentDetails!.push(BillingDashboardPaymentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillingDashboardPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["payorName"] = this.payorName;
        data["programName"] = this.programName;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.paymentDetails)) {
            data["paymentDetails"] = [];
            for (let item of this.paymentDetails)
                data["paymentDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBillingDashboardPaymentResponse {
    payorId?: number | undefined;
    programId?: number | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    status?: string | undefined;
    amount?: number | undefined;
    updatedOn?: Date;
    paymentDetails?: BillingDashboardPaymentResponse[] | undefined;
}

export class BillingDashboardRequest implements IBillingDashboardRequest {
    payorIds?: number[] | undefined;
    programIds?: number[] | undefined;
    companyId?: number;

    constructor(data?: IBillingDashboardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payorIds"])) {
                this.payorIds = [] as any;
                for (let item of _data["payorIds"])
                    this.payorIds!.push(item);
            }
            if (Array.isArray(_data["programIds"])) {
                this.programIds = [] as any;
                for (let item of _data["programIds"])
                    this.programIds!.push(item);
            }
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): BillingDashboardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payorIds)) {
            data["payorIds"] = [];
            for (let item of this.payorIds)
                data["payorIds"].push(item);
        }
        if (Array.isArray(this.programIds)) {
            data["programIds"] = [];
            for (let item of this.programIds)
                data["programIds"].push(item);
        }
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IBillingDashboardRequest {
    payorIds?: number[] | undefined;
    programIds?: number[] | undefined;
    companyId?: number;
}

export class BillingDashboardTemplate implements IBillingDashboardTemplate {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    isDefault?: boolean;
    details?: BillingDashboardTemplateResponse[] | undefined;

    constructor(data?: IBillingDashboardTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.payorName = _data["payorName"];
            this.programName = _data["programName"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(BillingDashboardTemplateResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillingDashboardTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["payorName"] = this.payorName;
        data["programName"] = this.programName;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBillingDashboardTemplate {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    payorName?: string | undefined;
    programName?: string | undefined;
    isDefault?: boolean;
    details?: BillingDashboardTemplateResponse[] | undefined;
}

export class BillingDashboardTemplateGridResponseBase implements IBillingDashboardTemplateGridResponseBase {
    items?: BillingDashboardTemplate[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BillingDashboardTemplate;

    constructor(data?: IBillingDashboardTemplateGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BillingDashboardTemplate.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? BillingDashboardTemplate.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BillingDashboardTemplateGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardTemplateGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBillingDashboardTemplateGridResponseBase {
    items?: BillingDashboardTemplate[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BillingDashboardTemplate;
}

export class BillingDashboardTemplateRequest implements IBillingDashboardTemplateRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    id?: number;
    companyId?: number;

    constructor(data?: IBillingDashboardTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.id = _data["id"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): BillingDashboardTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IBillingDashboardTemplateRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    id?: number;
    companyId?: number;
}

export class BillingDashboardTemplateResponse implements IBillingDashboardTemplateResponse {
    mappingId?: number;
    templateId?: number;
    templateName?: string | undefined;
    templateDescription?: string | undefined;
    payorId?: number;
    payorName?: string | undefined;
    programId?: number | undefined;
    programName?: string | undefined;
    isDefault?: boolean;

    constructor(data?: IBillingDashboardTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mappingId = _data["mappingId"];
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            this.templateDescription = _data["templateDescription"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.programId = _data["programId"];
            this.programName = _data["programName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): BillingDashboardTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId;
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        data["templateDescription"] = this.templateDescription;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["programId"] = this.programId;
        data["programName"] = this.programName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IBillingDashboardTemplateResponse {
    mappingId?: number;
    templateId?: number;
    templateName?: string | undefined;
    templateDescription?: string | undefined;
    payorId?: number;
    payorName?: string | undefined;
    programId?: number | undefined;
    programName?: string | undefined;
    isDefault?: boolean;
}

export class BillingParticipantRequestDto implements IBillingParticipantRequestDto {
    participantId?: string | undefined;
    referringNPI?: string | undefined;
    referringAPI?: string | undefined;
    referringFirstName?: string | undefined;
    referringLastName?: string | undefined;
    attendingNPI?: string | undefined;
    attendingAPI?: string | undefined;
    attendingFirstName?: string | undefined;
    attendingLastName?: string | undefined;

    constructor(data?: IBillingParticipantRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.referringNPI = _data["referringNPI"];
            this.referringAPI = _data["referringAPI"];
            this.referringFirstName = _data["referringFirstName"];
            this.referringLastName = _data["referringLastName"];
            this.attendingNPI = _data["attendingNPI"];
            this.attendingAPI = _data["attendingAPI"];
            this.attendingFirstName = _data["attendingFirstName"];
            this.attendingLastName = _data["attendingLastName"];
        }
    }

    static fromJS(data: any): BillingParticipantRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingParticipantRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["referringNPI"] = this.referringNPI;
        data["referringAPI"] = this.referringAPI;
        data["referringFirstName"] = this.referringFirstName;
        data["referringLastName"] = this.referringLastName;
        data["attendingNPI"] = this.attendingNPI;
        data["attendingAPI"] = this.attendingAPI;
        data["attendingFirstName"] = this.attendingFirstName;
        data["attendingLastName"] = this.attendingLastName;
        return data;
    }
}

export interface IBillingParticipantRequestDto {
    participantId?: string | undefined;
    referringNPI?: string | undefined;
    referringAPI?: string | undefined;
    referringFirstName?: string | undefined;
    referringLastName?: string | undefined;
    attendingNPI?: string | undefined;
    attendingAPI?: string | undefined;
    attendingFirstName?: string | undefined;
    attendingLastName?: string | undefined;
}

export class BillingParticipantResponseDto implements IBillingParticipantResponseDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    participantId?: string | undefined;
    referringNPI?: string | undefined;
    referringAPI?: string | undefined;
    referringFirstName?: string | undefined;
    referringLastName?: string | undefined;
    attendingNPI?: string | undefined;
    attendingAPI?: string | undefined;
    attendingFirstName?: string | undefined;
    attendingLastName?: string | undefined;

    constructor(data?: IBillingParticipantResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.participantId = _data["participantId"];
            this.referringNPI = _data["referringNPI"];
            this.referringAPI = _data["referringAPI"];
            this.referringFirstName = _data["referringFirstName"];
            this.referringLastName = _data["referringLastName"];
            this.attendingNPI = _data["attendingNPI"];
            this.attendingAPI = _data["attendingAPI"];
            this.attendingFirstName = _data["attendingFirstName"];
            this.attendingLastName = _data["attendingLastName"];
        }
    }

    static fromJS(data: any): BillingParticipantResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingParticipantResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["participantId"] = this.participantId;
        data["referringNPI"] = this.referringNPI;
        data["referringAPI"] = this.referringAPI;
        data["referringFirstName"] = this.referringFirstName;
        data["referringLastName"] = this.referringLastName;
        data["attendingNPI"] = this.attendingNPI;
        data["attendingAPI"] = this.attendingAPI;
        data["attendingFirstName"] = this.attendingFirstName;
        data["attendingLastName"] = this.attendingLastName;
        return data;
    }
}

export interface IBillingParticipantResponseDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    participantId?: string | undefined;
    referringNPI?: string | undefined;
    referringAPI?: string | undefined;
    referringFirstName?: string | undefined;
    referringLastName?: string | undefined;
    attendingNPI?: string | undefined;
    attendingAPI?: string | undefined;
    attendingFirstName?: string | undefined;
    attendingLastName?: string | undefined;
}

export class BillingProvider implements IBillingProvider {
    taxonomy?: string | undefined;
    programCode?: string | undefined;
    contactName?: string | undefined;
    npi?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    stateCode?: string | undefined;
    api?: string | undefined;
    fedTaxID?: string | undefined;

    constructor(data?: IBillingProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxonomy = _data["taxonomy"];
            this.programCode = _data["programCode"];
            this.contactName = _data["contactName"];
            this.npi = _data["npi"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.state = _data["state"];
            this.stateCode = _data["stateCode"];
            this.api = _data["api"];
            this.fedTaxID = _data["fedTaxID"];
        }
    }

    static fromJS(data: any): BillingProvider {
        data = typeof data === 'object' ? data : {};
        let result = new BillingProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxonomy"] = this.taxonomy;
        data["programCode"] = this.programCode;
        data["contactName"] = this.contactName;
        data["npi"] = this.npi;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["state"] = this.state;
        data["stateCode"] = this.stateCode;
        data["api"] = this.api;
        data["fedTaxID"] = this.fedTaxID;
        return data;
    }
}

export interface IBillingProvider {
    taxonomy?: string | undefined;
    programCode?: string | undefined;
    contactName?: string | undefined;
    npi?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    stateCode?: string | undefined;
    api?: string | undefined;
    fedTaxID?: string | undefined;
}

export class BillingRecordsPcnStatusRequest implements IBillingRecordsPcnStatusRequest {
    tcnIds?: string[] | undefined;
    pcnStatus?: number;
    payDate?: Date | undefined;

    constructor(data?: IBillingRecordsPcnStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tcnIds"])) {
                this.tcnIds = [] as any;
                for (let item of _data["tcnIds"])
                    this.tcnIds!.push(item);
            }
            this.pcnStatus = _data["pcnStatus"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillingRecordsPcnStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BillingRecordsPcnStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tcnIds)) {
            data["tcnIds"] = [];
            for (let item of this.tcnIds)
                data["tcnIds"].push(item);
        }
        data["pcnStatus"] = this.pcnStatus;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBillingRecordsPcnStatusRequest {
    tcnIds?: string[] | undefined;
    pcnStatus?: number;
    payDate?: Date | undefined;
}

export class BillingStatusDetailsDto implements IBillingStatusDetailsDto {
    id?: number;
    code?: string | undefined;
    value?: string | undefined;

    constructor(data?: IBillingStatusDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BillingStatusDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingStatusDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["value"] = this.value;
        return data;
    }
}

export interface IBillingStatusDetailsDto {
    id?: number;
    code?: string | undefined;
    value?: string | undefined;
}

export class BulkAdjustmentsIngestionDto implements IBulkAdjustmentsIngestionDto {
    filePath?: string | undefined;
    email?: string | undefined;

    constructor(data?: IBulkAdjustmentsIngestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["filePath"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): BulkAdjustmentsIngestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAdjustmentsIngestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        data["email"] = this.email;
        return data;
    }
}

export interface IBulkAdjustmentsIngestionDto {
    filePath?: string | undefined;
    email?: string | undefined;
}

export class BulkWriteOffCreateBatchRequestDto implements IBulkWriteOffCreateBatchRequestDto {
    payor?: string | undefined;
    payorId?: number;
    writeOffCauseID?: number;
    writeOffCause?: string | undefined;
    writeOffErrorTypeID?: number;
    writeOffErrorType?: string | undefined;
    includedLcn?: BulkWriteOffGridDataDto[] | undefined;
    program?: string | undefined;
    ccn?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    hcpcsCode?: string | undefined;
    lineStatus?: LineStatus[] | undefined;
    participantId?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    remarkCode?: string | undefined;
    selectedWriteOffStatus?: string | undefined;
    writeOffLimit?: number | undefined;
    includeAllClaimsInBatch?: boolean;

    constructor(data?: IBulkWriteOffCreateBatchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payor = _data["payor"];
            this.payorId = _data["payorId"];
            this.writeOffCauseID = _data["writeOffCauseID"];
            this.writeOffCause = _data["writeOffCause"];
            this.writeOffErrorTypeID = _data["writeOffErrorTypeID"];
            this.writeOffErrorType = _data["writeOffErrorType"];
            if (Array.isArray(_data["includedLcn"])) {
                this.includedLcn = [] as any;
                for (let item of _data["includedLcn"])
                    this.includedLcn!.push(BulkWriteOffGridDataDto.fromJS(item));
            }
            this.program = _data["program"];
            this.ccn = _data["ccn"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hcpcsCode = _data["hcpcsCode"];
            if (Array.isArray(_data["lineStatus"])) {
                this.lineStatus = [] as any;
                for (let item of _data["lineStatus"])
                    this.lineStatus!.push(item);
            }
            this.participantId = _data["participantId"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.groupCode = _data["groupCode"];
            this.remarkCode = _data["remarkCode"];
            this.selectedWriteOffStatus = _data["selectedWriteOffStatus"];
            this.writeOffLimit = _data["writeOffLimit"];
            this.includeAllClaimsInBatch = _data["includeAllClaimsInBatch"];
        }
    }

    static fromJS(data: any): BulkWriteOffCreateBatchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkWriteOffCreateBatchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payor"] = this.payor;
        data["payorId"] = this.payorId;
        data["writeOffCauseID"] = this.writeOffCauseID;
        data["writeOffCause"] = this.writeOffCause;
        data["writeOffErrorTypeID"] = this.writeOffErrorTypeID;
        data["writeOffErrorType"] = this.writeOffErrorType;
        if (Array.isArray(this.includedLcn)) {
            data["includedLcn"] = [];
            for (let item of this.includedLcn)
                data["includedLcn"].push(item.toJSON());
        }
        data["program"] = this.program;
        data["ccn"] = this.ccn;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hcpcsCode"] = this.hcpcsCode;
        if (Array.isArray(this.lineStatus)) {
            data["lineStatus"] = [];
            for (let item of this.lineStatus)
                data["lineStatus"].push(item);
        }
        data["participantId"] = this.participantId;
        data["adjustmentCode"] = this.adjustmentCode;
        data["groupCode"] = this.groupCode;
        data["remarkCode"] = this.remarkCode;
        data["selectedWriteOffStatus"] = this.selectedWriteOffStatus;
        data["writeOffLimit"] = this.writeOffLimit;
        data["includeAllClaimsInBatch"] = this.includeAllClaimsInBatch;
        return data;
    }
}

export interface IBulkWriteOffCreateBatchRequestDto {
    payor?: string | undefined;
    payorId?: number;
    writeOffCauseID?: number;
    writeOffCause?: string | undefined;
    writeOffErrorTypeID?: number;
    writeOffErrorType?: string | undefined;
    includedLcn?: BulkWriteOffGridDataDto[] | undefined;
    program?: string | undefined;
    ccn?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    hcpcsCode?: string | undefined;
    lineStatus?: LineStatus[] | undefined;
    participantId?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    remarkCode?: string | undefined;
    selectedWriteOffStatus?: string | undefined;
    writeOffLimit?: number | undefined;
    includeAllClaimsInBatch?: boolean;
}

export class BulkWriteOffGridDataDto implements IBulkWriteOffGridDataDto {
    id?: number;
    ccn?: string | undefined;
    lcnid?: number;
    ccnid?: number;
    lcn?: string | undefined;
    remainingAmount?: number | undefined;
    appliedAmount?: number | undefined;
    pendingWriteOffAmount?: number | undefined;
    participantID?: string | undefined;
    participantName?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    remarkCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    billUnit?: number;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;

    constructor(data?: IBulkWriteOffGridDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ccn = _data["ccn"];
            this.lcnid = _data["lcnid"];
            this.ccnid = _data["ccnid"];
            this.lcn = _data["lcn"];
            this.remainingAmount = _data["remainingAmount"];
            this.appliedAmount = _data["appliedAmount"];
            this.pendingWriteOffAmount = _data["pendingWriteOffAmount"];
            this.participantID = _data["participantID"];
            this.participantName = _data["participantName"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.groupCode = _data["groupCode"];
            this.remarkCode = _data["remarkCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.billUnit = _data["billUnit"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
        }
    }

    static fromJS(data: any): BulkWriteOffGridDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkWriteOffGridDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ccn"] = this.ccn;
        data["lcnid"] = this.lcnid;
        data["ccnid"] = this.ccnid;
        data["lcn"] = this.lcn;
        data["remainingAmount"] = this.remainingAmount;
        data["appliedAmount"] = this.appliedAmount;
        data["pendingWriteOffAmount"] = this.pendingWriteOffAmount;
        data["participantID"] = this.participantID;
        data["participantName"] = this.participantName;
        data["adjustmentCode"] = this.adjustmentCode;
        data["groupCode"] = this.groupCode;
        data["remarkCode"] = this.remarkCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["billUnit"] = this.billUnit;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        return data;
    }
}

export interface IBulkWriteOffGridDataDto {
    id?: number;
    ccn?: string | undefined;
    lcnid?: number;
    ccnid?: number;
    lcn?: string | undefined;
    remainingAmount?: number | undefined;
    appliedAmount?: number | undefined;
    pendingWriteOffAmount?: number | undefined;
    participantID?: string | undefined;
    participantName?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    remarkCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    billUnit?: number;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
}

export class BulkWriteOffGridDataDtoBulkWriteOffGridResponse implements IBulkWriteOffGridDataDtoBulkWriteOffGridResponse {
    items?: BulkWriteOffGridDataDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BulkWriteOffGridDataDto;
    error?: ResponseModel;

    constructor(data?: IBulkWriteOffGridDataDtoBulkWriteOffGridResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BulkWriteOffGridDataDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? BulkWriteOffGridDataDto.fromJS(_data["data"]) : <any>undefined;
            this.error = _data["error"] ? ResponseModel.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkWriteOffGridDataDtoBulkWriteOffGridResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BulkWriteOffGridDataDtoBulkWriteOffGridResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBulkWriteOffGridDataDtoBulkWriteOffGridResponse {
    items?: BulkWriteOffGridDataDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BulkWriteOffGridDataDto;
    error?: ResponseModel;
}

export class BulkWriteOffSearchRequestDto implements IBulkWriteOffSearchRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string[] | undefined;
    program?: string[] | undefined;
    ccn?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    hcpcsCode?: string | undefined;
    lineStatus?: LineStatus[] | undefined;
    participantId?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    remarkCode?: string | undefined;
    selectedWriteOffStatus?: string | undefined;
    writeOffLimit?: number | undefined;
    includeAllClaimsInBatch?: boolean;

    constructor(data?: IBulkWriteOffSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["payor"])) {
                this.payor = [] as any;
                for (let item of _data["payor"])
                    this.payor!.push(item);
            }
            if (Array.isArray(_data["program"])) {
                this.program = [] as any;
                for (let item of _data["program"])
                    this.program!.push(item);
            }
            this.ccn = _data["ccn"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hcpcsCode = _data["hcpcsCode"];
            if (Array.isArray(_data["lineStatus"])) {
                this.lineStatus = [] as any;
                for (let item of _data["lineStatus"])
                    this.lineStatus!.push(item);
            }
            this.participantId = _data["participantId"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.groupCode = _data["groupCode"];
            this.remarkCode = _data["remarkCode"];
            this.selectedWriteOffStatus = _data["selectedWriteOffStatus"];
            this.writeOffLimit = _data["writeOffLimit"];
            this.includeAllClaimsInBatch = _data["includeAllClaimsInBatch"];
        }
    }

    static fromJS(data: any): BulkWriteOffSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkWriteOffSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.payor)) {
            data["payor"] = [];
            for (let item of this.payor)
                data["payor"].push(item);
        }
        if (Array.isArray(this.program)) {
            data["program"] = [];
            for (let item of this.program)
                data["program"].push(item);
        }
        data["ccn"] = this.ccn;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hcpcsCode"] = this.hcpcsCode;
        if (Array.isArray(this.lineStatus)) {
            data["lineStatus"] = [];
            for (let item of this.lineStatus)
                data["lineStatus"].push(item);
        }
        data["participantId"] = this.participantId;
        data["adjustmentCode"] = this.adjustmentCode;
        data["groupCode"] = this.groupCode;
        data["remarkCode"] = this.remarkCode;
        data["selectedWriteOffStatus"] = this.selectedWriteOffStatus;
        data["writeOffLimit"] = this.writeOffLimit;
        data["includeAllClaimsInBatch"] = this.includeAllClaimsInBatch;
        return data;
    }
}

export interface IBulkWriteOffSearchRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string[] | undefined;
    program?: string[] | undefined;
    ccn?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    hcpcsCode?: string | undefined;
    lineStatus?: LineStatus[] | undefined;
    participantId?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    remarkCode?: string | undefined;
    selectedWriteOffStatus?: string | undefined;
    writeOffLimit?: number | undefined;
    includeAllClaimsInBatch?: boolean;
}

export class CCNDTO implements ICCNDTO {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    ccn?: string | undefined;
    bccnId?: number;
    refCCN?: number | undefined;
    isExcluded?: boolean;
    payor?: string | undefined;
    program?: string | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    caregiverName?: string | undefined;
    caregiverNPI?: string | undefined;
    caregiverAPI?: string | undefined;
    authCode?: string | undefined;
    serviceCode?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    payUnits?: number | undefined;
    billUnits?: number | undefined;
    totalBillAmount?: number | undefined;
    excludeReason?: string | undefined;
    groupId?: string | undefined;

    constructor(data?: ICCNDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.ccn = _data["ccn"];
            this.bccnId = _data["bccnId"];
            this.refCCN = _data["refCCN"];
            this.isExcluded = _data["isExcluded"];
            this.payor = _data["payor"];
            this.program = _data["program"];
            this.participantId = _data["participantId"];
            this.participantName = _data["participantName"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverNPI = _data["caregiverNPI"];
            this.caregiverAPI = _data["caregiverAPI"];
            this.authCode = _data["authCode"];
            this.serviceCode = _data["serviceCode"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.payUnits = _data["payUnits"];
            this.billUnits = _data["billUnits"];
            this.totalBillAmount = _data["totalBillAmount"];
            this.excludeReason = _data["excludeReason"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CCNDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CCNDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["ccn"] = this.ccn;
        data["bccnId"] = this.bccnId;
        data["refCCN"] = this.refCCN;
        data["isExcluded"] = this.isExcluded;
        data["payor"] = this.payor;
        data["program"] = this.program;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["caregiverName"] = this.caregiverName;
        data["caregiverNPI"] = this.caregiverNPI;
        data["caregiverAPI"] = this.caregiverAPI;
        data["authCode"] = this.authCode;
        data["serviceCode"] = this.serviceCode;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["payUnits"] = this.payUnits;
        data["billUnits"] = this.billUnits;
        data["totalBillAmount"] = this.totalBillAmount;
        data["excludeReason"] = this.excludeReason;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ICCNDTO {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    ccn?: string | undefined;
    bccnId?: number;
    refCCN?: number | undefined;
    isExcluded?: boolean;
    payor?: string | undefined;
    program?: string | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    caregiverName?: string | undefined;
    caregiverNPI?: string | undefined;
    caregiverAPI?: string | undefined;
    authCode?: string | undefined;
    serviceCode?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    payUnits?: number | undefined;
    billUnits?: number | undefined;
    totalBillAmount?: number | undefined;
    excludeReason?: string | undefined;
    groupId?: string | undefined;
}

export class CCNDTOGridResponseBase implements ICCNDTOGridResponseBase {
    items?: CCNDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CCNDTO;

    constructor(data?: ICCNDTOGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CCNDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CCNDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CCNDTOGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CCNDTOGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICCNDTOGridResponseBase {
    items?: CCNDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CCNDTO;
}

export enum CCNStatus {
    InProgress = "InProgress",
    Billed = "Billed",
    Acknowledged = "Acknowledged",
    Paid = "Paid",
    PartialPaid = "PartialPaid",
    Adjusted = "Adjusted",
    Void = "Void",
    Denied = "Denied",
    OverPaid = "OverPaid",
    Closed = "Closed",
    NeedsReview = "NeedsReview",
    Replaced = "Replaced",
}

export class CcnAdjustmentCode implements ICcnAdjustmentCode {
    adjustmentCode?: string | undefined;

    constructor(data?: ICcnAdjustmentCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adjustmentCode = _data["adjustmentCode"];
        }
    }

    static fromJS(data: any): CcnAdjustmentCode {
        data = typeof data === 'object' ? data : {};
        let result = new CcnAdjustmentCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustmentCode"] = this.adjustmentCode;
        return data;
    }
}

export interface ICcnAdjustmentCode {
    adjustmentCode?: string | undefined;
}

export class CcnDetailDto implements ICcnDetailDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    ccn?: string | undefined;
    participantID?: string | undefined;
    participantName?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    currentAmount?: number;
    status?: CCNStatus;
    createdOn?: Date | undefined;
    icn?: string | undefined;
    insuredId?: string | undefined;
    diagCode?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;

    constructor(data?: ICcnDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.ccn = _data["ccn"];
            this.participantID = _data["participantID"];
            this.participantName = _data["participantName"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.currentAmount = _data["currentAmount"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.icn = _data["icn"];
            this.insuredId = _data["insuredId"];
            this.diagCode = _data["diagCode"];
            this.authCode = _data["authCode"];
            this.servCode = _data["servCode"];
        }
    }

    static fromJS(data: any): CcnDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CcnDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["ccn"] = this.ccn;
        data["participantID"] = this.participantID;
        data["participantName"] = this.participantName;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["currentAmount"] = this.currentAmount;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["icn"] = this.icn;
        data["insuredId"] = this.insuredId;
        data["diagCode"] = this.diagCode;
        data["authCode"] = this.authCode;
        data["servCode"] = this.servCode;
        return data;
    }
}

export interface ICcnDetailDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    ccn?: string | undefined;
    participantID?: string | undefined;
    participantName?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    currentAmount?: number;
    status?: CCNStatus;
    createdOn?: Date | undefined;
    icn?: string | undefined;
    insuredId?: string | undefined;
    diagCode?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
}

export class CcnDetailDtoGridResponseBase implements ICcnDetailDtoGridResponseBase {
    items?: CcnDetailDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CcnDetailDto;

    constructor(data?: ICcnDetailDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CcnDetailDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CcnDetailDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CcnDetailDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CcnDetailDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICcnDetailDtoGridResponseBase {
    items?: CcnDetailDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CcnDetailDto;
}

export class CcnDetailsDto implements ICcnDetailsDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    ccn?: string | undefined;
    participantName?: string | undefined;
    participantId?: string | undefined;
    payorId?: string | undefined;
    programId?: string | undefined;
    billCode?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier1?: string | undefined;
    modifier2?: string | undefined;
    modifier3?: string | undefined;
    modifier4?: string | undefined;
    servCode?: string | undefined;
    authCode?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isExcluded?: boolean | undefined;
    adjudicatedDate?: Date | undefined;
    status?: CCNStatus;
    claimAmount?: number;
    paidAmount?: number;
    copayAmount?: number | undefined;
    remainingAmount?: number;
    overPaidAmount?: number;
    writeOffAmount?: number | undefined;
    readonly statusText?: string | undefined;
    icn?: string | undefined;
    note?: string | undefined;
    writeOffPending?: number | undefined;
    caregiverId?: string | undefined;
    adjustmentCode?: CcnAdjustmentCode[] | undefined;
    isAdjusted?: boolean;

    constructor(data?: ICcnDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.ccn = _data["ccn"];
            this.participantName = _data["participantName"];
            this.participantId = _data["participantId"];
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.billCode = _data["billCode"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier1 = _data["modifier1"];
            this.modifier2 = _data["modifier2"];
            this.modifier3 = _data["modifier3"];
            this.modifier4 = _data["modifier4"];
            this.servCode = _data["servCode"];
            this.authCode = _data["authCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isExcluded = _data["isExcluded"];
            this.adjudicatedDate = _data["adjudicatedDate"] ? new Date(_data["adjudicatedDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.claimAmount = _data["claimAmount"];
            this.paidAmount = _data["paidAmount"];
            this.copayAmount = _data["copayAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.overPaidAmount = _data["overPaidAmount"];
            this.writeOffAmount = _data["writeOffAmount"];
            (<any>this).statusText = _data["statusText"];
            this.icn = _data["icn"];
            this.note = _data["note"];
            this.writeOffPending = _data["writeOffPending"];
            this.caregiverId = _data["caregiverId"];
            if (Array.isArray(_data["adjustmentCode"])) {
                this.adjustmentCode = [] as any;
                for (let item of _data["adjustmentCode"])
                    this.adjustmentCode!.push(CcnAdjustmentCode.fromJS(item));
            }
            this.isAdjusted = _data["isAdjusted"];
        }
    }

    static fromJS(data: any): CcnDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CcnDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["ccn"] = this.ccn;
        data["participantName"] = this.participantName;
        data["participantId"] = this.participantId;
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["billCode"] = this.billCode;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier1"] = this.modifier1;
        data["modifier2"] = this.modifier2;
        data["modifier3"] = this.modifier3;
        data["modifier4"] = this.modifier4;
        data["servCode"] = this.servCode;
        data["authCode"] = this.authCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isExcluded"] = this.isExcluded;
        data["adjudicatedDate"] = this.adjudicatedDate ? this.adjudicatedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["claimAmount"] = this.claimAmount;
        data["paidAmount"] = this.paidAmount;
        data["copayAmount"] = this.copayAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["overPaidAmount"] = this.overPaidAmount;
        data["writeOffAmount"] = this.writeOffAmount;
        data["statusText"] = this.statusText;
        data["icn"] = this.icn;
        data["note"] = this.note;
        data["writeOffPending"] = this.writeOffPending;
        data["caregiverId"] = this.caregiverId;
        if (Array.isArray(this.adjustmentCode)) {
            data["adjustmentCode"] = [];
            for (let item of this.adjustmentCode)
                data["adjustmentCode"].push(item.toJSON());
        }
        data["isAdjusted"] = this.isAdjusted;
        return data;
    }
}

export interface ICcnDetailsDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    ccn?: string | undefined;
    participantName?: string | undefined;
    participantId?: string | undefined;
    payorId?: string | undefined;
    programId?: string | undefined;
    billCode?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier1?: string | undefined;
    modifier2?: string | undefined;
    modifier3?: string | undefined;
    modifier4?: string | undefined;
    servCode?: string | undefined;
    authCode?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isExcluded?: boolean | undefined;
    adjudicatedDate?: Date | undefined;
    status?: CCNStatus;
    claimAmount?: number;
    paidAmount?: number;
    copayAmount?: number | undefined;
    remainingAmount?: number;
    overPaidAmount?: number;
    writeOffAmount?: number | undefined;
    statusText?: string | undefined;
    icn?: string | undefined;
    note?: string | undefined;
    writeOffPending?: number | undefined;
    caregiverId?: string | undefined;
    adjustmentCode?: CcnAdjustmentCode[] | undefined;
    isAdjusted?: boolean;
}

export class CcnExcelExportRequest implements ICcnExcelExportRequest {
    ids?: number[] | undefined;

    constructor(data?: ICcnExcelExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): CcnExcelExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CcnExcelExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface ICcnExcelExportRequest {
    ids?: number[] | undefined;
}

export class CcnHistoryDto implements ICcnHistoryDto {
    id?: number;
    ccn?: string | undefined;
    claimAmount?: number | undefined;
    createdOn?: Date | undefined;
    batchNumber?: string | undefined;

    constructor(data?: ICcnHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ccn = _data["ccn"];
            this.claimAmount = _data["claimAmount"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.batchNumber = _data["batchNumber"];
        }
    }

    static fromJS(data: any): CcnHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CcnHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ccn"] = this.ccn;
        data["claimAmount"] = this.claimAmount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        return data;
    }
}

export interface ICcnHistoryDto {
    id?: number;
    ccn?: string | undefined;
    claimAmount?: number | undefined;
    createdOn?: Date | undefined;
    batchNumber?: string | undefined;
}

export class CcnHistoryDtoGridResponseBase implements ICcnHistoryDtoGridResponseBase {
    items?: CcnHistoryDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CcnHistoryDto;

    constructor(data?: ICcnHistoryDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CcnHistoryDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CcnHistoryDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CcnHistoryDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CcnHistoryDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICcnHistoryDtoGridResponseBase {
    items?: CcnHistoryDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CcnHistoryDto;
}

export class CcnRefreshProceedRequestDto implements ICcnRefreshProceedRequestDto {
    ccnId?: number;
    insuredId?: string | undefined;
    diagCode?: string | undefined;
    authCode?: string | undefined;

    constructor(data?: ICcnRefreshProceedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ccnId = _data["ccnId"];
            this.insuredId = _data["insuredId"];
            this.diagCode = _data["diagCode"];
            this.authCode = _data["authCode"];
        }
    }

    static fromJS(data: any): CcnRefreshProceedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CcnRefreshProceedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ccnId"] = this.ccnId;
        data["insuredId"] = this.insuredId;
        data["diagCode"] = this.diagCode;
        data["authCode"] = this.authCode;
        return data;
    }
}

export interface ICcnRefreshProceedRequestDto {
    ccnId?: number;
    insuredId?: string | undefined;
    diagCode?: string | undefined;
    authCode?: string | undefined;
}

export class CcnSearchRequest implements ICcnSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string | undefined;
    participantId?: string | undefined;
    hcpcsCode?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    documentStartDate?: Date | undefined;
    documentEndDate?: Date | undefined;
    statuses?: CCNStatus[] | undefined;
    filterType?: string | undefined;

    constructor(data?: ICcnSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.payor = _data["payor"];
            this.participantId = _data["participantId"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
            this.documentStartDate = _data["documentStartDate"] ? new Date(_data["documentStartDate"].toString()) : <any>undefined;
            this.documentEndDate = _data["documentEndDate"] ? new Date(_data["documentEndDate"].toString()) : <any>undefined;
            this.filterType = _data["filterType"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
        }
    }

    static fromJS(data: any): CcnSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CcnSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["payor"] = this.payor;
        data["participantId"] = this.participantId;
        data["hcpcsCode"] = this.hcpcsCode;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        data["documentStartDate"] = this.documentStartDate ? this.documentStartDate.toISOString() : <any>undefined;
        data["documentEndDate"] = this.documentEndDate ? this.documentEndDate.toISOString() : <any>undefined;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        return data;
    }
}

export interface ICcnSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string | undefined;
    participantId?: string | undefined;
    hcpcsCode?: string | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    documentStartDate?: Date | undefined;
    documentEndDate?: Date | undefined;
    statuses?: CCNStatus[] | undefined;
}

export class ClaimAuth implements IClaimAuth {
    acn?: string | undefined;
    authCode?: string | undefined;
    diagnosisCode?: string | undefined;
    insuredId?: string | undefined;
    billCode?: string | undefined;
    servCode?: string | undefined;
    ccnPaidCount?: number | undefined;
    unitRange?: number | undefined;
    amountRange?: number | undefined;
    rangeAmount?: number | undefined;
    budgetAmount?: number | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    unitRate?: number | undefined;
    rangeUnits?: number | undefined;

    constructor(data?: IClaimAuth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acn = _data["acn"];
            this.authCode = _data["authCode"];
            this.diagnosisCode = _data["diagnosisCode"];
            this.insuredId = _data["insuredId"];
            this.billCode = _data["billCode"];
            this.servCode = _data["servCode"];
            this.ccnPaidCount = _data["ccnPaidCount"];
            this.unitRange = _data["unitRange"];
            this.amountRange = _data["amountRange"];
            this.rangeAmount = _data["rangeAmount"];
            this.budgetAmount = _data["budgetAmount"];
            this.serviceStartDate = _data["serviceStartDate"] ? new Date(_data["serviceStartDate"].toString()) : <any>undefined;
            this.serviceEndDate = _data["serviceEndDate"] ? new Date(_data["serviceEndDate"].toString()) : <any>undefined;
            this.unitRate = _data["unitRate"];
            this.rangeUnits = _data["rangeUnits"];
        }
    }

    static fromJS(data: any): ClaimAuth {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAuth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acn"] = this.acn;
        data["authCode"] = this.authCode;
        data["diagnosisCode"] = this.diagnosisCode;
        data["insuredId"] = this.insuredId;
        data["billCode"] = this.billCode;
        data["servCode"] = this.servCode;
        data["ccnPaidCount"] = this.ccnPaidCount;
        data["unitRange"] = this.unitRange;
        data["amountRange"] = this.amountRange;
        data["rangeAmount"] = this.rangeAmount;
        data["budgetAmount"] = this.budgetAmount;
        data["serviceStartDate"] = this.serviceStartDate ? this.serviceStartDate.toISOString() : <any>undefined;
        data["serviceEndDate"] = this.serviceEndDate ? this.serviceEndDate.toISOString() : <any>undefined;
        data["unitRate"] = this.unitRate;
        data["rangeUnits"] = this.rangeUnits;
        return data;
    }
}

export interface IClaimAuth {
    acn?: string | undefined;
    authCode?: string | undefined;
    diagnosisCode?: string | undefined;
    insuredId?: string | undefined;
    billCode?: string | undefined;
    servCode?: string | undefined;
    ccnPaidCount?: number | undefined;
    unitRange?: number | undefined;
    amountRange?: number | undefined;
    rangeAmount?: number | undefined;
    budgetAmount?: number | undefined;
    serviceStartDate?: Date | undefined;
    serviceEndDate?: Date | undefined;
    unitRate?: number | undefined;
    rangeUnits?: number | undefined;
}

export class ClaimBatchDTO implements IClaimBatchDTO {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    batchNumber?: string | undefined;
    mbccnId?: number;
    status?: number;
    payor?: string | undefined;
    batchType?: string | undefined;
    program?: string | undefined;
    totalBillAmount?: number;
    totalPayrollAmount?: number;
    interest?: number | undefined;
    writeOffAmount?: number | undefined;
    isProcessing?: boolean | undefined;
    readonly statusText?: string | undefined;

    constructor(data?: IClaimBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.batchNumber = _data["batchNumber"];
            this.mbccnId = _data["mbccnId"];
            this.status = _data["status"];
            this.payor = _data["payor"];
            this.batchType = _data["batchType"];
            this.program = _data["program"];
            this.totalBillAmount = _data["totalBillAmount"];
            this.totalPayrollAmount = _data["totalPayrollAmount"];
            this.interest = _data["interest"];
            this.writeOffAmount = _data["writeOffAmount"];
            this.isProcessing = _data["isProcessing"];
            (<any>this).statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): ClaimBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["batchNumber"] = this.batchNumber;
        data["mbccnId"] = this.mbccnId;
        data["status"] = this.status;
        data["payor"] = this.payor;
        data["batchType"] = this.batchType;
        data["program"] = this.program;
        data["totalBillAmount"] = this.totalBillAmount;
        data["totalPayrollAmount"] = this.totalPayrollAmount;
        data["interest"] = this.interest;
        data["writeOffAmount"] = this.writeOffAmount;
        data["isProcessing"] = this.isProcessing;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IClaimBatchDTO {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    batchNumber?: string | undefined;
    mbccnId?: number;
    status?: number;
    payor?: string | undefined;
    batchType?: string | undefined;
    program?: string | undefined;
    totalBillAmount?: number;
    totalPayrollAmount?: number;
    interest?: number | undefined;
    writeOffAmount?: number | undefined;
    isProcessing?: boolean | undefined;
    statusText?: string | undefined;
}

export class ClaimBatchDTOGridResponseBase implements IClaimBatchDTOGridResponseBase {
    items?: ClaimBatchDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ClaimBatchDTO;

    constructor(data?: IClaimBatchDTOGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClaimBatchDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ClaimBatchDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimBatchDTOGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimBatchDTOGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClaimBatchDTOGridResponseBase {
    items?: ClaimBatchDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ClaimBatchDTO;
}

export class ClaimBatchSubscriberDetail implements IClaimBatchSubscriberDetail {
    group?: string | undefined;
    participantId?: string | undefined;
    payorCode?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    insuredId?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IClaimBatchSubscriberDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.participantId = _data["participantId"];
            this.payorCode = _data["payorCode"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.insuredId = _data["insuredId"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimBatchSubscriberDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimBatchSubscriberDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["participantId"] = this.participantId;
        data["payorCode"] = this.payorCode;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["insuredId"] = this.insuredId;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClaimBatchSubscriberDetail {
    group?: string | undefined;
    participantId?: string | undefined;
    payorCode?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    insuredId?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class ClaimCreationTypeResponse implements IClaimCreationTypeResponse {
    id?: number;
    description?: string | undefined;
    enableLineGrp?: boolean;
    enableClaimGrp?: boolean;
    enableClaimsPerBatch?: boolean;
    enableLinesPerClaim?: boolean;
    isEdiType?: boolean;

    constructor(data?: IClaimCreationTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.enableLineGrp = _data["enableLineGrp"];
            this.enableClaimGrp = _data["enableClaimGrp"];
            this.enableClaimsPerBatch = _data["enableClaimsPerBatch"];
            this.enableLinesPerClaim = _data["enableLinesPerClaim"];
            this.isEdiType = _data["isEdiType"];
        }
    }

    static fromJS(data: any): ClaimCreationTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimCreationTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["enableLineGrp"] = this.enableLineGrp;
        data["enableClaimGrp"] = this.enableClaimGrp;
        data["enableClaimsPerBatch"] = this.enableClaimsPerBatch;
        data["enableLinesPerClaim"] = this.enableLinesPerClaim;
        data["isEdiType"] = this.isEdiType;
        return data;
    }
}

export interface IClaimCreationTypeResponse {
    id?: number;
    description?: string | undefined;
    enableLineGrp?: boolean;
    enableClaimGrp?: boolean;
    enableClaimsPerBatch?: boolean;
    enableLinesPerClaim?: boolean;
    isEdiType?: boolean;
}

export class ClaimDetailFlyoutRequest implements IClaimDetailFlyoutRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    ccn?: string | undefined;
    companyId?: number;

    constructor(data?: IClaimDetailFlyoutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.ccn = _data["ccn"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ClaimDetailFlyoutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimDetailFlyoutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["ccn"] = this.ccn;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IClaimDetailFlyoutRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    ccn?: string | undefined;
    companyId?: number;
}

export enum ClaimGrouping {
    Daily = "Daily",
    Weekly = "Weekly",
    Shift = "Shift",
}

export class ClaimSummaryInquiryDetailDto implements IClaimSummaryInquiryDetailDto {
    id?: number;
    ccn?: string | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    claimDate?: Date;
    participantID?: string | undefined;
    participantName?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    totalBillAmount?: number;
    totalPaidAmount?: number;
    writeOffAmount?: number;
    status?: CCNStatus;
    startDate?: Date;
    endDate?: Date;
    batchNumber?: string | undefined;
    remainingAmount?: number;
    billCode?: string | undefined;

    constructor(data?: IClaimSummaryInquiryDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ccn = _data["ccn"];
            this.payor = _data["payor"];
            this.program = _data["program"];
            this.claimDate = _data["claimDate"] ? new Date(_data["claimDate"].toString()) : <any>undefined;
            this.participantID = _data["participantID"];
            this.participantName = _data["participantName"];
            this.authCode = _data["authCode"];
            this.servCode = _data["servCode"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
            this.totalBillAmount = _data["totalBillAmount"];
            this.totalPaidAmount = _data["totalPaidAmount"];
            this.writeOffAmount = _data["writeOffAmount"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.batchNumber = _data["batchNumber"];
            this.remainingAmount = _data["remainingAmount"];
            this.billCode = _data["billCode"];
        }
    }

    static fromJS(data: any): ClaimSummaryInquiryDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimSummaryInquiryDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ccn"] = this.ccn;
        data["payor"] = this.payor;
        data["program"] = this.program;
        data["claimDate"] = this.claimDate ? this.claimDate.toISOString() : <any>undefined;
        data["participantID"] = this.participantID;
        data["participantName"] = this.participantName;
        data["authCode"] = this.authCode;
        data["servCode"] = this.servCode;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        data["totalBillAmount"] = this.totalBillAmount;
        data["totalPaidAmount"] = this.totalPaidAmount;
        data["writeOffAmount"] = this.writeOffAmount;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["remainingAmount"] = this.remainingAmount;
        data["billCode"] = this.billCode;
        return data;
    }
}

export interface IClaimSummaryInquiryDetailDto {
    id?: number;
    ccn?: string | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    claimDate?: Date;
    participantID?: string | undefined;
    participantName?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    totalBillAmount?: number;
    totalPaidAmount?: number;
    writeOffAmount?: number;
    status?: CCNStatus;
    startDate?: Date;
    endDate?: Date;
    batchNumber?: string | undefined;
    remainingAmount?: number;
    billCode?: string | undefined;
}

export class ClaimSummaryInquiryDetailDtoClaimSummaryGridResponse implements IClaimSummaryInquiryDetailDtoClaimSummaryGridResponse {
    items?: ClaimSummaryInquiryDetailDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ClaimSummaryInquiryDetailDto;
    ccnIds?: number[] | undefined;
    error?: ResponseModel;

    constructor(data?: IClaimSummaryInquiryDetailDtoClaimSummaryGridResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClaimSummaryInquiryDetailDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ClaimSummaryInquiryDetailDto.fromJS(_data["data"]) : <any>undefined;
            if (Array.isArray(_data["ccnIds"])) {
                this.ccnIds = [] as any;
                for (let item of _data["ccnIds"])
                    this.ccnIds!.push(item);
            }
            this.error = _data["error"] ? ResponseModel.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimSummaryInquiryDetailDtoClaimSummaryGridResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimSummaryInquiryDetailDtoClaimSummaryGridResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (Array.isArray(this.ccnIds)) {
            data["ccnIds"] = [];
            for (let item of this.ccnIds)
                data["ccnIds"].push(item);
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClaimSummaryInquiryDetailDtoClaimSummaryGridResponse {
    items?: ClaimSummaryInquiryDetailDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ClaimSummaryInquiryDetailDto;
    ccnIds?: number[] | undefined;
    error?: ResponseModel;
}

export class ClaimSummaryRequestDto implements IClaimSummaryRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string[] | undefined;
    program?: string[] | undefined;
    icn?: string | undefined;
    startClaimDate?: Date | undefined;
    endClaimDate?: Date | undefined;
    ignoredClaimStatus?: string | undefined;
    status?: CCNStatus[] | undefined;
    participantId?: string | undefined;
    filterType?: string | undefined;

    constructor(data?: IClaimSummaryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["payor"])) {
                this.payor = [] as any;
                for (let item of _data["payor"])
                    this.payor!.push(item);
            }
            if (Array.isArray(_data["program"])) {
                this.program = [] as any;
                for (let item of _data["program"])
                    this.program!.push(item);
            }
            this.icn = _data["icn"];
            this.startClaimDate = _data["startClaimDate"] ? new Date(_data["startClaimDate"].toString()) : <any>undefined;
            this.endClaimDate = _data["endClaimDate"] ? new Date(_data["endClaimDate"].toString()) : <any>undefined;
            this.ignoredClaimStatus = _data["ignoredClaimStatus"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.participantId = _data["participantId"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): ClaimSummaryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimSummaryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.payor)) {
            data["payor"] = [];
            for (let item of this.payor)
                data["payor"].push(item);
        }
        if (Array.isArray(this.program)) {
            data["program"] = [];
            for (let item of this.program)
                data["program"].push(item);
        }
        data["icn"] = this.icn;
        data["startClaimDate"] = this.startClaimDate ? this.startClaimDate.toISOString() : <any>undefined;
        data["endClaimDate"] = this.endClaimDate ? this.endClaimDate.toISOString() : <any>undefined;
        data["ignoredClaimStatus"] = this.ignoredClaimStatus;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["participantId"] = this.participantId;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IClaimSummaryRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string[] | undefined;
    program?: string[] | undefined;
    icn?: string | undefined;
    startClaimDate?: Date | undefined;
    endClaimDate?: Date | undefined;
    ignoredClaimStatus?: string | undefined;
    status?: CCNStatus[] | undefined;
    participantId?: string | undefined;
    filterType?: string | undefined;
}

export class ClaimTemplateRequestDto implements IClaimTemplateRequestDto {
    id?: number;
    templateName?: string | undefined;
    companyId?: number;
    description?: string | undefined;
    payorId?: string | undefined;
    programId?: string | undefined;
    programConfigId?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    timelyOnly?: boolean;
    claimType?: string | undefined;
    participantId?: string | undefined;
    authId?: string | undefined;
    authCode?: string | undefined;
    servCodeId?: string | undefined;
    servCode?: string | undefined;
    icn?: string | undefined;
    serviceCodeList?: ServiceCode[] | undefined;
    docType?: string | undefined;
    cutoffDateTime?: Date | undefined;

    constructor(data?: IClaimTemplateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.programConfigId = _data["programConfigId"];
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.timelyOnly = _data["timelyOnly"];
            this.claimType = _data["claimType"];
            this.participantId = _data["participantId"];
            this.authId = _data["authId"];
            this.authCode = _data["authCode"];
            this.servCodeId = _data["servCodeId"];
            this.servCode = _data["servCode"];
            this.icn = _data["icn"];
            if (Array.isArray(_data["serviceCodeList"])) {
                this.serviceCodeList = [] as any;
                for (let item of _data["serviceCodeList"])
                    this.serviceCodeList!.push(ServiceCode.fromJS(item));
            }
            this.docType = _data["docType"];
            this.cutoffDateTime = _data["cutoffDateTime"] ? new Date(_data["cutoffDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimTemplateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTemplateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["programConfigId"] = this.programConfigId;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["timelyOnly"] = this.timelyOnly;
        data["claimType"] = this.claimType;
        data["participantId"] = this.participantId;
        data["authId"] = this.authId;
        data["authCode"] = this.authCode;
        data["servCodeId"] = this.servCodeId;
        data["servCode"] = this.servCode;
        data["icn"] = this.icn;
        if (Array.isArray(this.serviceCodeList)) {
            data["serviceCodeList"] = [];
            for (let item of this.serviceCodeList)
                data["serviceCodeList"].push(item.toJSON());
        }
        data["docType"] = this.docType;
        data["cutoffDateTime"] = this.cutoffDateTime ? this.cutoffDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClaimTemplateRequestDto {
    id?: number;
    templateName?: string | undefined;
    companyId?: number;
    description?: string | undefined;
    payorId?: string | undefined;
    programId?: string | undefined;
    programConfigId?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    timelyOnly?: boolean;
    claimType?: string | undefined;
    participantId?: string | undefined;
    authId?: string | undefined;
    authCode?: string | undefined;
    servCodeId?: string | undefined;
    servCode?: string | undefined;
    icn?: string | undefined;
    serviceCodeList?: ServiceCode[] | undefined;
    docType?: string | undefined;
    cutoffDateTime?: Date | undefined;
}

export class ClaimTemplateResponseByIdDto implements IClaimTemplateResponseByIdDto {
    id?: number;
    templateName?: string | undefined;
    description?: string | undefined;
    payorId?: string | undefined;
    programId?: string | undefined;
    programConfig?: ProgramConfigurationResponseDto;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    timelyOnly?: boolean;
    claimTypeFilter?: string | undefined;
    participantId?: string | undefined;
    authId?: string | undefined;
    authCode?: string | undefined;
    servCodeId?: string | undefined;
    servCode?: string | undefined;
    icn?: string | undefined;
    docTypeFilter?: string | undefined;
    cutoffDateTime?: Date | undefined;

    constructor(data?: IClaimTemplateResponseByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.programConfig = _data["programConfig"] ? ProgramConfigurationResponseDto.fromJS(_data["programConfig"]) : <any>undefined;
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.timelyOnly = _data["timelyOnly"];
            this.claimTypeFilter = _data["claimTypeFilter"];
            this.participantId = _data["participantId"];
            this.authId = _data["authId"];
            this.authCode = _data["authCode"];
            this.servCodeId = _data["servCodeId"];
            this.servCode = _data["servCode"];
            this.icn = _data["icn"];
            this.docTypeFilter = _data["docTypeFilter"];
            this.cutoffDateTime = _data["cutoffDateTime"] ? new Date(_data["cutoffDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimTemplateResponseByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTemplateResponseByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["programConfig"] = this.programConfig ? this.programConfig.toJSON() : <any>undefined;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["timelyOnly"] = this.timelyOnly;
        data["claimTypeFilter"] = this.claimTypeFilter;
        data["participantId"] = this.participantId;
        data["authId"] = this.authId;
        data["authCode"] = this.authCode;
        data["servCodeId"] = this.servCodeId;
        data["servCode"] = this.servCode;
        data["icn"] = this.icn;
        data["docTypeFilter"] = this.docTypeFilter;
        data["cutoffDateTime"] = this.cutoffDateTime ? this.cutoffDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClaimTemplateResponseByIdDto {
    id?: number;
    templateName?: string | undefined;
    description?: string | undefined;
    payorId?: string | undefined;
    programId?: string | undefined;
    programConfig?: ProgramConfigurationResponseDto;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    timelyOnly?: boolean;
    claimTypeFilter?: string | undefined;
    participantId?: string | undefined;
    authId?: string | undefined;
    authCode?: string | undefined;
    servCodeId?: string | undefined;
    servCode?: string | undefined;
    icn?: string | undefined;
    docTypeFilter?: string | undefined;
    cutoffDateTime?: Date | undefined;
}

export class ClaimTemplateResponseDto implements IClaimTemplateResponseDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    templateName?: string | undefined;
    description?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;

    constructor(data?: IClaimTemplateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimTemplateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTemplateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClaimTemplateResponseDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    templateName?: string | undefined;
    description?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
}

export class ClaimTemplateResponseDtoGridResponseBase implements IClaimTemplateResponseDtoGridResponseBase {
    items?: ClaimTemplateResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ClaimTemplateResponseDto;

    constructor(data?: IClaimTemplateResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClaimTemplateResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ClaimTemplateResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimTemplateResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTemplateResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClaimTemplateResponseDtoGridResponseBase {
    items?: ClaimTemplateResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ClaimTemplateResponseDto;
}

export class ClaimTemplateSearchRequest implements IClaimTemplateSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string | undefined;
    program?: string[] | undefined;
    timeOnly?: boolean | undefined;
    claimTypes?: string | undefined;
    cutoffDateTime?: Date | undefined;
    startServiceDate?: Date | undefined;
    endDate?: Date | undefined;
    participantId?: string | undefined;
    authCode?: string[] | undefined;
    serviceCode?: string[] | undefined;
    programConfigurations?: ProgramConfigurationResponseDto[] | undefined;
    templateName?: string | undefined;
    templateDescription?: string | undefined;
    isOriginalType?: boolean | undefined;
    isAdjustmentType?: boolean | undefined;
    icn?: string | undefined;

    constructor(data?: IClaimTemplateSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.payor = _data["payor"];
            if (Array.isArray(_data["program"])) {
                this.program = [] as any;
                for (let item of _data["program"])
                    this.program!.push(item);
            }
            this.timeOnly = _data["timeOnly"];
            this.claimTypes = _data["claimTypes"];
            this.cutoffDateTime = _data["cutoffDateTime"] ? new Date(_data["cutoffDateTime"].toString()) : <any>undefined;
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.participantId = _data["participantId"];
            if (Array.isArray(_data["authCode"])) {
                this.authCode = [] as any;
                for (let item of _data["authCode"])
                    this.authCode!.push(item);
            }
            if (Array.isArray(_data["serviceCode"])) {
                this.serviceCode = [] as any;
                for (let item of _data["serviceCode"])
                    this.serviceCode!.push(item);
            }
            if (Array.isArray(_data["programConfigurations"])) {
                this.programConfigurations = [] as any;
                for (let item of _data["programConfigurations"])
                    this.programConfigurations!.push(ProgramConfigurationResponseDto.fromJS(item));
            }
            this.templateName = _data["templateName"];
            this.templateDescription = _data["templateDescription"];
            this.isOriginalType = _data["isOriginalType"];
            this.isAdjustmentType = _data["isAdjustmentType"];
            this.icn = _data["icn"];
        }
    }

    static fromJS(data: any): ClaimTemplateSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimTemplateSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["payor"] = this.payor;
        if (Array.isArray(this.program)) {
            data["program"] = [];
            for (let item of this.program)
                data["program"].push(item);
        }
        data["timeOnly"] = this.timeOnly;
        data["claimTypes"] = this.claimTypes;
        data["cutoffDateTime"] = this.cutoffDateTime ? this.cutoffDateTime.toISOString() : <any>undefined;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["participantId"] = this.participantId;
        if (Array.isArray(this.authCode)) {
            data["authCode"] = [];
            for (let item of this.authCode)
                data["authCode"].push(item);
        }
        if (Array.isArray(this.serviceCode)) {
            data["serviceCode"] = [];
            for (let item of this.serviceCode)
                data["serviceCode"].push(item);
        }
        if (Array.isArray(this.programConfigurations)) {
            data["programConfigurations"] = [];
            for (let item of this.programConfigurations)
                data["programConfigurations"].push(item.toJSON());
        }
        data["templateName"] = this.templateName;
        data["templateDescription"] = this.templateDescription;
        data["isOriginalType"] = this.isOriginalType;
        data["isAdjustmentType"] = this.isAdjustmentType;
        data["icn"] = this.icn;
        return data;
    }
}

export interface IClaimTemplateSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string | undefined;
    program?: string[] | undefined;
    timeOnly?: boolean | undefined;
    claimTypes?: string | undefined;
    cutoffDateTime?: Date | undefined;
    startServiceDate?: Date | undefined;
    endDate?: Date | undefined;
    participantId?: string | undefined;
    authCode?: string[] | undefined;
    serviceCode?: string[] | undefined;
    programConfigurations?: ProgramConfigurationResponseDto[] | undefined;
    templateName?: string | undefined;
    templateDescription?: string | undefined;
    isOriginalType?: boolean | undefined;
    isAdjustmentType?: boolean | undefined;
    icn?: string | undefined;
}

export class ClaimlineDenialReasonsRequest implements IClaimlineDenialReasonsRequest {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    claimLineIds?: number[] | undefined;
    notes?: string | undefined;
    eventDate?: Date;
    adjustmentCodeIds?: number[] | undefined;
    remarkCodeIds?: number[] | undefined;
    groupCodeIds?: number[] | undefined;

    constructor(data?: IClaimlineDenialReasonsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["claimLineIds"])) {
                this.claimLineIds = [] as any;
                for (let item of _data["claimLineIds"])
                    this.claimLineIds!.push(item);
            }
            this.notes = _data["notes"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["adjustmentCodeIds"])) {
                this.adjustmentCodeIds = [] as any;
                for (let item of _data["adjustmentCodeIds"])
                    this.adjustmentCodeIds!.push(item);
            }
            if (Array.isArray(_data["remarkCodeIds"])) {
                this.remarkCodeIds = [] as any;
                for (let item of _data["remarkCodeIds"])
                    this.remarkCodeIds!.push(item);
            }
            if (Array.isArray(_data["groupCodeIds"])) {
                this.groupCodeIds = [] as any;
                for (let item of _data["groupCodeIds"])
                    this.groupCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ClaimlineDenialReasonsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimlineDenialReasonsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.claimLineIds)) {
            data["claimLineIds"] = [];
            for (let item of this.claimLineIds)
                data["claimLineIds"].push(item);
        }
        data["notes"] = this.notes;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        if (Array.isArray(this.adjustmentCodeIds)) {
            data["adjustmentCodeIds"] = [];
            for (let item of this.adjustmentCodeIds)
                data["adjustmentCodeIds"].push(item);
        }
        if (Array.isArray(this.remarkCodeIds)) {
            data["remarkCodeIds"] = [];
            for (let item of this.remarkCodeIds)
                data["remarkCodeIds"].push(item);
        }
        if (Array.isArray(this.groupCodeIds)) {
            data["groupCodeIds"] = [];
            for (let item of this.groupCodeIds)
                data["groupCodeIds"].push(item);
        }
        return data;
    }
}

export interface IClaimlineDenialReasonsRequest {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    claimLineIds?: number[] | undefined;
    notes?: string | undefined;
    eventDate?: Date;
    adjustmentCodeIds?: number[] | undefined;
    remarkCodeIds?: number[] | undefined;
    groupCodeIds?: number[] | undefined;
}

export class ClaimlineOverrideStatusRequest implements IClaimlineOverrideStatusRequest {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    claimLineIds?: number[] | undefined;
    notes?: string | undefined;
    eventDate?: Date;
    action?: LCNOverideAction;

    constructor(data?: IClaimlineOverrideStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["claimLineIds"])) {
                this.claimLineIds = [] as any;
                for (let item of _data["claimLineIds"])
                    this.claimLineIds!.push(item);
            }
            this.notes = _data["notes"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): ClaimlineOverrideStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimlineOverrideStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.claimLineIds)) {
            data["claimLineIds"] = [];
            for (let item of this.claimLineIds)
                data["claimLineIds"].push(item);
        }
        data["notes"] = this.notes;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }
}

export interface IClaimlineOverrideStatusRequest {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    claimLineIds?: number[] | undefined;
    notes?: string | undefined;
    eventDate?: Date;
    action?: LCNOverideAction;
}

export class ClaimsProgramConfigFilterRequest implements IClaimsProgramConfigFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    ids?: number[] | undefined;

    constructor(data?: IClaimsProgramConfigFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.searchParameter = _data["searchParameter"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ClaimsProgramConfigFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsProgramConfigFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["searchParameter"] = this.searchParameter;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IClaimsProgramConfigFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    ids?: number[] | undefined;
}

export class ClaimsProgramConfigRequestDto implements IClaimsProgramConfigRequestDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    template?: string | undefined;
    programType?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    templateDesc?: string | undefined;
    payorId?: number;
    payor?: string | undefined;
    programId!: number;
    program?: string | undefined;
    ediConfigId?: number | undefined;
    templateName?: string | undefined;
    payOnlyPaidRecords?: boolean;
    caregiverNPI?: boolean;
    overrideAuthRequired?: boolean;
    attendingProviderRequired?: boolean;
    referringProviderRequired?: boolean;
    passportIdRequired?: boolean;
    timelyFilingDays!: number;
    timelyReworkDays!: number;
    threshold!: number;
    claimFileDestination!: string;
    manualClaimFileDestination!: string;
    claimCreationTypeId!: number;
    lineGrouping!: LineGrouping;
    claimGrouping!: ClaimGrouping;
    lateTime?: LateTime;
    claimsPerBatch!: number;
    linesPerClaim!: number;
    copay?: boolean;
    copayType?: CopayType;
    copayValue?: number | undefined;
    copayPayerId?: number | undefined;
    copayPayer?: string | undefined;
    copayProgramId?: number | undefined;
    copayProgram?: string | undefined;
    copayFrequency?: number;
    companyId?: number;
    payerPortal?: string | undefined;
    caregiverPartitioning?: boolean;
    overtimeBilling?: OvertimeBilling;
    otStartDay?: DayOfWeek;
    otEndDay?: DayOfWeek;
    otThresholdHours?: number | undefined;
    authNumberPartitioning?: boolean;

    constructor(data?: IClaimsProgramConfigRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.template = _data["template"];
            this.programType = _data["programType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.templateDesc = _data["templateDesc"];
            this.payorId = _data["payorId"];
            this.payor = _data["payor"];
            this.programId = _data["programId"];
            this.program = _data["program"];
            this.ediConfigId = _data["ediConfigId"];
            this.templateName = _data["templateName"];
            this.payOnlyPaidRecords = _data["payOnlyPaidRecords"];
            this.caregiverNPI = _data["caregiverNPI"];
            this.overrideAuthRequired = _data["overrideAuthRequired"];
            this.attendingProviderRequired = _data["attendingProviderRequired"];
            this.referringProviderRequired = _data["referringProviderRequired"];
            this.passportIdRequired = _data["passportIdRequired"];
            this.timelyFilingDays = _data["timelyFilingDays"];
            this.timelyReworkDays = _data["timelyReworkDays"];
            this.threshold = _data["threshold"];
            this.claimFileDestination = _data["claimFileDestination"];
            this.manualClaimFileDestination = _data["manualClaimFileDestination"];
            this.claimCreationTypeId = _data["claimCreationTypeId"];
            this.lineGrouping = _data["lineGrouping"];
            this.claimGrouping = _data["claimGrouping"];
            this.lateTime = _data["lateTime"];
            this.claimsPerBatch = _data["claimsPerBatch"];
            this.linesPerClaim = _data["linesPerClaim"];
            this.copay = _data["copay"];
            this.copayType = _data["copayType"];
            this.copayValue = _data["copayValue"];
            this.copayPayerId = _data["copayPayerId"];
            this.copayPayer = _data["copayPayer"];
            this.copayProgramId = _data["copayProgramId"];
            this.copayProgram = _data["copayProgram"];
            this.copayFrequency = _data["copayFrequency"];
            this.companyId = _data["companyId"];
            this.payerPortal = _data["payerPortal"];
            this.caregiverPartitioning = _data["caregiverPartitioning"];
            this.overtimeBilling = _data["overtimeBilling"];
            this.otStartDay = _data["otStartDay"];
            this.otEndDay = _data["otEndDay"];
            this.otThresholdHours = _data["otThresholdHours"];
            this.authNumberPartitioning = _data["authNumberPartitioning"];
        }
    }

    static fromJS(data: any): ClaimsProgramConfigRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsProgramConfigRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["template"] = this.template;
        data["programType"] = this.programType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["templateDesc"] = this.templateDesc;
        data["payorId"] = this.payorId;
        data["payor"] = this.payor;
        data["programId"] = this.programId;
        data["program"] = this.program;
        data["ediConfigId"] = this.ediConfigId;
        data["templateName"] = this.templateName;
        data["payOnlyPaidRecords"] = this.payOnlyPaidRecords;
        data["caregiverNPI"] = this.caregiverNPI;
        data["overrideAuthRequired"] = this.overrideAuthRequired;
        data["attendingProviderRequired"] = this.attendingProviderRequired;
        data["referringProviderRequired"] = this.referringProviderRequired;
        data["passportIdRequired"] = this.passportIdRequired;
        data["timelyFilingDays"] = this.timelyFilingDays;
        data["timelyReworkDays"] = this.timelyReworkDays;
        data["threshold"] = this.threshold;
        data["claimFileDestination"] = this.claimFileDestination;
        data["manualClaimFileDestination"] = this.manualClaimFileDestination;
        data["claimCreationTypeId"] = this.claimCreationTypeId;
        data["lineGrouping"] = this.lineGrouping;
        data["claimGrouping"] = this.claimGrouping;
        data["lateTime"] = this.lateTime;
        data["claimsPerBatch"] = this.claimsPerBatch;
        data["linesPerClaim"] = this.linesPerClaim;
        data["copay"] = this.copay;
        data["copayType"] = this.copayType;
        data["copayValue"] = this.copayValue;
        data["copayPayerId"] = this.copayPayerId;
        data["copayPayer"] = this.copayPayer;
        data["copayProgramId"] = this.copayProgramId;
        data["copayProgram"] = this.copayProgram;
        data["copayFrequency"] = this.copayFrequency;
        data["companyId"] = this.companyId;
        data["payerPortal"] = this.payerPortal;
        data["caregiverPartitioning"] = this.caregiverPartitioning;
        data["overtimeBilling"] = this.overtimeBilling;
        data["otStartDay"] = this.otStartDay;
        data["otEndDay"] = this.otEndDay;
        data["otThresholdHours"] = this.otThresholdHours;
        data["authNumberPartitioning"] = this.authNumberPartitioning;
        return data;
    }
}

export interface IClaimsProgramConfigRequestDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    template?: string | undefined;
    programType?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    templateDesc?: string | undefined;
    payorId?: number;
    payor?: string | undefined;
    programId: number;
    program?: string | undefined;
    ediConfigId?: number | undefined;
    templateName?: string | undefined;
    payOnlyPaidRecords?: boolean;
    caregiverNPI?: boolean;
    overrideAuthRequired?: boolean;
    attendingProviderRequired?: boolean;
    referringProviderRequired?: boolean;
    passportIdRequired?: boolean;
    timelyFilingDays: number;
    timelyReworkDays: number;
    threshold: number;
    claimFileDestination: string;
    manualClaimFileDestination: string;
    claimCreationTypeId: number;
    lineGrouping: LineGrouping;
    claimGrouping: ClaimGrouping;
    lateTime?: LateTime;
    claimsPerBatch: number;
    linesPerClaim: number;
    copay?: boolean;
    copayType?: CopayType;
    copayValue?: number | undefined;
    copayPayerId?: number | undefined;
    copayPayer?: string | undefined;
    copayProgramId?: number | undefined;
    copayProgram?: string | undefined;
    copayFrequency?: number;
    companyId?: number;
    payerPortal?: string | undefined;
    caregiverPartitioning?: boolean;
    overtimeBilling?: OvertimeBilling;
    otStartDay?: DayOfWeek;
    otEndDay?: DayOfWeek;
    otThresholdHours?: number | undefined;
    authNumberPartitioning?: boolean;
}

export class ClaimsProgramConfigResponseDto implements IClaimsProgramConfigResponseDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    template?: string | undefined;
    payorId?: string | undefined;
    programType?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IClaimsProgramConfigResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.template = _data["template"];
            this.payorId = _data["payorId"];
            this.programType = _data["programType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimsProgramConfigResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsProgramConfigResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["template"] = this.template;
        data["payorId"] = this.payorId;
        data["programType"] = this.programType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClaimsProgramConfigResponseDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    template?: string | undefined;
    payorId?: string | undefined;
    programType?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class ClaimsProgramConfigResponseDtoGridResponseBase implements IClaimsProgramConfigResponseDtoGridResponseBase {
    items?: ClaimsProgramConfigResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ClaimsProgramConfigResponseDto;

    constructor(data?: IClaimsProgramConfigResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClaimsProgramConfigResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ClaimsProgramConfigResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimsProgramConfigResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsProgramConfigResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClaimsProgramConfigResponseDtoGridResponseBase {
    items?: ClaimsProgramConfigResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ClaimsProgramConfigResponseDto;
}

export class ClaimsProgramConfigurationResponseDto implements IClaimsProgramConfigurationResponseDto {
    id?: number;
    template?: string | undefined;
    templateDesc?: string | undefined;
    payorId?: number;
    payorDesc?: string | undefined;
    payorName?: string | undefined;
    programId?: number;
    progNbr?: string | undefined;
    programName?: string | undefined;
    ediConfigId?: number;
    templateName?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    payOnlyPaidRecords?: boolean;
    caregiverNpi?: boolean;
    overrideAuthRequired?: boolean;
    attendingProviderRequired?: boolean;
    referringProviderRequired?: boolean;
    passportIdRequired?: boolean;
    timelyFilingDays?: number;
    timelyReworkDays?: number;
    threshold?: number;
    claimFileDestination?: string | undefined;
    manualClaimFileDestination?: string | undefined;
    claimCreationTypeId?: number;
    lineGrouping?: LineGrouping;
    claimGrouping?: ClaimGrouping;
    claimsPerBatch?: number;
    linesPerClaim?: number;
    copay?: boolean;
    copayType?: number | undefined;
    copayValue?: number | undefined;
    copayPayerId?: number | undefined;
    copayFrequency?: number;
    companyId?: number;
    payerPortal?: string | undefined;
    copayPayorDesc?: string | undefined;
    copayPayorName?: string | undefined;
    copayProgramId?: number | undefined;
    copayProgramNbr?: string | undefined;
    copayProgramName?: string | undefined;
    lateTime?: LateTime;
    caregiverPartitioning?: boolean;
    overtimeBilling?: number | undefined;
    otStartDay?: number | undefined;
    otEndDay?: number | undefined;
    otThresholdHours?: number | undefined;
    authNumberPartitioning?: boolean;

    constructor(data?: IClaimsProgramConfigurationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.template = _data["template"];
            this.templateDesc = _data["templateDesc"];
            this.payorId = _data["payorId"];
            this.payorDesc = _data["payorDesc"];
            this.payorName = _data["payorName"];
            this.programId = _data["programId"];
            this.progNbr = _data["progNbr"];
            this.programName = _data["programName"];
            this.ediConfigId = _data["ediConfigId"];
            this.templateName = _data["templateName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.payOnlyPaidRecords = _data["payOnlyPaidRecords"];
            this.caregiverNpi = _data["caregiverNpi"];
            this.overrideAuthRequired = _data["overrideAuthRequired"];
            this.attendingProviderRequired = _data["attendingProviderRequired"];
            this.referringProviderRequired = _data["referringProviderRequired"];
            this.passportIdRequired = _data["passportIdRequired"];
            this.timelyFilingDays = _data["timelyFilingDays"];
            this.timelyReworkDays = _data["timelyReworkDays"];
            this.threshold = _data["threshold"];
            this.claimFileDestination = _data["claimFileDestination"];
            this.manualClaimFileDestination = _data["manualClaimFileDestination"];
            this.claimCreationTypeId = _data["claimCreationTypeId"];
            this.lineGrouping = _data["lineGrouping"];
            this.claimGrouping = _data["claimGrouping"];
            this.claimsPerBatch = _data["claimsPerBatch"];
            this.linesPerClaim = _data["linesPerClaim"];
            this.copay = _data["copay"];
            this.copayType = _data["copayType"];
            this.copayValue = _data["copayValue"];
            this.copayPayerId = _data["copayPayerId"];
            this.copayFrequency = _data["copayFrequency"];
            this.companyId = _data["companyId"];
            this.payerPortal = _data["payerPortal"];
            this.copayPayorDesc = _data["copayPayorDesc"];
            this.copayPayorName = _data["copayPayorName"];
            this.copayProgramId = _data["copayProgramId"];
            this.copayProgramNbr = _data["copayProgramNbr"];
            this.copayProgramName = _data["copayProgramName"];
            this.lateTime = _data["lateTime"];
            this.caregiverPartitioning = _data["caregiverPartitioning"];
            this.overtimeBilling = _data["overtimeBilling"];
            this.otStartDay = _data["otStartDay"];
            this.otEndDay = _data["otEndDay"];
            this.otThresholdHours = _data["otThresholdHours"];
            this.authNumberPartitioning = _data["authNumberPartitioning"];
        }
    }

    static fromJS(data: any): ClaimsProgramConfigurationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsProgramConfigurationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["template"] = this.template;
        data["templateDesc"] = this.templateDesc;
        data["payorId"] = this.payorId;
        data["payorDesc"] = this.payorDesc;
        data["payorName"] = this.payorName;
        data["programId"] = this.programId;
        data["progNbr"] = this.progNbr;
        data["programName"] = this.programName;
        data["ediConfigId"] = this.ediConfigId;
        data["templateName"] = this.templateName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["payOnlyPaidRecords"] = this.payOnlyPaidRecords;
        data["caregiverNpi"] = this.caregiverNpi;
        data["overrideAuthRequired"] = this.overrideAuthRequired;
        data["attendingProviderRequired"] = this.attendingProviderRequired;
        data["referringProviderRequired"] = this.referringProviderRequired;
        data["passportIdRequired"] = this.passportIdRequired;
        data["timelyFilingDays"] = this.timelyFilingDays;
        data["timelyReworkDays"] = this.timelyReworkDays;
        data["threshold"] = this.threshold;
        data["claimFileDestination"] = this.claimFileDestination;
        data["manualClaimFileDestination"] = this.manualClaimFileDestination;
        data["claimCreationTypeId"] = this.claimCreationTypeId;
        data["lineGrouping"] = this.lineGrouping;
        data["claimGrouping"] = this.claimGrouping;
        data["claimsPerBatch"] = this.claimsPerBatch;
        data["linesPerClaim"] = this.linesPerClaim;
        data["copay"] = this.copay;
        data["copayType"] = this.copayType;
        data["copayValue"] = this.copayValue;
        data["copayPayerId"] = this.copayPayerId;
        data["copayFrequency"] = this.copayFrequency;
        data["companyId"] = this.companyId;
        data["payerPortal"] = this.payerPortal;
        data["copayPayorDesc"] = this.copayPayorDesc;
        data["copayPayorName"] = this.copayPayorName;
        data["copayProgramId"] = this.copayProgramId;
        data["copayProgramNbr"] = this.copayProgramNbr;
        data["copayProgramName"] = this.copayProgramName;
        data["lateTime"] = this.lateTime;
        data["caregiverPartitioning"] = this.caregiverPartitioning;
        data["overtimeBilling"] = this.overtimeBilling;
        data["otStartDay"] = this.otStartDay;
        data["otEndDay"] = this.otEndDay;
        data["otThresholdHours"] = this.otThresholdHours;
        data["authNumberPartitioning"] = this.authNumberPartitioning;
        return data;
    }
}

export interface IClaimsProgramConfigurationResponseDto {
    id?: number;
    template?: string | undefined;
    templateDesc?: string | undefined;
    payorId?: number;
    payorDesc?: string | undefined;
    payorName?: string | undefined;
    programId?: number;
    progNbr?: string | undefined;
    programName?: string | undefined;
    ediConfigId?: number;
    templateName?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    payOnlyPaidRecords?: boolean;
    caregiverNpi?: boolean;
    overrideAuthRequired?: boolean;
    attendingProviderRequired?: boolean;
    referringProviderRequired?: boolean;
    passportIdRequired?: boolean;
    timelyFilingDays?: number;
    timelyReworkDays?: number;
    threshold?: number;
    claimFileDestination?: string | undefined;
    manualClaimFileDestination?: string | undefined;
    claimCreationTypeId?: number;
    lineGrouping?: LineGrouping;
    claimGrouping?: ClaimGrouping;
    claimsPerBatch?: number;
    linesPerClaim?: number;
    copay?: boolean;
    copayType?: number | undefined;
    copayValue?: number | undefined;
    copayPayerId?: number | undefined;
    copayFrequency?: number;
    companyId?: number;
    payerPortal?: string | undefined;
    copayPayorDesc?: string | undefined;
    copayPayorName?: string | undefined;
    copayProgramId?: number | undefined;
    copayProgramNbr?: string | undefined;
    copayProgramName?: string | undefined;
    lateTime?: LateTime;
    caregiverPartitioning?: boolean;
    overtimeBilling?: number | undefined;
    otStartDay?: number | undefined;
    otEndDay?: number | undefined;
    otThresholdHours?: number | undefined;
    authNumberPartitioning?: boolean;
}

export class ClaimsWriteOffDto implements IClaimsWriteOffDto {
    id?: number | undefined;
    claimId?: number | undefined;
    participantId?: string | undefined;
    batchId?: number | undefined;
    woCauseId?: number | undefined;
    writeOffAmount?: number;
    woCause?: string | undefined;
    woErrorTypeId?: number | undefined;
    woErrorType?: string | undefined;

    constructor(data?: IClaimsWriteOffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claimId = _data["claimId"];
            this.participantId = _data["participantId"];
            this.batchId = _data["batchId"];
            this.woCauseId = _data["woCauseId"];
            this.writeOffAmount = _data["writeOffAmount"];
            this.woCause = _data["woCause"];
            this.woErrorTypeId = _data["woErrorTypeId"];
            this.woErrorType = _data["woErrorType"];
        }
    }

    static fromJS(data: any): ClaimsWriteOffDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsWriteOffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claimId"] = this.claimId;
        data["participantId"] = this.participantId;
        data["batchId"] = this.batchId;
        data["woCauseId"] = this.woCauseId;
        data["writeOffAmount"] = this.writeOffAmount;
        data["woCause"] = this.woCause;
        data["woErrorTypeId"] = this.woErrorTypeId;
        data["woErrorType"] = this.woErrorType;
        return data;
    }
}

export interface IClaimsWriteOffDto {
    id?: number | undefined;
    claimId?: number | undefined;
    participantId?: string | undefined;
    batchId?: number | undefined;
    woCauseId?: number | undefined;
    writeOffAmount?: number;
    woCause?: string | undefined;
    woErrorTypeId?: number | undefined;
    woErrorType?: string | undefined;
}

export class CoPayHistoryRequest implements ICoPayHistoryRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    companyId?: number;
    serviceCode?: string | undefined;
    transactionDate?: Date;
    participantPersonId?: string | undefined;
    searchParam?: string | undefined;

    constructor(data?: ICoPayHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.companyId = _data["companyId"];
            this.serviceCode = _data["serviceCode"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.participantPersonId = _data["participantPersonId"];
            this.searchParam = _data["searchParam"];
        }
    }

    static fromJS(data: any): CoPayHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["companyId"] = this.companyId;
        data["serviceCode"] = this.serviceCode;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["participantPersonId"] = this.participantPersonId;
        data["searchParam"] = this.searchParam;
        return data;
    }
}

export interface ICoPayHistoryRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    companyId?: number;
    serviceCode?: string | undefined;
    transactionDate?: Date;
    participantPersonId?: string | undefined;
    searchParam?: string | undefined;
}

export class CoPayHistoryResponse implements ICoPayHistoryResponse {
    coPayAmount?: number;
    coPayLastUpdated?: Date;
    transactionDate?: Date;
    responsibilityAmount?: number;
    coPayBalance?: number;

    constructor(data?: ICoPayHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coPayAmount = _data["coPayAmount"];
            this.coPayLastUpdated = _data["coPayLastUpdated"] ? new Date(_data["coPayLastUpdated"].toString()) : <any>undefined;
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.responsibilityAmount = _data["responsibilityAmount"];
            this.coPayBalance = _data["coPayBalance"];
        }
    }

    static fromJS(data: any): CoPayHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coPayAmount"] = this.coPayAmount;
        data["coPayLastUpdated"] = this.coPayLastUpdated ? this.coPayLastUpdated.toISOString() : <any>undefined;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["responsibilityAmount"] = this.responsibilityAmount;
        data["coPayBalance"] = this.coPayBalance;
        return data;
    }
}

export interface ICoPayHistoryResponse {
    coPayAmount?: number;
    coPayLastUpdated?: Date;
    transactionDate?: Date;
    responsibilityAmount?: number;
    coPayBalance?: number;
}

export class CoPayHistoryResponseGridResponseBase implements ICoPayHistoryResponseGridResponseBase {
    items?: CoPayHistoryResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CoPayHistoryResponse;

    constructor(data?: ICoPayHistoryResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CoPayHistoryResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CoPayHistoryResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CoPayHistoryResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayHistoryResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICoPayHistoryResponseGridResponseBase {
    items?: CoPayHistoryResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CoPayHistoryResponse;
}

export class CoPayListRequest implements ICoPayListRequest {
    coPayRequests?: CoPayRequest[] | undefined;
    participantPersonId?: string | undefined;
    patientPayDetails?: PatientPaySummaryDetails[] | undefined;

    constructor(data?: ICoPayListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coPayRequests"])) {
                this.coPayRequests = [] as any;
                for (let item of _data["coPayRequests"])
                    this.coPayRequests!.push(CoPayRequest.fromJS(item));
            }
            this.participantPersonId = _data["participantPersonId"];
            if (Array.isArray(_data["patientPayDetails"])) {
                this.patientPayDetails = [] as any;
                for (let item of _data["patientPayDetails"])
                    this.patientPayDetails!.push(PatientPaySummaryDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoPayListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coPayRequests)) {
            data["coPayRequests"] = [];
            for (let item of this.coPayRequests)
                data["coPayRequests"].push(item.toJSON());
        }
        data["participantPersonId"] = this.participantPersonId;
        if (Array.isArray(this.patientPayDetails)) {
            data["patientPayDetails"] = [];
            for (let item of this.patientPayDetails)
                data["patientPayDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoPayListRequest {
    coPayRequests?: CoPayRequest[] | undefined;
    participantPersonId?: string | undefined;
    patientPayDetails?: PatientPaySummaryDetails[] | undefined;
}

export class CoPayListResponse implements ICoPayListResponse {
    coPayResponses?: CoPayResponse[] | undefined;
    participantPersonId?: string | undefined;

    constructor(data?: ICoPayListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coPayResponses"])) {
                this.coPayResponses = [] as any;
                for (let item of _data["coPayResponses"])
                    this.coPayResponses!.push(CoPayResponse.fromJS(item));
            }
            this.participantPersonId = _data["participantPersonId"];
        }
    }

    static fromJS(data: any): CoPayListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coPayResponses)) {
            data["coPayResponses"] = [];
            for (let item of this.coPayResponses)
                data["coPayResponses"].push(item.toJSON());
        }
        data["participantPersonId"] = this.participantPersonId;
        return data;
    }
}

export interface ICoPayListResponse {
    coPayResponses?: CoPayResponse[] | undefined;
    participantPersonId?: string | undefined;
}

export class CoPayRequest implements ICoPayRequest {
    patientPaySummaryID?: number;
    companyId?: number;
    serviceCode?: string | undefined;
    transactionDate?: Date;
    amount?: number;

    constructor(data?: ICoPayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPaySummaryID = _data["patientPaySummaryID"];
            this.companyId = _data["companyId"];
            this.serviceCode = _data["serviceCode"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CoPayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPaySummaryID"] = this.patientPaySummaryID;
        data["companyId"] = this.companyId;
        data["serviceCode"] = this.serviceCode;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ICoPayRequest {
    patientPaySummaryID?: number;
    companyId?: number;
    serviceCode?: string | undefined;
    transactionDate?: Date;
    amount?: number;
}

export class CoPayResponse implements ICoPayResponse {
    patientPaySummaryID?: number;
    companyId?: number;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    description?: string | undefined;
    transactionDate?: Date;
    amount?: number;
    amountSatisfied?: number | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: ICoPayResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPaySummaryID = _data["patientPaySummaryID"];
            this.companyId = _data["companyId"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.serviceCode = _data["serviceCode"];
            this.description = _data["description"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.amountSatisfied = _data["amountSatisfied"];
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CoPayResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPaySummaryID"] = this.patientPaySummaryID;
        data["companyId"] = this.companyId;
        data["serviceCodeId"] = this.serviceCodeId;
        data["serviceCode"] = this.serviceCode;
        data["description"] = this.description;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["amountSatisfied"] = this.amountSatisfied;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICoPayResponse {
    patientPaySummaryID?: number;
    companyId?: number;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    description?: string | undefined;
    transactionDate?: Date;
    amount?: number;
    amountSatisfied?: number | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
}

export class CoPayUpsertRequest implements ICoPayUpsertRequest {
    patientPayDetails?: PatientPaySummaryDetails[] | undefined;
    userInfo?: string | undefined;
    companyId?: number;

    constructor(data?: ICoPayUpsertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["patientPayDetails"])) {
                this.patientPayDetails = [] as any;
                for (let item of _data["patientPayDetails"])
                    this.patientPayDetails!.push(PatientPaySummaryDetails.fromJS(item));
            }
            this.userInfo = _data["userInfo"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CoPayUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patientPayDetails)) {
            data["patientPayDetails"] = [];
            for (let item of this.patientPayDetails)
                data["patientPayDetails"].push(item.toJSON());
        }
        data["userInfo"] = this.userInfo;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICoPayUpsertRequest {
    patientPayDetails?: PatientPaySummaryDetails[] | undefined;
    userInfo?: string | undefined;
    companyId?: number;
}

export class CodesRequestDto implements ICodesRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;

    constructor(data?: ICodesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.searchParameter = _data["searchParameter"];
        }
    }

    static fromJS(data: any): CodesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["searchParameter"] = this.searchParameter;
        return data;
    }
}

export interface ICodesRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
}

export class ColumnLevelChangeHistoryBase implements IColumnLevelChangeHistoryBase {
    previousColumnValue?: string | undefined;
    currentColumnValue?: string | undefined;
    columnName?: string | undefined;

    constructor(data?: IColumnLevelChangeHistoryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousColumnValue = _data["previousColumnValue"];
            this.currentColumnValue = _data["currentColumnValue"];
            this.columnName = _data["columnName"];
        }
    }

    static fromJS(data: any): ColumnLevelChangeHistoryBase {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnLevelChangeHistoryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousColumnValue"] = this.previousColumnValue;
        data["currentColumnValue"] = this.currentColumnValue;
        data["columnName"] = this.columnName;
        return data;
    }
}

export interface IColumnLevelChangeHistoryBase {
    previousColumnValue?: string | undefined;
    currentColumnValue?: string | undefined;
    columnName?: string | undefined;
}

export class ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase implements IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
    readonly columnLevelChangeHistory?: ColumnLevelChangeHistoryBase[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columnLevelChangeHistory"])) {
                (<any>this).columnLevelChangeHistory = [] as any;
                for (let item of _data["columnLevelChangeHistory"])
                    (<any>this).columnLevelChangeHistory!.push(ColumnLevelChangeHistoryBase.fromJS(item));
            }
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnLevelChangeHistory)) {
            data["columnLevelChangeHistory"] = [];
            for (let item of this.columnLevelChangeHistory)
                data["columnLevelChangeHistory"].push(item.toJSON());
        }
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
    columnLevelChangeHistory?: ColumnLevelChangeHistoryBase[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export enum CopayType {
    Dollar = "Dollar",
    Percentage = "Percentage",
}

export class CreateManualClaimsRequest implements ICreateManualClaimsRequest {
    payorId?: string | undefined;
    programId?: string | undefined;
    participantId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    billCode?: string | undefined;
    authCode?: string | undefined;
    serviceCode?: string | undefined;
    billUnit?: number;
    billAmount?: number;
    submitterDetail?: SubmitterDetails[] | undefined;
    receiverDetail?: ReceiverDetails[] | undefined;
    billingProviderDetail?: BillingProvider[] | undefined;
    subscriberDetailInfo?: ClaimBatchSubscriberDetail[] | undefined;
    payorInfo?: PayorInfo[] | undefined;
    billingAreaInfo?: BillingAreaInfo[] | undefined;
    billCodeDetailsInfo?: BillCodeDetail[] | undefined;
    placeOfService?: number | undefined;
    revenueCode?: string | undefined;
    diagCode?: string | undefined;

    constructor(data?: ICreateManualClaimsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
            this.participantId = _data["participantId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.billCode = _data["billCode"];
            this.authCode = _data["authCode"];
            this.serviceCode = _data["serviceCode"];
            this.billUnit = _data["billUnit"];
            this.billAmount = _data["billAmount"];
            if (Array.isArray(_data["submitterDetail"])) {
                this.submitterDetail = [] as any;
                for (let item of _data["submitterDetail"])
                    this.submitterDetail!.push(SubmitterDetails.fromJS(item));
            }
            if (Array.isArray(_data["receiverDetail"])) {
                this.receiverDetail = [] as any;
                for (let item of _data["receiverDetail"])
                    this.receiverDetail!.push(ReceiverDetails.fromJS(item));
            }
            if (Array.isArray(_data["billingProviderDetail"])) {
                this.billingProviderDetail = [] as any;
                for (let item of _data["billingProviderDetail"])
                    this.billingProviderDetail!.push(BillingProvider.fromJS(item));
            }
            if (Array.isArray(_data["subscriberDetailInfo"])) {
                this.subscriberDetailInfo = [] as any;
                for (let item of _data["subscriberDetailInfo"])
                    this.subscriberDetailInfo!.push(ClaimBatchSubscriberDetail.fromJS(item));
            }
            if (Array.isArray(_data["payorInfo"])) {
                this.payorInfo = [] as any;
                for (let item of _data["payorInfo"])
                    this.payorInfo!.push(PayorInfo.fromJS(item));
            }
            if (Array.isArray(_data["billingAreaInfo"])) {
                this.billingAreaInfo = [] as any;
                for (let item of _data["billingAreaInfo"])
                    this.billingAreaInfo!.push(BillingAreaInfo.fromJS(item));
            }
            if (Array.isArray(_data["billCodeDetailsInfo"])) {
                this.billCodeDetailsInfo = [] as any;
                for (let item of _data["billCodeDetailsInfo"])
                    this.billCodeDetailsInfo!.push(BillCodeDetail.fromJS(item));
            }
            this.placeOfService = _data["placeOfService"];
            this.revenueCode = _data["revenueCode"];
            this.diagCode = _data["diagCode"];
        }
    }

    static fromJS(data: any): CreateManualClaimsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualClaimsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        data["participantId"] = this.participantId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["billCode"] = this.billCode;
        data["authCode"] = this.authCode;
        data["serviceCode"] = this.serviceCode;
        data["billUnit"] = this.billUnit;
        data["billAmount"] = this.billAmount;
        if (Array.isArray(this.submitterDetail)) {
            data["submitterDetail"] = [];
            for (let item of this.submitterDetail)
                data["submitterDetail"].push(item.toJSON());
        }
        if (Array.isArray(this.receiverDetail)) {
            data["receiverDetail"] = [];
            for (let item of this.receiverDetail)
                data["receiverDetail"].push(item.toJSON());
        }
        if (Array.isArray(this.billingProviderDetail)) {
            data["billingProviderDetail"] = [];
            for (let item of this.billingProviderDetail)
                data["billingProviderDetail"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriberDetailInfo)) {
            data["subscriberDetailInfo"] = [];
            for (let item of this.subscriberDetailInfo)
                data["subscriberDetailInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.payorInfo)) {
            data["payorInfo"] = [];
            for (let item of this.payorInfo)
                data["payorInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.billingAreaInfo)) {
            data["billingAreaInfo"] = [];
            for (let item of this.billingAreaInfo)
                data["billingAreaInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.billCodeDetailsInfo)) {
            data["billCodeDetailsInfo"] = [];
            for (let item of this.billCodeDetailsInfo)
                data["billCodeDetailsInfo"].push(item.toJSON());
        }
        data["placeOfService"] = this.placeOfService;
        data["revenueCode"] = this.revenueCode;
        data["diagCode"] = this.diagCode;
        return data;
    }
}

export interface ICreateManualClaimsRequest {
    payorId?: string | undefined;
    programId?: string | undefined;
    participantId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    billCode?: string | undefined;
    authCode?: string | undefined;
    serviceCode?: string | undefined;
    billUnit?: number;
    billAmount?: number;
    submitterDetail?: SubmitterDetails[] | undefined;
    receiverDetail?: ReceiverDetails[] | undefined;
    billingProviderDetail?: BillingProvider[] | undefined;
    subscriberDetailInfo?: ClaimBatchSubscriberDetail[] | undefined;
    payorInfo?: PayorInfo[] | undefined;
    billingAreaInfo?: BillingAreaInfo[] | undefined;
    billCodeDetailsInfo?: BillCodeDetail[] | undefined;
    placeOfService?: number | undefined;
    revenueCode?: string | undefined;
    diagCode?: string | undefined;
}

export class CustomFilterRequest implements ICustomFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;

    constructor(data?: ICustomFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.searchParameter = _data["searchParameter"];
        }
    }

    static fromJS(data: any): CustomFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["searchParameter"] = this.searchParameter;
        return data;
    }
}

export interface ICustomFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
}

export class CustomGridFilterRequest implements ICustomGridFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    id?: string | undefined;

    constructor(data?: ICustomGridFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomGridFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGridFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface ICustomGridFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    id?: string | undefined;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class DeleteManualClaimRequest implements IDeleteManualClaimRequest {
    batchNumber?: string | undefined;
    ccn?: string[] | undefined;

    constructor(data?: IDeleteManualClaimRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNumber = _data["batchNumber"];
            if (Array.isArray(_data["ccn"])) {
                this.ccn = [] as any;
                for (let item of _data["ccn"])
                    this.ccn!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteManualClaimRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteManualClaimRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        if (Array.isArray(this.ccn)) {
            data["ccn"] = [];
            for (let item of this.ccn)
                data["ccn"].push(item);
        }
        return data;
    }
}

export interface IDeleteManualClaimRequest {
    batchNumber?: string | undefined;
    ccn?: string[] | undefined;
}

export class EdiConfigurationFilterRequest implements IEdiConfigurationFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    payorId?: number | undefined;
    programId?: number | undefined;

    constructor(data?: IEdiConfigurationFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.searchParameter = _data["searchParameter"];
            this.payorId = _data["payorId"];
            this.programId = _data["programId"];
        }
    }

    static fromJS(data: any): EdiConfigurationFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EdiConfigurationFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["searchParameter"] = this.searchParameter;
        data["payorId"] = this.payorId;
        data["programId"] = this.programId;
        return data;
    }
}

export interface IEdiConfigurationFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    payorId?: number | undefined;
    programId?: number | undefined;
}

export class ExcludedBcns implements IExcludedBcns {
    excludedBillingRecords?: number[] | undefined;
    participantId?: string[] | undefined;
    includedBcns?: number[] | undefined;

    constructor(data?: IExcludedBcns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["excludedBillingRecords"])) {
                this.excludedBillingRecords = [] as any;
                for (let item of _data["excludedBillingRecords"])
                    this.excludedBillingRecords!.push(item);
            }
            if (Array.isArray(_data["participantId"])) {
                this.participantId = [] as any;
                for (let item of _data["participantId"])
                    this.participantId!.push(item);
            }
            if (Array.isArray(_data["includedBcns"])) {
                this.includedBcns = [] as any;
                for (let item of _data["includedBcns"])
                    this.includedBcns!.push(item);
            }
        }
    }

    static fromJS(data: any): ExcludedBcns {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedBcns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.excludedBillingRecords)) {
            data["excludedBillingRecords"] = [];
            for (let item of this.excludedBillingRecords)
                data["excludedBillingRecords"].push(item);
        }
        if (Array.isArray(this.participantId)) {
            data["participantId"] = [];
            for (let item of this.participantId)
                data["participantId"].push(item);
        }
        if (Array.isArray(this.includedBcns)) {
            data["includedBcns"] = [];
            for (let item of this.includedBcns)
                data["includedBcns"].push(item);
        }
        return data;
    }
}

export interface IExcludedBcns {
    excludedBillingRecords?: number[] | undefined;
    participantId?: string[] | undefined;
    includedBcns?: number[] | undefined;
}

export class ExcludedClaimsDto implements IExcludedClaimsDto {
    id?: number;
    exclusionReason?: string | undefined;
    ccn?: string | undefined;
    participantId?: number;
    participantName?: string | undefined;
    caregiverName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalCount?: number;

    constructor(data?: IExcludedClaimsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exclusionReason = _data["exclusionReason"];
            this.ccn = _data["ccn"];
            this.participantId = _data["participantId"];
            this.participantName = _data["participantName"];
            this.caregiverName = _data["caregiverName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ExcludedClaimsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedClaimsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exclusionReason"] = this.exclusionReason;
        data["ccn"] = this.ccn;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["caregiverName"] = this.caregiverName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IExcludedClaimsDto {
    id?: number;
    exclusionReason?: string | undefined;
    ccn?: string | undefined;
    participantId?: number;
    participantName?: string | undefined;
    caregiverName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalCount?: number;
}

export class ExcludedClaimsDtoGridResponseBase implements IExcludedClaimsDtoGridResponseBase {
    items?: ExcludedClaimsDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ExcludedClaimsDto;

    constructor(data?: IExcludedClaimsDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExcludedClaimsDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ExcludedClaimsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExcludedClaimsDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedClaimsDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExcludedClaimsDtoGridResponseBase {
    items?: ExcludedClaimsDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ExcludedClaimsDto;
}

export class ExcludedVoidedCCNDTO implements IExcludedVoidedCCNDTO {
    id?: number;
    exclusionReason?: string | undefined;
    ccn?: string | undefined;
    status?: string | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    caregiverName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    totalCount?: number;
    groupId?: string | undefined;
    isExcluded?: boolean;

    constructor(data?: IExcludedVoidedCCNDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exclusionReason = _data["exclusionReason"];
            this.ccn = _data["ccn"];
            this.status = _data["status"];
            this.participantId = _data["participantId"];
            this.participantName = _data["participantName"];
            this.caregiverName = _data["caregiverName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.payor = _data["payor"];
            this.program = _data["program"];
            this.totalCount = _data["totalCount"];
            this.groupId = _data["groupId"];
            this.isExcluded = _data["isExcluded"];
        }
    }

    static fromJS(data: any): ExcludedVoidedCCNDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedVoidedCCNDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exclusionReason"] = this.exclusionReason;
        data["ccn"] = this.ccn;
        data["status"] = this.status;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["caregiverName"] = this.caregiverName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["payor"] = this.payor;
        data["program"] = this.program;
        data["totalCount"] = this.totalCount;
        data["groupId"] = this.groupId;
        data["isExcluded"] = this.isExcluded;
        return data;
    }
}

export interface IExcludedVoidedCCNDTO {
    id?: number;
    exclusionReason?: string | undefined;
    ccn?: string | undefined;
    status?: string | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    caregiverName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    totalCount?: number;
    groupId?: string | undefined;
    isExcluded?: boolean;
}

export class ExcludedVoidedCCNDTOGridResponseBase implements IExcludedVoidedCCNDTOGridResponseBase {
    items?: ExcludedVoidedCCNDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ExcludedVoidedCCNDTO;

    constructor(data?: IExcludedVoidedCCNDTOGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExcludedVoidedCCNDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ExcludedVoidedCCNDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExcludedVoidedCCNDTOGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedVoidedCCNDTOGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExcludedVoidedCCNDTOGridResponseBase {
    items?: ExcludedVoidedCCNDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ExcludedVoidedCCNDTO;
}

export class FileResultDto implements IFileResultDto {
    fileName?: string | undefined;
    content?: string | undefined;

    constructor(data?: IFileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): FileResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        return data;
    }
}

export interface IFileResultDto {
    fileName?: string | undefined;
    content?: string | undefined;
}

export class FilterRequestWithId implements IFilterRequestWithId {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    id?: string | undefined;

    constructor(data?: IFilterRequestWithId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FilterRequestWithId {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequestWithId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IFilterRequestWithId {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    id?: string | undefined;
}

export class GetClaimBatchFilterRequest implements IGetClaimBatchFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    fetchDeletedBatch?: boolean;
    filterType?: string | undefined;

    constructor(data?: IGetClaimBatchFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.searchParameter = _data["searchParameter"];
            this.fetchDeletedBatch = _data["fetchDeletedBatch"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): GetClaimBatchFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaimBatchFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["searchParameter"] = this.searchParameter;
        data["fetchDeletedBatch"] = this.fetchDeletedBatch;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IGetClaimBatchFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    fetchDeletedBatch?: boolean;
    filterType?: string | undefined;
}

export class GetHistoryRequestBase implements IGetHistoryRequestBase {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    explicitColumns?: string[] | undefined;
    includeCreation?: boolean;

    constructor(data?: IGetHistoryRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["explicitColumns"])) {
                this.explicitColumns = [] as any;
                for (let item of _data["explicitColumns"])
                    this.explicitColumns!.push(item);
            }
            this.includeCreation = _data["includeCreation"];
        }
    }

    static fromJS(data: any): GetHistoryRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new GetHistoryRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.explicitColumns)) {
            data["explicitColumns"] = [];
            for (let item of this.explicitColumns)
                data["explicitColumns"].push(item);
        }
        data["includeCreation"] = this.includeCreation;
        return data;
    }
}

export interface IGetHistoryRequestBase {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    explicitColumns?: string[] | undefined;
    includeCreation?: boolean;
}

export class GetServCodeDetailsByTcnRequest implements IGetServCodeDetailsByTcnRequest {
    tcn?: string | undefined;
    caregiverId?: string | undefined;

    constructor(data?: IGetServCodeDetailsByTcnRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcn = _data["tcn"];
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): GetServCodeDetailsByTcnRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServCodeDetailsByTcnRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcn"] = this.tcn;
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface IGetServCodeDetailsByTcnRequest {
    tcn?: string | undefined;
    caregiverId?: string | undefined;
}

export class GlXmlExportRequest implements IGlXmlExportRequest {
    batchNumber?: string | undefined;

    constructor(data?: IGlXmlExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNumber = _data["batchNumber"];
        }
    }

    static fromJS(data: any): GlXmlExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GlXmlExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        return data;
    }
}

export interface IGlXmlExportRequest {
    batchNumber?: string | undefined;
}

export class GlXmlGridResponse implements IGlXmlGridResponse {
    source?: string | undefined;
    location?: string | undefined;
    account?: string | undefined;
    program?: string | undefined;
    description?: string | undefined;
    debit?: string | undefined;
    credit?: string | undefined;

    constructor(data?: IGlXmlGridResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.location = _data["location"];
            this.account = _data["account"];
            this.program = _data["program"];
            this.description = _data["description"];
            this.debit = _data["debit"];
            this.credit = _data["credit"];
        }
    }

    static fromJS(data: any): GlXmlGridResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GlXmlGridResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["location"] = this.location;
        data["account"] = this.account;
        data["program"] = this.program;
        data["description"] = this.description;
        data["debit"] = this.debit;
        data["credit"] = this.credit;
        return data;
    }
}

export interface IGlXmlGridResponse {
    source?: string | undefined;
    location?: string | undefined;
    account?: string | undefined;
    program?: string | undefined;
    description?: string | undefined;
    debit?: string | undefined;
    credit?: string | undefined;
}

export class GroupCodeResponseDto implements IGroupCodeResponseDto {
    groupCodeId?: number;
    groupCode?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IGroupCodeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupCodeId = _data["groupCodeId"];
            this.groupCode = _data["groupCode"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): GroupCodeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupCodeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupCodeId"] = this.groupCodeId;
        data["groupCode"] = this.groupCode;
        data["description"] = this.description;
        data["status"] = this.status;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IGroupCodeResponseDto {
    groupCodeId?: number;
    groupCode?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class GroupCodeResponseDtoGridResponseBase implements IGroupCodeResponseDtoGridResponseBase {
    items?: GroupCodeResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: GroupCodeResponseDto;

    constructor(data?: IGroupCodeResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GroupCodeResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? GroupCodeResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GroupCodeResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new GroupCodeResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGroupCodeResponseDtoGridResponseBase {
    items?: GroupCodeResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: GroupCodeResponseDto;
}

export class IcnResponse implements IIcnResponse {
    icn?: string | undefined;
    dateSubmitted?: Date | undefined;

    constructor(data?: IIcnResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icn = _data["icn"];
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IcnResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IcnResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icn"] = this.icn;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIcnResponse {
    icn?: string | undefined;
    dateSubmitted?: Date | undefined;
}

export class IcnResponseGridResponseBase implements IIcnResponseGridResponseBase {
    items?: IcnResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: IcnResponse;

    constructor(data?: IIcnResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IcnResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? IcnResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IcnResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new IcnResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIcnResponseGridResponseBase {
    items?: IcnResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: IcnResponse;
}

export class Int64NullableApiResponse implements IInt64NullableApiResponse {
    message?: string | undefined;
    data?: number | undefined;
    success?: boolean;

    constructor(data?: IInt64NullableApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): Int64NullableApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Int64NullableApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data;
        data["success"] = this.success;
        return data;
    }
}

export interface IInt64NullableApiResponse {
    message?: string | undefined;
    data?: number | undefined;
    success?: boolean;
}

export class LCNAdjustmentCodeDetailsDto implements ILCNAdjustmentCodeDetailsDto {
    adjustmentCodeId?: number;
    adjustmentCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILCNAdjustmentCodeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adjustmentCodeId = _data["adjustmentCodeId"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LCNAdjustmentCodeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LCNAdjustmentCodeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustmentCodeId"] = this.adjustmentCodeId;
        data["adjustmentCode"] = this.adjustmentCode;
        data["description"] = this.description;
        return data;
    }
}

export interface ILCNAdjustmentCodeDetailsDto {
    adjustmentCodeId?: number;
    adjustmentCode?: string | undefined;
    description?: string | undefined;
}

export class LCNFilterRequest implements ILCNFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    companyId?: number;
    ccn?: string | undefined;

    constructor(data?: ILCNFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.companyId = _data["companyId"];
            this.ccn = _data["ccn"];
        }
    }

    static fromJS(data: any): LCNFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LCNFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["companyId"] = this.companyId;
        data["ccn"] = this.ccn;
        return data;
    }
}

export interface ILCNFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    companyId?: number;
    ccn?: string | undefined;
}

export class LCNGroupCodeDetailsDto implements ILCNGroupCodeDetailsDto {
    groupCodeId?: number;
    groupCode?: string | undefined;

    constructor(data?: ILCNGroupCodeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupCodeId = _data["groupCodeId"];
            this.groupCode = _data["groupCode"];
        }
    }

    static fromJS(data: any): LCNGroupCodeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LCNGroupCodeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupCodeId"] = this.groupCodeId;
        data["groupCode"] = this.groupCode;
        return data;
    }
}

export interface ILCNGroupCodeDetailsDto {
    groupCodeId?: number;
    groupCode?: string | undefined;
}

export class LCNHistoryResponse implements ILCNHistoryResponse {
    lcnStatus?: string | undefined;
    eventDate?: Date;
    note?: string | undefined;
    remarkCode?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    denialReasondDetails?: LCNAdjustmentCodeDetailsDto[] | undefined;
    groupCodeDetails?: LCNGroupCodeDetailsDto[] | undefined;
    remarkCodeDetails?: LCNRemarkCodeDetailsDto[] | undefined;
    checkNumber?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: ILCNHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcnStatus = _data["lcnStatus"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.remarkCode = _data["remarkCode"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.groupCode = _data["groupCode"];
            if (Array.isArray(_data["denialReasondDetails"])) {
                this.denialReasondDetails = [] as any;
                for (let item of _data["denialReasondDetails"])
                    this.denialReasondDetails!.push(LCNAdjustmentCodeDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["groupCodeDetails"])) {
                this.groupCodeDetails = [] as any;
                for (let item of _data["groupCodeDetails"])
                    this.groupCodeDetails!.push(LCNGroupCodeDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["remarkCodeDetails"])) {
                this.remarkCodeDetails = [] as any;
                for (let item of _data["remarkCodeDetails"])
                    this.remarkCodeDetails!.push(LCNRemarkCodeDetailsDto.fromJS(item));
            }
            this.checkNumber = _data["checkNumber"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): LCNHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LCNHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcnStatus"] = this.lcnStatus;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["remarkCode"] = this.remarkCode;
        data["adjustmentCode"] = this.adjustmentCode;
        data["groupCode"] = this.groupCode;
        if (Array.isArray(this.denialReasondDetails)) {
            data["denialReasondDetails"] = [];
            for (let item of this.denialReasondDetails)
                data["denialReasondDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.groupCodeDetails)) {
            data["groupCodeDetails"] = [];
            for (let item of this.groupCodeDetails)
                data["groupCodeDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.remarkCodeDetails)) {
            data["remarkCodeDetails"] = [];
            for (let item of this.remarkCodeDetails)
                data["remarkCodeDetails"].push(item.toJSON());
        }
        data["checkNumber"] = this.checkNumber;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ILCNHistoryResponse {
    lcnStatus?: string | undefined;
    eventDate?: Date;
    note?: string | undefined;
    remarkCode?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    denialReasondDetails?: LCNAdjustmentCodeDetailsDto[] | undefined;
    groupCodeDetails?: LCNGroupCodeDetailsDto[] | undefined;
    remarkCodeDetails?: LCNRemarkCodeDetailsDto[] | undefined;
    checkNumber?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export enum LCNOverideAction {
    NA = "NA",
    ResetStatus = "ResetStatus",
    Rebilled = "Rebilled",
    Pending = "Pending",
}

export class LCNRemarkCodeDetailsDto implements ILCNRemarkCodeDetailsDto {
    remarkCodeId?: number;
    remarkCode?: string | undefined;

    constructor(data?: ILCNRemarkCodeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remarkCodeId = _data["remarkCodeId"];
            this.remarkCode = _data["remarkCode"];
        }
    }

    static fromJS(data: any): LCNRemarkCodeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LCNRemarkCodeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarkCodeId"] = this.remarkCodeId;
        data["remarkCode"] = this.remarkCode;
        return data;
    }
}

export interface ILCNRemarkCodeDetailsDto {
    remarkCodeId?: number;
    remarkCode?: string | undefined;
}

export enum LCNStatus {
    InProgress = "InProgress",
    Billed = "Billed",
    Paid = "Paid",
    PartialPaid = "PartialPaid",
    Adjusted = "Adjusted",
    Void = "Void",
    Denied = "Denied",
    OverPaid = "OverPaid",
    Closed = "Closed",
    Rebilled = "Rebilled",
    Pending = "Pending",
}

export class LCNUpdateDetailsResponse implements ILCNUpdateDetailsResponse {
    id?: number;
    ccn?: string | undefined;
    lcn?: string | undefined;
    participantID?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    currentAmount?: number;
    lcnStatus?: string | undefined;
    createdOn?: Date | undefined;
    remarkCode?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    eventDate?: Date | undefined;

    constructor(data?: ILCNUpdateDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ccn = _data["ccn"];
            this.lcn = _data["lcn"];
            this.participantID = _data["participantID"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.currentAmount = _data["currentAmount"];
            this.lcnStatus = _data["lcnStatus"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.remarkCode = _data["remarkCode"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.groupCode = _data["groupCode"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LCNUpdateDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LCNUpdateDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ccn"] = this.ccn;
        data["lcn"] = this.lcn;
        data["participantID"] = this.participantID;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["currentAmount"] = this.currentAmount;
        data["lcnStatus"] = this.lcnStatus;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["remarkCode"] = this.remarkCode;
        data["adjustmentCode"] = this.adjustmentCode;
        data["groupCode"] = this.groupCode;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILCNUpdateDetailsResponse {
    id?: number;
    ccn?: string | undefined;
    lcn?: string | undefined;
    participantID?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    currentAmount?: number;
    lcnStatus?: string | undefined;
    createdOn?: Date | undefined;
    remarkCode?: string | undefined;
    adjustmentCode?: string | undefined;
    groupCode?: string | undefined;
    eventDate?: Date | undefined;
}

export class LCNUpdateDetailsResponseGridResponseBase implements ILCNUpdateDetailsResponseGridResponseBase {
    items?: LCNUpdateDetailsResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: LCNUpdateDetailsResponse;

    constructor(data?: ILCNUpdateDetailsResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LCNUpdateDetailsResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? LCNUpdateDetailsResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LCNUpdateDetailsResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new LCNUpdateDetailsResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILCNUpdateDetailsResponseGridResponseBase {
    items?: LCNUpdateDetailsResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: LCNUpdateDetailsResponse;
}

export class LCNUpdateSearchRequest implements ILCNUpdateSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor!: string;
    participantId?: string | undefined;
    hcpcsCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdDateStart?: Date | undefined;
    createdDateEnd?: Date | undefined;
    eventDateStart?: Date | undefined;
    eventDateEnd?: Date | undefined;
    filterType?: string | undefined;

    constructor(data?: ILCNUpdateSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.payor = _data["payor"];
            this.participantId = _data["participantId"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.createdDateStart = _data["createdDateStart"] ? new Date(_data["createdDateStart"].toString()) : <any>undefined;
            this.createdDateEnd = _data["createdDateEnd"] ? new Date(_data["createdDateEnd"].toString()) : <any>undefined;
            this.eventDateStart = _data["eventDateStart"] ? new Date(_data["eventDateStart"].toString()) : <any>undefined;
            this.eventDateEnd = _data["eventDateEnd"] ? new Date(_data["eventDateEnd"].toString()) : <any>undefined;
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): LCNUpdateSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LCNUpdateSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["payor"] = this.payor;
        data["participantId"] = this.participantId;
        data["hcpcsCode"] = this.hcpcsCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["createdDateStart"] = this.createdDateStart ? this.createdDateStart.toISOString() : <any>undefined;
        data["createdDateEnd"] = this.createdDateEnd ? this.createdDateEnd.toISOString() : <any>undefined;
        data["eventDateStart"] = this.eventDateStart ? this.eventDateStart.toISOString() : <any>undefined;
        data["eventDateEnd"] = this.eventDateEnd ? this.eventDateEnd.toISOString() : <any>undefined;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface ILCNUpdateSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor: string;
    participantId?: string | undefined;
    hcpcsCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createdDateStart?: Date | undefined;
    createdDateEnd?: Date | undefined;
    eventDateStart?: Date | undefined;
    eventDateEnd?: Date | undefined;
    filterType?: string | undefined;
}

export enum LateTime {
    CleanClaim = "CleanClaim",
    Adjustment = "Adjustment",
}

export class LcnAdjustmentCodeDto implements ILcnAdjustmentCodeDto {
    lcn?: string | undefined;
    adjustmentCodeId?: number | undefined;
    adjustmentCode?: string | undefined;

    constructor(data?: ILcnAdjustmentCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcn = _data["lcn"];
            this.adjustmentCodeId = _data["adjustmentCodeId"];
            this.adjustmentCode = _data["adjustmentCode"];
        }
    }

    static fromJS(data: any): LcnAdjustmentCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LcnAdjustmentCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcn"] = this.lcn;
        data["adjustmentCodeId"] = this.adjustmentCodeId;
        data["adjustmentCode"] = this.adjustmentCode;
        return data;
    }
}

export interface ILcnAdjustmentCodeDto {
    lcn?: string | undefined;
    adjustmentCodeId?: number | undefined;
    adjustmentCode?: string | undefined;
}

export class LcnCodesDto implements ILcnCodesDto {
    lcn?: string | undefined;
    adjustmentCodeId?: number | undefined;
    groupCodeId?: number | undefined;
    remarkCodeId?: number | undefined;
    groupCode?: string | undefined;
    remarkCode?: string | undefined;

    constructor(data?: ILcnCodesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcn = _data["lcn"];
            this.adjustmentCodeId = _data["adjustmentCodeId"];
            this.groupCodeId = _data["groupCodeId"];
            this.remarkCodeId = _data["remarkCodeId"];
            this.groupCode = _data["groupCode"];
            this.remarkCode = _data["remarkCode"];
        }
    }

    static fromJS(data: any): LcnCodesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LcnCodesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcn"] = this.lcn;
        data["adjustmentCodeId"] = this.adjustmentCodeId;
        data["groupCodeId"] = this.groupCodeId;
        data["remarkCodeId"] = this.remarkCodeId;
        data["groupCode"] = this.groupCode;
        data["remarkCode"] = this.remarkCode;
        return data;
    }
}

export interface ILcnCodesDto {
    lcn?: string | undefined;
    adjustmentCodeId?: number | undefined;
    groupCodeId?: number | undefined;
    remarkCodeId?: number | undefined;
    groupCode?: string | undefined;
    remarkCode?: string | undefined;
}

export class LcnDetailsDto implements ILcnDetailsDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    lcn?: string | undefined;
    claimAmount?: number | undefined;
    paidAmount?: number | undefined;
    writeOffAmount?: number | undefined;
    status?: number;
    eventDate?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    readonly statusText?: string | undefined;
    lcnCodes?: LcnCodesDto[] | undefined;
    ccn?: string | undefined;
    caregiverNpi?: string | undefined;
    caregiverApi?: string | undefined;
    interest?: number | undefined;
    icn?: string | undefined;
    billUnits?: number | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    revenueCode?: string | undefined;
    bcnCount?: number;
    copayAmount?: number | undefined;
    remainingAmount?: number | undefined;

    constructor(data?: ILcnDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.lcn = _data["lcn"];
            this.claimAmount = _data["claimAmount"];
            this.paidAmount = _data["paidAmount"];
            this.writeOffAmount = _data["writeOffAmount"];
            this.status = _data["status"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            (<any>this).statusText = _data["statusText"];
            if (Array.isArray(_data["lcnCodes"])) {
                this.lcnCodes = [] as any;
                for (let item of _data["lcnCodes"])
                    this.lcnCodes!.push(LcnCodesDto.fromJS(item));
            }
            this.ccn = _data["ccn"];
            this.caregiverNpi = _data["caregiverNpi"];
            this.caregiverApi = _data["caregiverApi"];
            this.interest = _data["interest"];
            this.icn = _data["icn"];
            this.billUnits = _data["billUnits"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
            this.revenueCode = _data["revenueCode"];
            this.bcnCount = _data["bcnCount"];
            this.copayAmount = _data["copayAmount"];
            this.remainingAmount = _data["remainingAmount"];
        }
    }

    static fromJS(data: any): LcnDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LcnDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["lcn"] = this.lcn;
        data["claimAmount"] = this.claimAmount;
        data["paidAmount"] = this.paidAmount;
        data["writeOffAmount"] = this.writeOffAmount;
        data["status"] = this.status;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusText"] = this.statusText;
        if (Array.isArray(this.lcnCodes)) {
            data["lcnCodes"] = [];
            for (let item of this.lcnCodes)
                data["lcnCodes"].push(item.toJSON());
        }
        data["ccn"] = this.ccn;
        data["caregiverNpi"] = this.caregiverNpi;
        data["caregiverApi"] = this.caregiverApi;
        data["interest"] = this.interest;
        data["icn"] = this.icn;
        data["billUnits"] = this.billUnits;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        data["revenueCode"] = this.revenueCode;
        data["bcnCount"] = this.bcnCount;
        data["copayAmount"] = this.copayAmount;
        data["remainingAmount"] = this.remainingAmount;
        return data;
    }
}

export interface ILcnDetailsDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    lcn?: string | undefined;
    claimAmount?: number | undefined;
    paidAmount?: number | undefined;
    writeOffAmount?: number | undefined;
    status?: number;
    eventDate?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    statusText?: string | undefined;
    lcnCodes?: LcnCodesDto[] | undefined;
    ccn?: string | undefined;
    caregiverNpi?: string | undefined;
    caregiverApi?: string | undefined;
    interest?: number | undefined;
    icn?: string | undefined;
    billUnits?: number | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    revenueCode?: string | undefined;
    bcnCount?: number;
    copayAmount?: number | undefined;
    remainingAmount?: number | undefined;
}

export class LcnDetailsDtoGridResponseBase implements ILcnDetailsDtoGridResponseBase {
    items?: LcnDetailsDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: LcnDetailsDto;

    constructor(data?: ILcnDetailsDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LcnDetailsDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? LcnDetailsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LcnDetailsDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new LcnDetailsDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILcnDetailsDtoGridResponseBase {
    items?: LcnDetailsDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: LcnDetailsDto;
}

export class LcnEcnAdjustmentCodeDto implements ILcnEcnAdjustmentCodeDto {
    lcn?: string | undefined;
    ecn?: string | undefined;
    adjustmentCodeId?: number | undefined;
    adjustmentCode?: string | undefined;
    multipleServicePaymentsReceivedId?: number | undefined;

    constructor(data?: ILcnEcnAdjustmentCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcn = _data["lcn"];
            this.ecn = _data["ecn"];
            this.adjustmentCodeId = _data["adjustmentCodeId"];
            this.adjustmentCode = _data["adjustmentCode"];
            this.multipleServicePaymentsReceivedId = _data["multipleServicePaymentsReceivedId"];
        }
    }

    static fromJS(data: any): LcnEcnAdjustmentCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LcnEcnAdjustmentCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcn"] = this.lcn;
        data["ecn"] = this.ecn;
        data["adjustmentCodeId"] = this.adjustmentCodeId;
        data["adjustmentCode"] = this.adjustmentCode;
        data["multipleServicePaymentsReceivedId"] = this.multipleServicePaymentsReceivedId;
        return data;
    }
}

export interface ILcnEcnAdjustmentCodeDto {
    lcn?: string | undefined;
    ecn?: string | undefined;
    adjustmentCodeId?: number | undefined;
    adjustmentCode?: string | undefined;
    multipleServicePaymentsReceivedId?: number | undefined;
}

export class LcnEcnGroupCodeDto implements ILcnEcnGroupCodeDto {
    lcn?: string | undefined;
    ecn?: string | undefined;
    groupCodeId?: number | undefined;
    multipleServicePaymentsReceivedId?: number | undefined;

    constructor(data?: ILcnEcnGroupCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcn = _data["lcn"];
            this.ecn = _data["ecn"];
            this.groupCodeId = _data["groupCodeId"];
            this.multipleServicePaymentsReceivedId = _data["multipleServicePaymentsReceivedId"];
        }
    }

    static fromJS(data: any): LcnEcnGroupCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LcnEcnGroupCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcn"] = this.lcn;
        data["ecn"] = this.ecn;
        data["groupCodeId"] = this.groupCodeId;
        data["multipleServicePaymentsReceivedId"] = this.multipleServicePaymentsReceivedId;
        return data;
    }
}

export interface ILcnEcnGroupCodeDto {
    lcn?: string | undefined;
    ecn?: string | undefined;
    groupCodeId?: number | undefined;
    multipleServicePaymentsReceivedId?: number | undefined;
}

export class LcnEcnRemarkCodeDto implements ILcnEcnRemarkCodeDto {
    lcn?: string | undefined;
    ecn?: string | undefined;
    remarkCodeId?: number | undefined;
    remarkCode?: string | undefined;
    multipleServicePaymentsReceivedId?: number | undefined;

    constructor(data?: ILcnEcnRemarkCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcn = _data["lcn"];
            this.ecn = _data["ecn"];
            this.remarkCodeId = _data["remarkCodeId"];
            this.remarkCode = _data["remarkCode"];
            this.multipleServicePaymentsReceivedId = _data["multipleServicePaymentsReceivedId"];
        }
    }

    static fromJS(data: any): LcnEcnRemarkCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LcnEcnRemarkCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcn"] = this.lcn;
        data["ecn"] = this.ecn;
        data["remarkCodeId"] = this.remarkCodeId;
        data["remarkCode"] = this.remarkCode;
        data["multipleServicePaymentsReceivedId"] = this.multipleServicePaymentsReceivedId;
        return data;
    }
}

export interface ILcnEcnRemarkCodeDto {
    lcn?: string | undefined;
    ecn?: string | undefined;
    remarkCodeId?: number | undefined;
    remarkCode?: string | undefined;
    multipleServicePaymentsReceivedId?: number | undefined;
}

export class LcnGroupCodeDto implements ILcnGroupCodeDto {
    lcn?: string | undefined;
    groupCodeId?: number | undefined;

    constructor(data?: ILcnGroupCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcn = _data["lcn"];
            this.groupCodeId = _data["groupCodeId"];
        }
    }

    static fromJS(data: any): LcnGroupCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LcnGroupCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcn"] = this.lcn;
        data["groupCodeId"] = this.groupCodeId;
        return data;
    }
}

export interface ILcnGroupCodeDto {
    lcn?: string | undefined;
    groupCodeId?: number | undefined;
}

export class LcnRemarkCodeDto implements ILcnRemarkCodeDto {
    lcn?: string | undefined;
    remarkCodeId?: number | undefined;
    remarkCode?: string | undefined;

    constructor(data?: ILcnRemarkCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lcn = _data["lcn"];
            this.remarkCodeId = _data["remarkCodeId"];
            this.remarkCode = _data["remarkCode"];
        }
    }

    static fromJS(data: any): LcnRemarkCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LcnRemarkCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lcn"] = this.lcn;
        data["remarkCodeId"] = this.remarkCodeId;
        data["remarkCode"] = this.remarkCode;
        return data;
    }
}

export interface ILcnRemarkCodeDto {
    lcn?: string | undefined;
    remarkCodeId?: number | undefined;
    remarkCode?: string | undefined;
}

export enum LineGrouping {
    Shift = "Shift",
    Daily = "Daily",
    Weekly = "Weekly",
}

export enum LineStatus {
    Billed = "Billed",
    PartialPaid = "PartialPaid",
    Denied = "Denied",
    OverPaid = "OverPaid",
}

export class ManualClaimBatchLookupResponseDto implements IManualClaimBatchLookupResponseDto {
    id?: number | undefined;
    batchId?: string | undefined;
    status?: string | undefined;

    constructor(data?: IManualClaimBatchLookupResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.batchId = _data["batchId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ManualClaimBatchLookupResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualClaimBatchLookupResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["batchId"] = this.batchId;
        data["status"] = this.status;
        return data;
    }
}

export interface IManualClaimBatchLookupResponseDto {
    id?: number | undefined;
    batchId?: string | undefined;
    status?: string | undefined;
}

export class ManualClaimBatchLookupResponseDtoGridResponseBase implements IManualClaimBatchLookupResponseDtoGridResponseBase {
    items?: ManualClaimBatchLookupResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ManualClaimBatchLookupResponseDto;

    constructor(data?: IManualClaimBatchLookupResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ManualClaimBatchLookupResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ManualClaimBatchLookupResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ManualClaimBatchLookupResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ManualClaimBatchLookupResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IManualClaimBatchLookupResponseDtoGridResponseBase {
    items?: ManualClaimBatchLookupResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ManualClaimBatchLookupResponseDto;
}

export class ManualClaimsDto implements IManualClaimsDto {
    id?: number;
    ccn?: string | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    hcpcs?: string | undefined;
    modifier?: string | undefined;
    startServiceDate?: Date;
    endServiceDate?: Date;
    billUnits?: number;
    billAmount?: number;

    constructor(data?: IManualClaimsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ccn = _data["ccn"];
            this.payor = _data["payor"];
            this.program = _data["program"];
            this.participantId = _data["participantId"];
            this.participantName = _data["participantName"];
            this.hcpcs = _data["hcpcs"];
            this.modifier = _data["modifier"];
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.billUnits = _data["billUnits"];
            this.billAmount = _data["billAmount"];
        }
    }

    static fromJS(data: any): ManualClaimsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualClaimsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ccn"] = this.ccn;
        data["payor"] = this.payor;
        data["program"] = this.program;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["hcpcs"] = this.hcpcs;
        data["modifier"] = this.modifier;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["billUnits"] = this.billUnits;
        data["billAmount"] = this.billAmount;
        return data;
    }
}

export interface IManualClaimsDto {
    id?: number;
    ccn?: string | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    hcpcs?: string | undefined;
    modifier?: string | undefined;
    startServiceDate?: Date;
    endServiceDate?: Date;
    billUnits?: number;
    billAmount?: number;
}

export class ManualClaimsDtoGridResponseBase implements IManualClaimsDtoGridResponseBase {
    items?: ManualClaimsDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ManualClaimsDto;

    constructor(data?: IManualClaimsDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ManualClaimsDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ManualClaimsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ManualClaimsDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ManualClaimsDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IManualClaimsDtoGridResponseBase {
    items?: ManualClaimsDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ManualClaimsDto;
}

export class MbccnCreateRequestDto implements IMbccnCreateRequestDto {
    mbccnSearchCriteria?: MbccnCreateSearchCriteria;
    excludedBcn?: ExcludedBcns;

    constructor(data?: IMbccnCreateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mbccnSearchCriteria = _data["mbccnSearchCriteria"] ? MbccnCreateSearchCriteria.fromJS(_data["mbccnSearchCriteria"]) : <any>undefined;
            this.excludedBcn = _data["excludedBcn"] ? ExcludedBcns.fromJS(_data["excludedBcn"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MbccnCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MbccnCreateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mbccnSearchCriteria"] = this.mbccnSearchCriteria ? this.mbccnSearchCriteria.toJSON() : <any>undefined;
        data["excludedBcn"] = this.excludedBcn ? this.excludedBcn.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMbccnCreateRequestDto {
    mbccnSearchCriteria?: MbccnCreateSearchCriteria;
    excludedBcn?: ExcludedBcns;
}

export class MbccnCreateSearchCriteria implements IMbccnCreateSearchCriteria {
    id?: number;
    templateName?: string | undefined;
    companyId?: number;
    description?: string | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    programConfigurations?: ProgramConfigurationResponseDto[] | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    timelyOnly?: boolean;
    claimTypes?: string[] | undefined;
    participants?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    icn?: string | undefined;
    documentTypes?: string[] | undefined;
    cutoffDateTime?: Date;

    constructor(data?: IMbccnCreateSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.payor = _data["payor"];
            this.program = _data["program"];
            if (Array.isArray(_data["programConfigurations"])) {
                this.programConfigurations = [] as any;
                for (let item of _data["programConfigurations"])
                    this.programConfigurations!.push(ProgramConfigurationResponseDto.fromJS(item));
            }
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.timelyOnly = _data["timelyOnly"];
            if (Array.isArray(_data["claimTypes"])) {
                this.claimTypes = [] as any;
                for (let item of _data["claimTypes"])
                    this.claimTypes!.push(item);
            }
            this.participants = _data["participants"];
            this.authCode = _data["authCode"];
            this.servCode = _data["servCode"];
            this.icn = _data["icn"];
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            this.cutoffDateTime = _data["cutoffDateTime"] ? new Date(_data["cutoffDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MbccnCreateSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new MbccnCreateSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["payor"] = this.payor;
        data["program"] = this.program;
        if (Array.isArray(this.programConfigurations)) {
            data["programConfigurations"] = [];
            for (let item of this.programConfigurations)
                data["programConfigurations"].push(item.toJSON());
        }
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["timelyOnly"] = this.timelyOnly;
        if (Array.isArray(this.claimTypes)) {
            data["claimTypes"] = [];
            for (let item of this.claimTypes)
                data["claimTypes"].push(item);
        }
        data["participants"] = this.participants;
        data["authCode"] = this.authCode;
        data["servCode"] = this.servCode;
        data["icn"] = this.icn;
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        data["cutoffDateTime"] = this.cutoffDateTime ? this.cutoffDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMbccnCreateSearchCriteria {
    id?: number;
    templateName?: string | undefined;
    companyId?: number;
    description?: string | undefined;
    payor?: string | undefined;
    program?: string | undefined;
    programConfigurations?: ProgramConfigurationResponseDto[] | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    timelyOnly?: boolean;
    claimTypes?: string[] | undefined;
    participants?: string | undefined;
    authCode?: string | undefined;
    servCode?: string | undefined;
    icn?: string | undefined;
    documentTypes?: string[] | undefined;
    cutoffDateTime?: Date;
}

export class McnIdResponse implements IMcnIdResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    rowValidationMessages?: ShiftInjectorResponseModel[] | undefined;
    id?: number;
    batchNumber?: string | undefined;
    mcnId?: number;

    constructor(data?: IMcnIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            if (Array.isArray(_data["rowValidationMessages"])) {
                this.rowValidationMessages = [] as any;
                for (let item of _data["rowValidationMessages"])
                    this.rowValidationMessages!.push(ShiftInjectorResponseModel.fromJS(item));
            }
            this.id = _data["id"];
            this.batchNumber = _data["batchNumber"];
            this.mcnId = _data["mcnId"];
        }
    }

    static fromJS(data: any): McnIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new McnIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        if (Array.isArray(this.rowValidationMessages)) {
            data["rowValidationMessages"] = [];
            for (let item of this.rowValidationMessages)
                data["rowValidationMessages"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["batchNumber"] = this.batchNumber;
        data["mcnId"] = this.mcnId;
        return data;
    }
}

export interface IMcnIdResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    rowValidationMessages?: ShiftInjectorResponseModel[] | undefined;
    id?: number;
    batchNumber?: string | undefined;
    mcnId?: number;
}

export class McnLookupResponseDto implements IMcnLookupResponseDto {
    id?: number;
    participantId?: string | undefined;
    mcnCode?: string | undefined;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    checkDate?: Date | undefined;
    payor?: string | undefined;
    depRefNumber?: string | undefined;
    mcnAmount?: number | undefined;
    remainingAmount?: number | undefined;

    constructor(data?: IMcnLookupResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantId = _data["participantId"];
            this.mcnCode = _data["mcnCode"];
            this.checkNumber = _data["checkNumber"];
            this.checkAmount = _data["checkAmount"];
            this.checkDate = _data["checkDate"] ? new Date(_data["checkDate"].toString()) : <any>undefined;
            this.payor = _data["payor"];
            this.depRefNumber = _data["depRefNumber"];
            this.mcnAmount = _data["mcnAmount"];
            this.remainingAmount = _data["remainingAmount"];
        }
    }

    static fromJS(data: any): McnLookupResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new McnLookupResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantId"] = this.participantId;
        data["mcnCode"] = this.mcnCode;
        data["checkNumber"] = this.checkNumber;
        data["checkAmount"] = this.checkAmount;
        data["checkDate"] = this.checkDate ? this.checkDate.toISOString() : <any>undefined;
        data["payor"] = this.payor;
        data["depRefNumber"] = this.depRefNumber;
        data["mcnAmount"] = this.mcnAmount;
        data["remainingAmount"] = this.remainingAmount;
        return data;
    }
}

export interface IMcnLookupResponseDto {
    id?: number;
    participantId?: string | undefined;
    mcnCode?: string | undefined;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    checkDate?: Date | undefined;
    payor?: string | undefined;
    depRefNumber?: string | undefined;
    mcnAmount?: number | undefined;
    remainingAmount?: number | undefined;
}

export class McnLookupResponseDtoGridResponseBase implements IMcnLookupResponseDtoGridResponseBase {
    items?: McnLookupResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: McnLookupResponseDto;

    constructor(data?: IMcnLookupResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(McnLookupResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? McnLookupResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): McnLookupResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new McnLookupResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMcnLookupResponseDtoGridResponseBase {
    items?: McnLookupResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: McnLookupResponseDto;
}

export class McnStatusStatusHistory implements IMcnStatusStatusHistory {
    status?: number;
    timeStamp?: Date;
    userDetails?: string | undefined;
    readonly statusText?: string | undefined;

    constructor(data?: IMcnStatusStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.userDetails = _data["userDetails"];
            (<any>this).statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): McnStatusStatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new McnStatusStatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["userDetails"] = this.userDetails;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IMcnStatusStatusHistory {
    status?: number;
    timeStamp?: Date;
    userDetails?: string | undefined;
    statusText?: string | undefined;
}

export class McnStatusStatusHistoryGridResponseBase implements IMcnStatusStatusHistoryGridResponseBase {
    items?: McnStatusStatusHistory[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: McnStatusStatusHistory;

    constructor(data?: IMcnStatusStatusHistoryGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(McnStatusStatusHistory.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? McnStatusStatusHistory.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): McnStatusStatusHistoryGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new McnStatusStatusHistoryGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMcnStatusStatusHistoryGridResponseBase {
    items?: McnStatusStatusHistory[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: McnStatusStatusHistory;
}

export class McnWriteOffDto implements IMcnWriteOffDto {
    id?: number | undefined;
    mcnId?: number | undefined;
    batchId?: number | undefined;
    woCauseId?: number | undefined;
    writeOffAmount?: number;
    woCause?: string | undefined;
    woErrorTypeId?: number | undefined;
    woErrorType?: string | undefined;

    constructor(data?: IMcnWriteOffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mcnId = _data["mcnId"];
            this.batchId = _data["batchId"];
            this.woCauseId = _data["woCauseId"];
            this.writeOffAmount = _data["writeOffAmount"];
            this.woCause = _data["woCause"];
            this.woErrorTypeId = _data["woErrorTypeId"];
            this.woErrorType = _data["woErrorType"];
        }
    }

    static fromJS(data: any): McnWriteOffDto {
        data = typeof data === 'object' ? data : {};
        let result = new McnWriteOffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mcnId"] = this.mcnId;
        data["batchId"] = this.batchId;
        data["woCauseId"] = this.woCauseId;
        data["writeOffAmount"] = this.writeOffAmount;
        data["woCause"] = this.woCause;
        data["woErrorTypeId"] = this.woErrorTypeId;
        data["woErrorType"] = this.woErrorType;
        return data;
    }
}

export interface IMcnWriteOffDto {
    id?: number | undefined;
    mcnId?: number | undefined;
    batchId?: number | undefined;
    woCauseId?: number | undefined;
    writeOffAmount?: number;
    woCause?: string | undefined;
    woErrorTypeId?: number | undefined;
    woErrorType?: string | undefined;
}

export class MultiplePaymentsForLcnDto implements IMultiplePaymentsForLcnDto {
    id?: number | undefined;
    pbcnId?: number;
    lcn?: string | undefined;
    appliedAmount?: number;
    copayAmount?: number;
    ecn?: string | undefined;
    adjustmentCodes?: LcnEcnAdjustmentCodeDto[] | undefined;
    remarkCodes?: LcnEcnRemarkCodeDto[] | undefined;
    groupCodes?: LcnEcnGroupCodeDto[] | undefined;
    createdOn?: Date;
    servicePaymentId?: number | undefined;

    constructor(data?: IMultiplePaymentsForLcnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pbcnId = _data["pbcnId"];
            this.lcn = _data["lcn"];
            this.appliedAmount = _data["appliedAmount"];
            this.copayAmount = _data["copayAmount"];
            this.ecn = _data["ecn"];
            if (Array.isArray(_data["adjustmentCodes"])) {
                this.adjustmentCodes = [] as any;
                for (let item of _data["adjustmentCodes"])
                    this.adjustmentCodes!.push(LcnEcnAdjustmentCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["remarkCodes"])) {
                this.remarkCodes = [] as any;
                for (let item of _data["remarkCodes"])
                    this.remarkCodes!.push(LcnEcnRemarkCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["groupCodes"])) {
                this.groupCodes = [] as any;
                for (let item of _data["groupCodes"])
                    this.groupCodes!.push(LcnEcnGroupCodeDto.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.servicePaymentId = _data["servicePaymentId"];
        }
    }

    static fromJS(data: any): MultiplePaymentsForLcnDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplePaymentsForLcnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pbcnId"] = this.pbcnId;
        data["lcn"] = this.lcn;
        data["appliedAmount"] = this.appliedAmount;
        data["copayAmount"] = this.copayAmount;
        data["ecn"] = this.ecn;
        if (Array.isArray(this.adjustmentCodes)) {
            data["adjustmentCodes"] = [];
            for (let item of this.adjustmentCodes)
                data["adjustmentCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.remarkCodes)) {
            data["remarkCodes"] = [];
            for (let item of this.remarkCodes)
                data["remarkCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.groupCodes)) {
            data["groupCodes"] = [];
            for (let item of this.groupCodes)
                data["groupCodes"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["servicePaymentId"] = this.servicePaymentId;
        return data;
    }
}

export interface IMultiplePaymentsForLcnDto {
    id?: number | undefined;
    pbcnId?: number;
    lcn?: string | undefined;
    appliedAmount?: number;
    copayAmount?: number;
    ecn?: string | undefined;
    adjustmentCodes?: LcnEcnAdjustmentCodeDto[] | undefined;
    remarkCodes?: LcnEcnRemarkCodeDto[] | undefined;
    groupCodes?: LcnEcnGroupCodeDto[] | undefined;
    createdOn?: Date;
    servicePaymentId?: number | undefined;
}

export enum OvertimeBilling {
    None = "None",
    Weekly = "Weekly",
}

export class ParticipantAppliedPayments implements IParticipantAppliedPayments {
    servicePaymentId?: number;
    appliedMCNAmount?: number;
    remainingMCNAmount?: number;
    claimLineId?: number;

    constructor(data?: IParticipantAppliedPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servicePaymentId = _data["servicePaymentId"];
            this.appliedMCNAmount = _data["appliedMCNAmount"];
            this.remainingMCNAmount = _data["remainingMCNAmount"];
            this.claimLineId = _data["claimLineId"];
        }
    }

    static fromJS(data: any): ParticipantAppliedPayments {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantAppliedPayments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servicePaymentId"] = this.servicePaymentId;
        data["appliedMCNAmount"] = this.appliedMCNAmount;
        data["remainingMCNAmount"] = this.remainingMCNAmount;
        data["claimLineId"] = this.claimLineId;
        return data;
    }
}

export interface IParticipantAppliedPayments {
    servicePaymentId?: number;
    appliedMCNAmount?: number;
    remainingMCNAmount?: number;
    claimLineId?: number;
}

export class ParticipantPaymentsDataDto implements IParticipantPaymentsDataDto {
    servicePaymentId?: number;
    unAppliedAmount?: number | undefined;

    constructor(data?: IParticipantPaymentsDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servicePaymentId = _data["servicePaymentId"];
            this.unAppliedAmount = _data["unAppliedAmount"];
        }
    }

    static fromJS(data: any): ParticipantPaymentsDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantPaymentsDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servicePaymentId"] = this.servicePaymentId;
        data["unAppliedAmount"] = this.unAppliedAmount;
        return data;
    }
}

export interface IParticipantPaymentsDataDto {
    servicePaymentId?: number;
    unAppliedAmount?: number | undefined;
}

export class ParticipantPaymentsDataRequestDto implements IParticipantPaymentsDataRequestDto {
    batchId?: number;
    participantId?: string | undefined;
    companyId?: number;

    constructor(data?: IParticipantPaymentsDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.participantId = _data["participantId"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ParticipantPaymentsDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantPaymentsDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["participantId"] = this.participantId;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IParticipantPaymentsDataRequestDto {
    batchId?: number;
    participantId?: string | undefined;
    companyId?: number;
}

export class ParticipantPendingPayment implements IParticipantPendingPayment {
    items?: PendingPaymentsResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PendingPaymentsResponseDto;
    originalAmount?: number | undefined;
    appliedAmount?: number;
    paidClaimsAppliedAmount?: number | undefined;

    constructor(data?: IParticipantPendingPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PendingPaymentsResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PendingPaymentsResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.originalAmount = _data["originalAmount"];
            this.appliedAmount = _data["appliedAmount"];
            this.paidClaimsAppliedAmount = _data["paidClaimsAppliedAmount"];
        }
    }

    static fromJS(data: any): ParticipantPendingPayment {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantPendingPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["originalAmount"] = this.originalAmount;
        data["appliedAmount"] = this.appliedAmount;
        data["paidClaimsAppliedAmount"] = this.paidClaimsAppliedAmount;
        return data;
    }
}

export interface IParticipantPendingPayment {
    items?: PendingPaymentsResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PendingPaymentsResponseDto;
    originalAmount?: number | undefined;
    appliedAmount?: number;
    paidClaimsAppliedAmount?: number | undefined;
}

export class PatientPaySummaryDetails implements IPatientPaySummaryDetails {
    patientPaySummaryID?: number | undefined;
    svcCode?: string | undefined;
    transactionDate?: Date | undefined;
    amount?: number;
    payorIntegrationKey?: string | undefined;
    exLedgerID?: string | undefined;
    exLedgerType?: string | undefined;
    clientId?: string | undefined;
    participantPersonId?: string | undefined;
    isSummaryRecordExist?: boolean;
    type?: string | undefined;
    subType?: string | undefined;
    isLedge?: boolean;
    externalRecordId?: string | undefined;
    servLnStartDate?: Date | undefined;
    servLnEndDate?: Date | undefined;
    isValid?: boolean;

    constructor(data?: IPatientPaySummaryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPaySummaryID = _data["patientPaySummaryID"];
            this.svcCode = _data["svcCode"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.payorIntegrationKey = _data["payorIntegrationKey"];
            this.exLedgerID = _data["exLedgerID"];
            this.exLedgerType = _data["exLedgerType"];
            this.clientId = _data["clientId"];
            this.participantPersonId = _data["participantPersonId"];
            this.isSummaryRecordExist = _data["isSummaryRecordExist"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.isLedge = _data["isLedge"];
            this.externalRecordId = _data["externalRecordId"];
            this.servLnStartDate = _data["servLnStartDate"] ? new Date(_data["servLnStartDate"].toString()) : <any>undefined;
            this.servLnEndDate = _data["servLnEndDate"] ? new Date(_data["servLnEndDate"].toString()) : <any>undefined;
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): PatientPaySummaryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPaySummaryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPaySummaryID"] = this.patientPaySummaryID;
        data["svcCode"] = this.svcCode;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["payorIntegrationKey"] = this.payorIntegrationKey;
        data["exLedgerID"] = this.exLedgerID;
        data["exLedgerType"] = this.exLedgerType;
        data["clientId"] = this.clientId;
        data["participantPersonId"] = this.participantPersonId;
        data["isSummaryRecordExist"] = this.isSummaryRecordExist;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["isLedge"] = this.isLedge;
        data["externalRecordId"] = this.externalRecordId;
        data["servLnStartDate"] = this.servLnStartDate ? this.servLnStartDate.toISOString() : <any>undefined;
        data["servLnEndDate"] = this.servLnEndDate ? this.servLnEndDate.toISOString() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IPatientPaySummaryDetails {
    patientPaySummaryID?: number | undefined;
    svcCode?: string | undefined;
    transactionDate?: Date | undefined;
    amount?: number;
    payorIntegrationKey?: string | undefined;
    exLedgerID?: string | undefined;
    exLedgerType?: string | undefined;
    clientId?: string | undefined;
    participantPersonId?: string | undefined;
    isSummaryRecordExist?: boolean;
    type?: string | undefined;
    subType?: string | undefined;
    isLedge?: boolean;
    externalRecordId?: string | undefined;
    servLnStartDate?: Date | undefined;
    servLnEndDate?: Date | undefined;
    isValid?: boolean;
}

export class Payment implements IPayment {
    type?: string | undefined;
    mcn?: string | undefined;
    lcn?: string | undefined;
    paymentBatchNumber?: string | undefined;
    check?: string | undefined;
    checkDate?: Date;
    appliedDate?: Date;
    appliedAmount?: number;
    icn?: string | undefined;
    user?: string | undefined;
    copayAmount?: number | undefined;
    paymentType?: PaymentBatchType;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.mcn = _data["mcn"];
            this.lcn = _data["lcn"];
            this.paymentBatchNumber = _data["paymentBatchNumber"];
            this.check = _data["check"];
            this.checkDate = _data["checkDate"] ? new Date(_data["checkDate"].toString()) : <any>undefined;
            this.appliedDate = _data["appliedDate"] ? new Date(_data["appliedDate"].toString()) : <any>undefined;
            this.appliedAmount = _data["appliedAmount"];
            this.icn = _data["icn"];
            this.user = _data["user"];
            this.copayAmount = _data["copayAmount"];
            this.paymentType = _data["paymentType"];
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["mcn"] = this.mcn;
        data["lcn"] = this.lcn;
        data["paymentBatchNumber"] = this.paymentBatchNumber;
        data["check"] = this.check;
        data["checkDate"] = this.checkDate ? this.checkDate.toISOString() : <any>undefined;
        data["appliedDate"] = this.appliedDate ? this.appliedDate.toISOString() : <any>undefined;
        data["appliedAmount"] = this.appliedAmount;
        data["icn"] = this.icn;
        data["user"] = this.user;
        data["copayAmount"] = this.copayAmount;
        data["paymentType"] = this.paymentType;
        return data;
    }
}

export interface IPayment {
    type?: string | undefined;
    mcn?: string | undefined;
    lcn?: string | undefined;
    paymentBatchNumber?: string | undefined;
    check?: string | undefined;
    checkDate?: Date;
    appliedDate?: Date;
    appliedAmount?: number;
    icn?: string | undefined;
    user?: string | undefined;
    copayAmount?: number | undefined;
    paymentType?: PaymentBatchType;
}

export class PaymentApplicationRequestDto implements IPaymentApplicationRequestDto {
    companyId?: number;
    participantId?: string | undefined;
    participantName?: string | undefined;
    mcn?: string | undefined;
    batchId?: number;
    payor?: string | undefined;
    batchNumber?: string | undefined;
    checkNumber?: string | undefined;
    depRefNumber?: string | undefined;
    unappliedAmount?: number;
    pendingPayments?: PaymentApplicationResponseDto[] | undefined;
    checkDate?: Date | undefined;

    constructor(data?: IPaymentApplicationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.participantId = _data["participantId"];
            this.participantName = _data["participantName"];
            this.mcn = _data["mcn"];
            this.batchId = _data["batchId"];
            this.payor = _data["payor"];
            this.batchNumber = _data["batchNumber"];
            this.checkNumber = _data["checkNumber"];
            this.depRefNumber = _data["depRefNumber"];
            this.unappliedAmount = _data["unappliedAmount"];
            if (Array.isArray(_data["pendingPayments"])) {
                this.pendingPayments = [] as any;
                for (let item of _data["pendingPayments"])
                    this.pendingPayments!.push(PaymentApplicationResponseDto.fromJS(item));
            }
            this.checkDate = _data["checkDate"] ? new Date(_data["checkDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentApplicationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentApplicationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["mcn"] = this.mcn;
        data["batchId"] = this.batchId;
        data["payor"] = this.payor;
        data["batchNumber"] = this.batchNumber;
        data["checkNumber"] = this.checkNumber;
        data["depRefNumber"] = this.depRefNumber;
        data["unappliedAmount"] = this.unappliedAmount;
        if (Array.isArray(this.pendingPayments)) {
            data["pendingPayments"] = [];
            for (let item of this.pendingPayments)
                data["pendingPayments"].push(item.toJSON());
        }
        data["checkDate"] = this.checkDate ? this.checkDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPaymentApplicationRequestDto {
    companyId?: number;
    participantId?: string | undefined;
    participantName?: string | undefined;
    mcn?: string | undefined;
    batchId?: number;
    payor?: string | undefined;
    batchNumber?: string | undefined;
    checkNumber?: string | undefined;
    depRefNumber?: string | undefined;
    unappliedAmount?: number;
    pendingPayments?: PaymentApplicationResponseDto[] | undefined;
    checkDate?: Date | undefined;
}

export class PaymentApplicationResponseDto implements IPaymentApplicationResponseDto {
    claimLineId?: number;
    claimLineCreatedDate?: Date | undefined;
    ccn?: string | undefined;
    lcn?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    originalAmount?: number | undefined;
    outstandingAmount?: number | undefined;
    originalOutstandingAmount?: number | undefined;
    appliedAmount?: number | undefined;
    originalAppliedAmount?: number | undefined;
    createdOn?: Date;
    status?: number | undefined;
    readonly statusText?: string | undefined;
    writeOffAmount?: number | undefined;
    remarkCodes?: LcnRemarkCodeDto[] | undefined;
    adjustmentCodes?: LcnAdjustmentCodeDto[] | undefined;
    groupCodes?: LcnGroupCodeDto[] | undefined;
    copayAmount?: number | undefined;
    multiplePayments?: MultiplePaymentsForLcnDto[] | undefined;
    icn?: string | undefined;
    billUnits?: number | undefined;
    hasMultiplePayments?: boolean;
    isCurrentBatch?: boolean;
    servicePaymentReceivedId?: number | undefined;

    constructor(data?: IPaymentApplicationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimLineId = _data["claimLineId"];
            this.claimLineCreatedDate = _data["claimLineCreatedDate"] ? new Date(_data["claimLineCreatedDate"].toString()) : <any>undefined;
            this.ccn = _data["ccn"];
            this.lcn = _data["lcn"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.originalAmount = _data["originalAmount"];
            this.outstandingAmount = _data["outstandingAmount"];
            this.originalOutstandingAmount = _data["originalOutstandingAmount"];
            this.appliedAmount = _data["appliedAmount"];
            this.originalAppliedAmount = _data["originalAppliedAmount"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            (<any>this).statusText = _data["statusText"];
            this.writeOffAmount = _data["writeOffAmount"];
            if (Array.isArray(_data["remarkCodes"])) {
                this.remarkCodes = [] as any;
                for (let item of _data["remarkCodes"])
                    this.remarkCodes!.push(LcnRemarkCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["adjustmentCodes"])) {
                this.adjustmentCodes = [] as any;
                for (let item of _data["adjustmentCodes"])
                    this.adjustmentCodes!.push(LcnAdjustmentCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["groupCodes"])) {
                this.groupCodes = [] as any;
                for (let item of _data["groupCodes"])
                    this.groupCodes!.push(LcnGroupCodeDto.fromJS(item));
            }
            this.copayAmount = _data["copayAmount"];
            if (Array.isArray(_data["multiplePayments"])) {
                this.multiplePayments = [] as any;
                for (let item of _data["multiplePayments"])
                    this.multiplePayments!.push(MultiplePaymentsForLcnDto.fromJS(item));
            }
            this.icn = _data["icn"];
            this.billUnits = _data["billUnits"];
            this.hasMultiplePayments = _data["hasMultiplePayments"];
            this.isCurrentBatch = _data["isCurrentBatch"];
            this.servicePaymentReceivedId = _data["servicePaymentReceivedId"];
        }
    }

    static fromJS(data: any): PaymentApplicationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentApplicationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimLineId"] = this.claimLineId;
        data["claimLineCreatedDate"] = this.claimLineCreatedDate ? this.claimLineCreatedDate.toISOString() : <any>undefined;
        data["ccn"] = this.ccn;
        data["lcn"] = this.lcn;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["originalAmount"] = this.originalAmount;
        data["outstandingAmount"] = this.outstandingAmount;
        data["originalOutstandingAmount"] = this.originalOutstandingAmount;
        data["appliedAmount"] = this.appliedAmount;
        data["originalAppliedAmount"] = this.originalAppliedAmount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["writeOffAmount"] = this.writeOffAmount;
        if (Array.isArray(this.remarkCodes)) {
            data["remarkCodes"] = [];
            for (let item of this.remarkCodes)
                data["remarkCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.adjustmentCodes)) {
            data["adjustmentCodes"] = [];
            for (let item of this.adjustmentCodes)
                data["adjustmentCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.groupCodes)) {
            data["groupCodes"] = [];
            for (let item of this.groupCodes)
                data["groupCodes"].push(item.toJSON());
        }
        data["copayAmount"] = this.copayAmount;
        if (Array.isArray(this.multiplePayments)) {
            data["multiplePayments"] = [];
            for (let item of this.multiplePayments)
                data["multiplePayments"].push(item.toJSON());
        }
        data["icn"] = this.icn;
        data["billUnits"] = this.billUnits;
        data["hasMultiplePayments"] = this.hasMultiplePayments;
        data["isCurrentBatch"] = this.isCurrentBatch;
        data["servicePaymentReceivedId"] = this.servicePaymentReceivedId;
        return data;
    }
}

export interface IPaymentApplicationResponseDto {
    claimLineId?: number;
    claimLineCreatedDate?: Date | undefined;
    ccn?: string | undefined;
    lcn?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    originalAmount?: number | undefined;
    outstandingAmount?: number | undefined;
    originalOutstandingAmount?: number | undefined;
    appliedAmount?: number | undefined;
    originalAppliedAmount?: number | undefined;
    createdOn?: Date;
    status?: number | undefined;
    statusText?: string | undefined;
    writeOffAmount?: number | undefined;
    remarkCodes?: LcnRemarkCodeDto[] | undefined;
    adjustmentCodes?: LcnAdjustmentCodeDto[] | undefined;
    groupCodes?: LcnGroupCodeDto[] | undefined;
    copayAmount?: number | undefined;
    multiplePayments?: MultiplePaymentsForLcnDto[] | undefined;
    icn?: string | undefined;
    billUnits?: number | undefined;
    hasMultiplePayments?: boolean;
    isCurrentBatch?: boolean;
    servicePaymentReceivedId?: number | undefined;
}

export class PaymentBatchDeleteRequestDto implements IPaymentBatchDeleteRequestDto {
    ids?: number[] | undefined;
    batchIds?: string[] | undefined;

    constructor(data?: IPaymentBatchDeleteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["batchIds"])) {
                this.batchIds = [] as any;
                for (let item of _data["batchIds"])
                    this.batchIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PaymentBatchDeleteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatchDeleteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.batchIds)) {
            data["batchIds"] = [];
            for (let item of this.batchIds)
                data["batchIds"].push(item);
        }
        return data;
    }
}

export interface IPaymentBatchDeleteRequestDto {
    ids?: number[] | undefined;
    batchIds?: string[] | undefined;
}

export class PaymentBatchExportRequest implements IPaymentBatchExportRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    batchNumber?: string | undefined;
    participantId?: string | undefined;
    paymentType?: string | undefined;

    constructor(data?: IPaymentBatchExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.batchNumber = _data["batchNumber"];
            this.participantId = _data["participantId"];
            this.paymentType = _data["paymentType"];
        }
    }

    static fromJS(data: any): PaymentBatchExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatchExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["batchNumber"] = this.batchNumber;
        data["participantId"] = this.participantId;
        data["paymentType"] = this.paymentType;
        return data;
    }
}

export interface IPaymentBatchExportRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    batchNumber?: string | undefined;
    participantId?: string | undefined;
    paymentType?: string | undefined;
}

export class PaymentBatchHistoryDto implements IPaymentBatchHistoryDto {
    status?: string | undefined;
    timeStamp?: Date;
    userDetails?: string | undefined;

    constructor(data?: IPaymentBatchHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.userDetails = _data["userDetails"];
        }
    }

    static fromJS(data: any): PaymentBatchHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatchHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["userDetails"] = this.userDetails;
        return data;
    }
}

export interface IPaymentBatchHistoryDto {
    status?: string | undefined;
    timeStamp?: Date;
    userDetails?: string | undefined;
}

export class PaymentBatchHistoryDtoGridResponseBase implements IPaymentBatchHistoryDtoGridResponseBase {
    items?: PaymentBatchHistoryDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PaymentBatchHistoryDto;

    constructor(data?: IPaymentBatchHistoryDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentBatchHistoryDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PaymentBatchHistoryDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentBatchHistoryDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatchHistoryDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaymentBatchHistoryDtoGridResponseBase {
    items?: PaymentBatchHistoryDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PaymentBatchHistoryDto;
}

export class PaymentBatchRejectRequestDto implements IPaymentBatchRejectRequestDto {
    batchId?: string | undefined;
    rejectReason?: string | undefined;

    constructor(data?: IPaymentBatchRejectRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.rejectReason = _data["rejectReason"];
        }
    }

    static fromJS(data: any): PaymentBatchRejectRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatchRejectRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["rejectReason"] = this.rejectReason;
        return data;
    }
}

export interface IPaymentBatchRejectRequestDto {
    batchId?: string | undefined;
    rejectReason?: string | undefined;
}

export enum PaymentBatchType {
    Auto = "Auto",
    Manual = "Manual",
    WriteOff = "WriteOff",
    UnappliedWriteOff = "UnappliedWriteOff",
    ApplicationUpdate = "ApplicationUpdate",
    ClaimBatch = "ClaimBatch",
}

export class PaymentReclassifyRequestDto implements IPaymentReclassifyRequestDto {
    companyId?: number;
    participantId?: string | undefined;
    mcn?: string | undefined;
    newParticipantId?: string | undefined;
    newParticipantName?: string | undefined;
    reclassifyAmount?: number;

    constructor(data?: IPaymentReclassifyRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.participantId = _data["participantId"];
            this.mcn = _data["mcn"];
            this.newParticipantId = _data["newParticipantId"];
            this.newParticipantName = _data["newParticipantName"];
            this.reclassifyAmount = _data["reclassifyAmount"];
        }
    }

    static fromJS(data: any): PaymentReclassifyRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentReclassifyRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["participantId"] = this.participantId;
        data["mcn"] = this.mcn;
        data["newParticipantId"] = this.newParticipantId;
        data["newParticipantName"] = this.newParticipantName;
        data["reclassifyAmount"] = this.reclassifyAmount;
        return data;
    }
}

export interface IPaymentReclassifyRequestDto {
    companyId?: number;
    participantId?: string | undefined;
    mcn?: string | undefined;
    newParticipantId?: string | undefined;
    newParticipantName?: string | undefined;
    reclassifyAmount?: number;
}

export class PaymentsBatchDto implements IPaymentsBatchDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number | undefined;
    pbcnId?: string | undefined;
    payorName?: string | undefined;
    payorId?: number | undefined;
    transactionNumber?: string | undefined;
    checkNumber?: string | undefined;
    checkDate?: Date | undefined;
    batchDate?: Date | undefined;
    description?: string | undefined;
    userEmail?: string | undefined;
    companyId?: number;
    batchStatus?: string | undefined;
    paymentType?: string | undefined;
    appliedAmount?: number;
    checkAmount?: number;
    adjustmentAmount?: number;
    depRefNumber?: string | undefined;
    remitNumber?: string | undefined;
    interestAmount?: number;
    docuwareLink?: string | undefined;
    applicationCount?: number | undefined;
    unappliedAmount?: number;
    notes?: string | undefined;
    submittedAmount?: number;
    rejectReason?: string | undefined;
    copayTotal?: number | undefined;
    isProcessing?: boolean;
    type?: PaymentBatchType;

    constructor(data?: IPaymentsBatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.pbcnId = _data["pbcnId"];
            this.payorName = _data["payorName"];
            this.payorId = _data["payorId"];
            this.transactionNumber = _data["transactionNumber"];
            this.checkNumber = _data["checkNumber"];
            this.checkDate = _data["checkDate"] ? new Date(_data["checkDate"].toString()) : <any>undefined;
            this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.userEmail = _data["userEmail"];
            this.companyId = _data["companyId"];
            this.batchStatus = _data["batchStatus"];
            this.paymentType = _data["paymentType"];
            this.appliedAmount = _data["appliedAmount"];
            this.checkAmount = _data["checkAmount"];
            this.adjustmentAmount = _data["adjustmentAmount"];
            this.depRefNumber = _data["depRefNumber"];
            this.remitNumber = _data["remitNumber"];
            this.interestAmount = _data["interestAmount"];
            this.docuwareLink = _data["docuwareLink"];
            this.applicationCount = _data["applicationCount"];
            this.unappliedAmount = _data["unappliedAmount"];
            this.notes = _data["notes"];
            this.submittedAmount = _data["submittedAmount"];
            this.rejectReason = _data["rejectReason"];
            this.copayTotal = _data["copayTotal"];
            this.isProcessing = _data["isProcessing"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PaymentsBatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentsBatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["pbcnId"] = this.pbcnId;
        data["payorName"] = this.payorName;
        data["payorId"] = this.payorId;
        data["transactionNumber"] = this.transactionNumber;
        data["checkNumber"] = this.checkNumber;
        data["checkDate"] = this.checkDate ? this.checkDate.toISOString() : <any>undefined;
        data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["userEmail"] = this.userEmail;
        data["companyId"] = this.companyId;
        data["batchStatus"] = this.batchStatus;
        data["paymentType"] = this.paymentType;
        data["appliedAmount"] = this.appliedAmount;
        data["checkAmount"] = this.checkAmount;
        data["adjustmentAmount"] = this.adjustmentAmount;
        data["depRefNumber"] = this.depRefNumber;
        data["remitNumber"] = this.remitNumber;
        data["interestAmount"] = this.interestAmount;
        data["docuwareLink"] = this.docuwareLink;
        data["applicationCount"] = this.applicationCount;
        data["unappliedAmount"] = this.unappliedAmount;
        data["notes"] = this.notes;
        data["submittedAmount"] = this.submittedAmount;
        data["rejectReason"] = this.rejectReason;
        data["copayTotal"] = this.copayTotal;
        data["isProcessing"] = this.isProcessing;
        data["type"] = this.type;
        return data;
    }
}

export interface IPaymentsBatchDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number | undefined;
    pbcnId?: string | undefined;
    payorName?: string | undefined;
    payorId?: number | undefined;
    transactionNumber?: string | undefined;
    checkNumber?: string | undefined;
    checkDate?: Date | undefined;
    batchDate?: Date | undefined;
    description?: string | undefined;
    userEmail?: string | undefined;
    companyId?: number;
    batchStatus?: string | undefined;
    paymentType?: string | undefined;
    appliedAmount?: number;
    checkAmount?: number;
    adjustmentAmount?: number;
    depRefNumber?: string | undefined;
    remitNumber?: string | undefined;
    interestAmount?: number;
    docuwareLink?: string | undefined;
    applicationCount?: number | undefined;
    unappliedAmount?: number;
    notes?: string | undefined;
    submittedAmount?: number;
    rejectReason?: string | undefined;
    copayTotal?: number | undefined;
    isProcessing?: boolean;
    type?: PaymentBatchType;
}

export class PaymentsBatchDtoGridResponseBase implements IPaymentsBatchDtoGridResponseBase {
    items?: PaymentsBatchDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PaymentsBatchDto;

    constructor(data?: IPaymentsBatchDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentsBatchDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PaymentsBatchDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentsBatchDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentsBatchDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaymentsBatchDtoGridResponseBase {
    items?: PaymentsBatchDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PaymentsBatchDto;
}

export class PaymentsBatchRequestDto implements IPaymentsBatchRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    companyId?: number;
    searchParameter?: string | undefined;
    fetchDeletedBatch?: boolean;
    filterType?: string;

    constructor(data?: IPaymentsBatchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.companyId = _data["companyId"];
            this.searchParameter = _data["searchParameter"];
            this.fetchDeletedBatch = _data["fetchDeletedBatch"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): PaymentsBatchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentsBatchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["companyId"] = this.companyId;
        data["searchParameter"] = this.searchParameter;
        data["fetchDeletedBatch"] = this.fetchDeletedBatch;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IPaymentsBatchRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    companyId?: number;
    searchParameter?: string | undefined;
    fetchDeletedBatch?: boolean;
    filterType?: string | undefined;
}

export class PayorInfo implements IPayorInfo {
    payorId?: string | undefined;
    payorName?: string | undefined;
    nationalPlanId?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateName?: string | undefined;
    zip?: string | undefined;
    api?: string | undefined;

    constructor(data?: IPayorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.nationalPlanId = _data["nationalPlanId"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.stateName = _data["stateName"];
            this.zip = _data["zip"];
            this.api = _data["api"];
        }
    }

    static fromJS(data: any): PayorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PayorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["nationalPlanId"] = this.nationalPlanId;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["stateName"] = this.stateName;
        data["zip"] = this.zip;
        data["api"] = this.api;
        return data;
    }
}

export interface IPayorInfo {
    payorId?: string | undefined;
    payorName?: string | undefined;
    nationalPlanId?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    stateName?: string | undefined;
    zip?: string | undefined;
    api?: string | undefined;
}

export enum PcnStatus {
    New = "New",
    InProgress = "InProgress",
    ReadyToBePaid = "ReadyToBePaid",
    Paid = "Paid",
    Hold = "Hold",
    NeverToBePaid = "NeverToBePaid",
    Processed = "Processed",
}

export class PendingPaymentsDto implements IPendingPaymentsDto {
    pendingPayments?: PendingPaymentsResponseDto[] | undefined;
    batchId?: number;
    paymentType?: string | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    companyId?: number;
    originalAmount?: number;
    remainingOriginalAmount?: number;
    participantLastName?: string | undefined;
    isTotalPaymentToBeSaved?: boolean | undefined;
    insuredId?: string | undefined;

    constructor(data?: IPendingPaymentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pendingPayments"])) {
                this.pendingPayments = [] as any;
                for (let item of _data["pendingPayments"])
                    this.pendingPayments!.push(PendingPaymentsResponseDto.fromJS(item));
            }
            this.batchId = _data["batchId"];
            this.paymentType = _data["paymentType"];
            this.participantId = _data["participantId"];
            this.participantName = _data["participantName"];
            this.companyId = _data["companyId"];
            this.originalAmount = _data["originalAmount"];
            this.remainingOriginalAmount = _data["remainingOriginalAmount"];
            this.participantLastName = _data["participantLastName"];
            this.isTotalPaymentToBeSaved = _data["isTotalPaymentToBeSaved"];
            this.insuredId = _data["insuredId"];
        }
    }

    static fromJS(data: any): PendingPaymentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingPaymentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pendingPayments)) {
            data["pendingPayments"] = [];
            for (let item of this.pendingPayments)
                data["pendingPayments"].push(item.toJSON());
        }
        data["batchId"] = this.batchId;
        data["paymentType"] = this.paymentType;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["companyId"] = this.companyId;
        data["originalAmount"] = this.originalAmount;
        data["remainingOriginalAmount"] = this.remainingOriginalAmount;
        data["participantLastName"] = this.participantLastName;
        data["isTotalPaymentToBeSaved"] = this.isTotalPaymentToBeSaved;
        data["insuredId"] = this.insuredId;
        return data;
    }
}

export interface IPendingPaymentsDto {
    pendingPayments?: PendingPaymentsResponseDto[] | undefined;
    batchId?: number;
    paymentType?: string | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    companyId?: number;
    originalAmount?: number;
    remainingOriginalAmount?: number;
    participantLastName?: string | undefined;
    isTotalPaymentToBeSaved?: boolean | undefined;
    insuredId?: string | undefined;
}

export class PendingPaymentsRequestDto implements IPendingPaymentsRequestDto {
    participantId?: string | undefined;
    companyId?: number;
    ccn?: string | undefined;
    batchId?: string | undefined;
    fetchAllPayments?: boolean;
    fromDate?: Date;
    toDate?: Date;

    constructor(data?: IPendingPaymentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.companyId = _data["companyId"];
            this.ccn = _data["ccn"];
            this.batchId = _data["batchId"];
            this.fetchAllPayments = _data["fetchAllPayments"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PendingPaymentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingPaymentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["companyId"] = this.companyId;
        data["ccn"] = this.ccn;
        data["batchId"] = this.batchId;
        data["fetchAllPayments"] = this.fetchAllPayments;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPendingPaymentsRequestDto {
    participantId?: string | undefined;
    companyId?: number;
    ccn?: string | undefined;
    batchId?: string | undefined;
    fetchAllPayments?: boolean;
    fromDate?: Date;
    toDate?: Date;
}

export class PendingPaymentsResponseDto implements IPendingPaymentsResponseDto {
    claimId?: number;
    claimPaymentReceivedId?: number | undefined;
    servicePaymentReceivedId?: number | undefined;
    ccn?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    insuredId?: string | undefined;
    claimLineId?: number;
    lcn?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    claimLineCreatedDate?: Date | undefined;
    claimStartDate?: Date | undefined;
    claimEndDate?: Date | undefined;
    readonly remainingAmount?: number | undefined;
    appliedRemainingAmount?: number | undefined;
    appliedAmount?: number | undefined;
    icn?: string | undefined;
    billUnits?: number | undefined;
    submittedAmount?: number | undefined;
    mcn?: string | undefined;
    appliedPayments?: ParticipantAppliedPayments[] | undefined;
    adjustmentCodes?: LcnAdjustmentCodeDto[] | undefined;
    groupCodes?: LcnGroupCodeDto[] | undefined;
    remarkCodes?: LcnRemarkCodeDto[] | undefined;
    status?: LCNStatus;
    readonly statusString?: string | undefined;
    copayAmount?: number | undefined;
    writeOffAmount?: number | undefined;
    multiplePayments?: MultiplePaymentsForLcnDto[] | undefined;
    hasMultiplePayments?: boolean;

    constructor(data?: IPendingPaymentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimId = _data["claimId"];
            this.claimPaymentReceivedId = _data["claimPaymentReceivedId"];
            this.servicePaymentReceivedId = _data["servicePaymentReceivedId"];
            this.ccn = _data["ccn"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.insuredId = _data["insuredId"];
            this.claimLineId = _data["claimLineId"];
            this.lcn = _data["lcn"];
            this.hcpcsCode = _data["hcpcsCode"];
            this.modifier = _data["modifier"];
            this.claimLineCreatedDate = _data["claimLineCreatedDate"] ? new Date(_data["claimLineCreatedDate"].toString()) : <any>undefined;
            this.claimStartDate = _data["claimStartDate"] ? new Date(_data["claimStartDate"].toString()) : <any>undefined;
            this.claimEndDate = _data["claimEndDate"] ? new Date(_data["claimEndDate"].toString()) : <any>undefined;
            (<any>this).remainingAmount = _data["remainingAmount"];
            this.appliedRemainingAmount = _data["appliedRemainingAmount"];
            this.appliedAmount = _data["appliedAmount"];
            this.icn = _data["icn"];
            this.billUnits = _data["billUnits"];
            this.submittedAmount = _data["submittedAmount"];
            this.mcn = _data["mcn"];
            if (Array.isArray(_data["appliedPayments"])) {
                this.appliedPayments = [] as any;
                for (let item of _data["appliedPayments"])
                    this.appliedPayments!.push(ParticipantAppliedPayments.fromJS(item));
            }
            if (Array.isArray(_data["adjustmentCodes"])) {
                this.adjustmentCodes = [] as any;
                for (let item of _data["adjustmentCodes"])
                    this.adjustmentCodes!.push(LcnAdjustmentCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["groupCodes"])) {
                this.groupCodes = [] as any;
                for (let item of _data["groupCodes"])
                    this.groupCodes!.push(LcnGroupCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["remarkCodes"])) {
                this.remarkCodes = [] as any;
                for (let item of _data["remarkCodes"])
                    this.remarkCodes!.push(LcnRemarkCodeDto.fromJS(item));
            }
            this.status = _data["status"];
            (<any>this).statusString = _data["statusString"];
            this.copayAmount = _data["copayAmount"];
            this.writeOffAmount = _data["writeOffAmount"];
            if (Array.isArray(_data["multiplePayments"])) {
                this.multiplePayments = [] as any;
                for (let item of _data["multiplePayments"])
                    this.multiplePayments!.push(MultiplePaymentsForLcnDto.fromJS(item));
            }
            this.hasMultiplePayments = _data["hasMultiplePayments"];
        }
    }

    static fromJS(data: any): PendingPaymentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingPaymentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimId"] = this.claimId;
        data["claimPaymentReceivedId"] = this.claimPaymentReceivedId;
        data["servicePaymentReceivedId"] = this.servicePaymentReceivedId;
        data["ccn"] = this.ccn;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["insuredId"] = this.insuredId;
        data["claimLineId"] = this.claimLineId;
        data["lcn"] = this.lcn;
        data["hcpcsCode"] = this.hcpcsCode;
        data["modifier"] = this.modifier;
        data["claimLineCreatedDate"] = this.claimLineCreatedDate ? this.claimLineCreatedDate.toISOString() : <any>undefined;
        data["claimStartDate"] = this.claimStartDate ? this.claimStartDate.toISOString() : <any>undefined;
        data["claimEndDate"] = this.claimEndDate ? this.claimEndDate.toISOString() : <any>undefined;
        data["remainingAmount"] = this.remainingAmount;
        data["appliedRemainingAmount"] = this.appliedRemainingAmount;
        data["appliedAmount"] = this.appliedAmount;
        data["icn"] = this.icn;
        data["billUnits"] = this.billUnits;
        data["submittedAmount"] = this.submittedAmount;
        data["mcn"] = this.mcn;
        if (Array.isArray(this.appliedPayments)) {
            data["appliedPayments"] = [];
            for (let item of this.appliedPayments)
                data["appliedPayments"].push(item.toJSON());
        }
        if (Array.isArray(this.adjustmentCodes)) {
            data["adjustmentCodes"] = [];
            for (let item of this.adjustmentCodes)
                data["adjustmentCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.groupCodes)) {
            data["groupCodes"] = [];
            for (let item of this.groupCodes)
                data["groupCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.remarkCodes)) {
            data["remarkCodes"] = [];
            for (let item of this.remarkCodes)
                data["remarkCodes"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusString"] = this.statusString;
        data["copayAmount"] = this.copayAmount;
        data["writeOffAmount"] = this.writeOffAmount;
        if (Array.isArray(this.multiplePayments)) {
            data["multiplePayments"] = [];
            for (let item of this.multiplePayments)
                data["multiplePayments"].push(item.toJSON());
        }
        data["hasMultiplePayments"] = this.hasMultiplePayments;
        return data;
    }
}

export interface IPendingPaymentsResponseDto {
    claimId?: number;
    claimPaymentReceivedId?: number | undefined;
    servicePaymentReceivedId?: number | undefined;
    ccn?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    insuredId?: string | undefined;
    claimLineId?: number;
    lcn?: string | undefined;
    hcpcsCode?: string | undefined;
    modifier?: string | undefined;
    claimLineCreatedDate?: Date | undefined;
    claimStartDate?: Date | undefined;
    claimEndDate?: Date | undefined;
    remainingAmount?: number | undefined;
    appliedRemainingAmount?: number | undefined;
    appliedAmount?: number | undefined;
    icn?: string | undefined;
    billUnits?: number | undefined;
    submittedAmount?: number | undefined;
    mcn?: string | undefined;
    appliedPayments?: ParticipantAppliedPayments[] | undefined;
    adjustmentCodes?: LcnAdjustmentCodeDto[] | undefined;
    groupCodes?: LcnGroupCodeDto[] | undefined;
    remarkCodes?: LcnRemarkCodeDto[] | undefined;
    status?: LCNStatus;
    statusString?: string | undefined;
    copayAmount?: number | undefined;
    writeOffAmount?: number | undefined;
    multiplePayments?: MultiplePaymentsForLcnDto[] | undefined;
    hasMultiplePayments?: boolean;
}

export class PostRequestBase implements IPostRequestBase {
    id?: number;
    identifier?: string | undefined;

    constructor(data?: IPostRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): PostRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new PostRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IPostRequestBase {
    id?: number;
    identifier?: string | undefined;
}

export class ProgramConfigurationResponseDto implements IProgramConfigurationResponseDto {
    id?: number;
    template?: string | undefined;
    overrideAuthRequired?: boolean;
    attendingProviderRequired?: boolean;
    referringProviderRequired?: boolean;
    passportIdRequired?: boolean;
    timelyFillingDays?: number;
    timelyReworkDays?: number;
    threshold?: number;
    programId?: number;
    program?: string | undefined;
    description?: string | undefined;
    lateTime?: LateTime;
    caregiverPartitioning?: boolean;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IProgramConfigurationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.template = _data["template"];
            this.overrideAuthRequired = _data["overrideAuthRequired"];
            this.attendingProviderRequired = _data["attendingProviderRequired"];
            this.referringProviderRequired = _data["referringProviderRequired"];
            this.passportIdRequired = _data["passportIdRequired"];
            this.timelyFillingDays = _data["timelyFillingDays"];
            this.timelyReworkDays = _data["timelyReworkDays"];
            this.threshold = _data["threshold"];
            this.programId = _data["programId"];
            this.program = _data["program"];
            this.description = _data["description"];
            this.lateTime = _data["lateTime"];
            this.caregiverPartitioning = _data["caregiverPartitioning"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramConfigurationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramConfigurationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["template"] = this.template;
        data["overrideAuthRequired"] = this.overrideAuthRequired;
        data["attendingProviderRequired"] = this.attendingProviderRequired;
        data["referringProviderRequired"] = this.referringProviderRequired;
        data["passportIdRequired"] = this.passportIdRequired;
        data["timelyFillingDays"] = this.timelyFillingDays;
        data["timelyReworkDays"] = this.timelyReworkDays;
        data["threshold"] = this.threshold;
        data["programId"] = this.programId;
        data["program"] = this.program;
        data["description"] = this.description;
        data["lateTime"] = this.lateTime;
        data["caregiverPartitioning"] = this.caregiverPartitioning;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgramConfigurationResponseDto {
    id?: number;
    template?: string | undefined;
    overrideAuthRequired?: boolean;
    attendingProviderRequired?: boolean;
    referringProviderRequired?: boolean;
    passportIdRequired?: boolean;
    timelyFillingDays?: number;
    timelyReworkDays?: number;
    threshold?: number;
    programId?: number;
    program?: string | undefined;
    description?: string | undefined;
    lateTime?: LateTime;
    caregiverPartitioning?: boolean;
    startDate?: Date;
    endDate?: Date;
}

export class ProgramConfigurationResponseDtoGridResponseBase implements IProgramConfigurationResponseDtoGridResponseBase {
    items?: ProgramConfigurationResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ProgramConfigurationResponseDto;

    constructor(data?: IProgramConfigurationResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProgramConfigurationResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ProgramConfigurationResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramConfigurationResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramConfigurationResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProgramConfigurationResponseDtoGridResponseBase {
    items?: ProgramConfigurationResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ProgramConfigurationResponseDto;
}

export class ProgramEDIConfigRequestDto implements IProgramEDIConfigRequestDto {
    id?: number | undefined;
    templateName!: string;
    companyId?: number;
    description!: string;
    payorId!: number;
    payorCode?: string | undefined;
    programId!: number;
    programCode?: string | undefined;
    programEdiConfigDetails?: ProgramEdiConfigurationDetailsResponseByIdDto[] | undefined;

    constructor(data?: IProgramEDIConfigRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.companyId = _data["companyId"];
            this.description = _data["description"];
            this.payorId = _data["payorId"];
            this.payorCode = _data["payorCode"];
            this.programId = _data["programId"];
            this.programCode = _data["programCode"];
            if (Array.isArray(_data["programEdiConfigDetails"])) {
                this.programEdiConfigDetails = [] as any;
                for (let item of _data["programEdiConfigDetails"])
                    this.programEdiConfigDetails!.push(ProgramEdiConfigurationDetailsResponseByIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgramEDIConfigRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramEDIConfigRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["companyId"] = this.companyId;
        data["description"] = this.description;
        data["payorId"] = this.payorId;
        data["payorCode"] = this.payorCode;
        data["programId"] = this.programId;
        data["programCode"] = this.programCode;
        if (Array.isArray(this.programEdiConfigDetails)) {
            data["programEdiConfigDetails"] = [];
            for (let item of this.programEdiConfigDetails)
                data["programEdiConfigDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProgramEDIConfigRequestDto {
    id?: number | undefined;
    templateName: string;
    companyId?: number;
    description: string;
    payorId: number;
    payorCode?: string | undefined;
    programId: number;
    programCode?: string | undefined;
    programEdiConfigDetails?: ProgramEdiConfigurationDetailsResponseByIdDto[] | undefined;
}

export class ProgramEdiConfigurationDetailsResponseByIdDto implements IProgramEdiConfigurationDetailsResponseByIdDto {
    id?: number | undefined;
    segment?: string | undefined;
    loop?: string | undefined;
    field?: string | undefined;
    value?: string | undefined;
    isNew?: boolean;

    constructor(data?: IProgramEdiConfigurationDetailsResponseByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.segment = _data["segment"];
            this.loop = _data["loop"];
            this.field = _data["field"];
            this.value = _data["value"];
            this.isNew = _data["isNew"];
        }
    }

    static fromJS(data: any): ProgramEdiConfigurationDetailsResponseByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramEdiConfigurationDetailsResponseByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["segment"] = this.segment;
        data["loop"] = this.loop;
        data["field"] = this.field;
        data["value"] = this.value;
        data["isNew"] = this.isNew;
        return data;
    }
}

export interface IProgramEdiConfigurationDetailsResponseByIdDto {
    id?: number | undefined;
    segment?: string | undefined;
    loop?: string | undefined;
    field?: string | undefined;
    value?: string | undefined;
    isNew?: boolean;
}

export class ProgramEdiConfigurationResponseByIdDto implements IProgramEdiConfigurationResponseByIdDto {
    id?: number;
    templateName?: string | undefined;
    description?: string | undefined;
    payorId?: number;
    payorCode?: string | undefined;
    programId?: number;
    programCode?: string | undefined;
    programConfigDetails?: ProgramEdiConfigurationDetailsResponseByIdDto[] | undefined;

    constructor(data?: IProgramEdiConfigurationResponseByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.payorId = _data["payorId"];
            this.payorCode = _data["payorCode"];
            this.programId = _data["programId"];
            this.programCode = _data["programCode"];
            if (Array.isArray(_data["programConfigDetails"])) {
                this.programConfigDetails = [] as any;
                for (let item of _data["programConfigDetails"])
                    this.programConfigDetails!.push(ProgramEdiConfigurationDetailsResponseByIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgramEdiConfigurationResponseByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramEdiConfigurationResponseByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["payorId"] = this.payorId;
        data["payorCode"] = this.payorCode;
        data["programId"] = this.programId;
        data["programCode"] = this.programCode;
        if (Array.isArray(this.programConfigDetails)) {
            data["programConfigDetails"] = [];
            for (let item of this.programConfigDetails)
                data["programConfigDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProgramEdiConfigurationResponseByIdDto {
    id?: number;
    templateName?: string | undefined;
    description?: string | undefined;
    payorId?: number;
    payorCode?: string | undefined;
    programId?: number;
    programCode?: string | undefined;
    programConfigDetails?: ProgramEdiConfigurationDetailsResponseByIdDto[] | undefined;
}

export class ProgramEdiConfigurationResponseDto implements IProgramEdiConfigurationResponseDto {
    id?: number;
    templateName?: string | undefined;
    description?: string | undefined;
    payer?: string | undefined;
    program?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IProgramEdiConfigurationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.payer = _data["payer"];
            this.program = _data["program"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ProgramEdiConfigurationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramEdiConfigurationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["payer"] = this.payer;
        data["program"] = this.program;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IProgramEdiConfigurationResponseDto {
    id?: number;
    templateName?: string | undefined;
    description?: string | undefined;
    payer?: string | undefined;
    program?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ProgramEdiConfigurationResponseDtoGridResponseBase implements IProgramEdiConfigurationResponseDtoGridResponseBase {
    items?: ProgramEdiConfigurationResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ProgramEdiConfigurationResponseDto;

    constructor(data?: IProgramEdiConfigurationResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProgramEdiConfigurationResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ProgramEdiConfigurationResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramEdiConfigurationResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramEdiConfigurationResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProgramEdiConfigurationResponseDtoGridResponseBase {
    items?: ProgramEdiConfigurationResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ProgramEdiConfigurationResponseDto;
}

export class ProgramTemplateMappingResponse implements IProgramTemplateMappingResponse {
    isExists?: number;

    constructor(data?: IProgramTemplateMappingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isExists = _data["isExists"];
        }
    }

    static fromJS(data: any): ProgramTemplateMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramTemplateMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExists"] = this.isExists;
        return data;
    }
}

export interface IProgramTemplateMappingResponse {
    isExists?: number;
}

export class ReceiverDetails implements IReceiverDetails {
    receiverName?: string | undefined;
    receiverID?: string | undefined;
    programCode?: string | undefined;

    constructor(data?: IReceiverDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiverName = _data["receiverName"];
            this.receiverID = _data["receiverID"];
            this.programCode = _data["programCode"];
        }
    }

    static fromJS(data: any): ReceiverDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverName"] = this.receiverName;
        data["receiverID"] = this.receiverID;
        data["programCode"] = this.programCode;
        return data;
    }
}

export interface IReceiverDetails {
    receiverName?: string | undefined;
    receiverID?: string | undefined;
    programCode?: string | undefined;
}

export class RemarkCodeDto implements IRemarkCodeDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    remarkCodeId?: number | undefined;
    remarkCode?: string | undefined;
    description?: string | undefined;
    statusIntValue?: number | undefined;
    status?: string | undefined;

    constructor(data?: IRemarkCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.remarkCodeId = _data["remarkCodeId"];
            this.remarkCode = _data["remarkCode"];
            this.description = _data["description"];
            this.statusIntValue = _data["statusIntValue"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RemarkCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemarkCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["remarkCodeId"] = this.remarkCodeId;
        data["remarkCode"] = this.remarkCode;
        data["description"] = this.description;
        data["statusIntValue"] = this.statusIntValue;
        data["status"] = this.status;
        return data;
    }
}

export interface IRemarkCodeDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    remarkCodeId?: number | undefined;
    remarkCode?: string | undefined;
    description?: string | undefined;
    statusIntValue?: number | undefined;
    status?: string | undefined;
}

export class RemarkCodeDtoGridResponseBase implements IRemarkCodeDtoGridResponseBase {
    items?: RemarkCodeDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: RemarkCodeDto;

    constructor(data?: IRemarkCodeDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RemarkCodeDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? RemarkCodeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemarkCodeDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new RemarkCodeDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRemarkCodeDtoGridResponseBase {
    items?: RemarkCodeDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: RemarkCodeDto;
}

export class RemarkCodeRequestDto implements IRemarkCodeRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    onlyActive?: number | undefined;
    isExport?: boolean;

    constructor(data?: IRemarkCodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.searchParameter = _data["searchParameter"];
            this.onlyActive = _data["onlyActive"];
            this.isExport = _data["isExport"];
        }
    }

    static fromJS(data: any): RemarkCodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemarkCodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["searchParameter"] = this.searchParameter;
        data["onlyActive"] = this.onlyActive;
        data["isExport"] = this.isExport;
        return data;
    }
}

export interface IRemarkCodeRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    searchParameter?: string | undefined;
    onlyActive?: number | undefined;
    isExport?: boolean;
}

export class ResponseModel implements IResponseModel {
    isSuccess?: boolean;
    message?: string | undefined;
    rowValidationMessages?: ShiftInjectorResponseModel[] | undefined;
    id?: number;
    batchNumber?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            if (Array.isArray(_data["rowValidationMessages"])) {
                this.rowValidationMessages = [] as any;
                for (let item of _data["rowValidationMessages"])
                    this.rowValidationMessages!.push(ShiftInjectorResponseModel.fromJS(item));
            }
            this.id = _data["id"];
            this.batchNumber = _data["batchNumber"];
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        if (Array.isArray(this.rowValidationMessages)) {
            data["rowValidationMessages"] = [];
            for (let item of this.rowValidationMessages)
                data["rowValidationMessages"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["batchNumber"] = this.batchNumber;
        return data;
    }
}

export interface IResponseModel {
    isSuccess?: boolean;
    message?: string | undefined;
    rowValidationMessages?: ShiftInjectorResponseModel[] | undefined;
    id?: number;
    batchNumber?: string | undefined;
}

export class SaveAsDraftForAdjustmentResponse implements ISaveAsDraftForAdjustmentResponse {
    responseModel?: ResponseModel;
    batchId?: string;

    constructor(data?: ISaveAsDraftForAdjustmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseModel = _data["responseModel"] ? ResponseModel.fromJS(_data["responseModel"]) : <any>undefined;
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): SaveAsDraftForAdjustmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAsDraftForAdjustmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseModel"] = this.responseModel ? this.responseModel.toJSON() : <any>undefined;
        data["batchId"] = this.batchId;
        return data;
    }
}

export interface ISaveAsDraftForAdjustmentResponse {
    responseModel?: ResponseModel;
    batchId?: string;
}

export class SaveClaimsWriteOffRequestDto implements ISaveClaimsWriteOffRequestDto {
    paymentsBatch?: PaymentsBatchDto;
    claimsWriteOff?: ClaimsWriteOffDto[] | undefined;
    note?: string | undefined;
    appliedWriteOffAmout?: number;

    constructor(data?: ISaveClaimsWriteOffRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentsBatch = _data["paymentsBatch"] ? PaymentsBatchDto.fromJS(_data["paymentsBatch"]) : <any>undefined;
            if (Array.isArray(_data["claimsWriteOff"])) {
                this.claimsWriteOff = [] as any;
                for (let item of _data["claimsWriteOff"])
                    this.claimsWriteOff!.push(ClaimsWriteOffDto.fromJS(item));
            }
            this.note = _data["note"];
            this.appliedWriteOffAmout = _data["appliedWriteOffAmout"];
        }
    }

    static fromJS(data: any): SaveClaimsWriteOffRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveClaimsWriteOffRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentsBatch"] = this.paymentsBatch ? this.paymentsBatch.toJSON() : <any>undefined;
        if (Array.isArray(this.claimsWriteOff)) {
            data["claimsWriteOff"] = [];
            for (let item of this.claimsWriteOff)
                data["claimsWriteOff"].push(item.toJSON());
        }
        data["note"] = this.note;
        data["appliedWriteOffAmout"] = this.appliedWriteOffAmout;
        return data;
    }
}

export interface ISaveClaimsWriteOffRequestDto {
    paymentsBatch?: PaymentsBatchDto;
    claimsWriteOff?: ClaimsWriteOffDto[] | undefined;
    note?: string | undefined;
    appliedWriteOffAmout?: number;
}

export class SaveMcnWriteOffRequestDto implements ISaveMcnWriteOffRequestDto {
    paymentsBatch?: PaymentsBatchDto;
    mcnWriteOff?: McnWriteOffDto[] | undefined;
    mcnId?: number;
    pendingWriteOffAmount?: number;
    note?: string | undefined;
    appliedWriteOffAmout?: number;

    constructor(data?: ISaveMcnWriteOffRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentsBatch = _data["paymentsBatch"] ? PaymentsBatchDto.fromJS(_data["paymentsBatch"]) : <any>undefined;
            if (Array.isArray(_data["mcnWriteOff"])) {
                this.mcnWriteOff = [] as any;
                for (let item of _data["mcnWriteOff"])
                    this.mcnWriteOff!.push(McnWriteOffDto.fromJS(item));
            }
            this.mcnId = _data["mcnId"];
            this.pendingWriteOffAmount = _data["pendingWriteOffAmount"];
            this.note = _data["note"];
            this.appliedWriteOffAmout = _data["appliedWriteOffAmout"];
        }
    }

    static fromJS(data: any): SaveMcnWriteOffRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMcnWriteOffRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentsBatch"] = this.paymentsBatch ? this.paymentsBatch.toJSON() : <any>undefined;
        if (Array.isArray(this.mcnWriteOff)) {
            data["mcnWriteOff"] = [];
            for (let item of this.mcnWriteOff)
                data["mcnWriteOff"].push(item.toJSON());
        }
        data["mcnId"] = this.mcnId;
        data["pendingWriteOffAmount"] = this.pendingWriteOffAmount;
        data["note"] = this.note;
        data["appliedWriteOffAmout"] = this.appliedWriteOffAmout;
        return data;
    }
}

export interface ISaveMcnWriteOffRequestDto {
    paymentsBatch?: PaymentsBatchDto;
    mcnWriteOff?: McnWriteOffDto[] | undefined;
    mcnId?: number;
    pendingWriteOffAmount?: number;
    note?: string | undefined;
    appliedWriteOffAmout?: number;
}

export class SearchParamsForReviewDTO implements ISearchParamsForReviewDTO {
    batchId?: number;
    batchNumber?: string | undefined;
    mbccnId?: number;
    status?: number;
    payor?: string | undefined;
    programId?: string | undefined;
    programConfiguration?: string | undefined;
    programConfigurationDescription?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    timelyOnly?: string | undefined;
    claimTypes?: string[] | undefined;
    readonly claimType?: string | undefined;
    participants?: string | undefined;
    authCode?: string[] | undefined;
    servCode?: string[] | undefined;
    readonly serviceCodes?: string | undefined;
    readonly authCodes?: string | undefined;
    icn?: string | undefined;
    rejectReason?: string | undefined;
    readonly batchStatus?: string | undefined;
    cutoffDateTime?: Date | undefined;
    submitterId?: string | undefined;
    ccn?: string | undefined;
    submitterName?: string | undefined;
    receiverId?: string | undefined;
    receiverName?: string | undefined;
    taxonomy?: string | undefined;
    contactName?: string | undefined;
    npi?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    fedTaxID?: string | undefined;
    api?: string | undefined;

    constructor(data?: ISearchParamsForReviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.batchNumber = _data["batchNumber"];
            this.mbccnId = _data["mbccnId"];
            this.status = _data["status"];
            this.payor = _data["payor"];
            this.programId = _data["programId"];
            this.programConfiguration = _data["programConfiguration"];
            this.programConfigurationDescription = _data["programConfigurationDescription"];
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.timelyOnly = _data["timelyOnly"];
            if (Array.isArray(_data["claimTypes"])) {
                this.claimTypes = [] as any;
                for (let item of _data["claimTypes"])
                    this.claimTypes!.push(item);
            }
            (<any>this).claimType = _data["claimType"];
            this.participants = _data["participants"];
            if (Array.isArray(_data["authCode"])) {
                this.authCode = [] as any;
                for (let item of _data["authCode"])
                    this.authCode!.push(item);
            }
            if (Array.isArray(_data["servCode"])) {
                this.servCode = [] as any;
                for (let item of _data["servCode"])
                    this.servCode!.push(item);
            }
            (<any>this).serviceCodes = _data["serviceCodes"];
            (<any>this).authCodes = _data["authCodes"];
            this.icn = _data["icn"];
            this.rejectReason = _data["rejectReason"];
            (<any>this).batchStatus = _data["batchStatus"];
            this.cutoffDateTime = _data["cutoffDateTime"] ? new Date(_data["cutoffDateTime"].toString()) : <any>undefined;
            this.submitterId = _data["submitterId"];
            this.ccn = _data["ccn"];
            this.submitterName = _data["submitterName"];
            this.receiverId = _data["receiverId"];
            this.receiverName = _data["receiverName"];
            this.taxonomy = _data["taxonomy"];
            this.contactName = _data["contactName"];
            this.npi = _data["npi"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.fedTaxID = _data["fedTaxID"];
            this.api = _data["api"];
        }
    }

    static fromJS(data: any): SearchParamsForReviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamsForReviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["batchNumber"] = this.batchNumber;
        data["mbccnId"] = this.mbccnId;
        data["status"] = this.status;
        data["payor"] = this.payor;
        data["programId"] = this.programId;
        data["programConfiguration"] = this.programConfiguration;
        data["programConfigurationDescription"] = this.programConfigurationDescription;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["timelyOnly"] = this.timelyOnly;
        if (Array.isArray(this.claimTypes)) {
            data["claimTypes"] = [];
            for (let item of this.claimTypes)
                data["claimTypes"].push(item);
        }
        data["claimType"] = this.claimType;
        data["participants"] = this.participants;
        if (Array.isArray(this.authCode)) {
            data["authCode"] = [];
            for (let item of this.authCode)
                data["authCode"].push(item);
        }
        if (Array.isArray(this.servCode)) {
            data["servCode"] = [];
            for (let item of this.servCode)
                data["servCode"].push(item);
        }
        data["serviceCodes"] = this.serviceCodes;
        data["authCodes"] = this.authCodes;
        data["icn"] = this.icn;
        data["rejectReason"] = this.rejectReason;
        data["batchStatus"] = this.batchStatus;
        data["cutoffDateTime"] = this.cutoffDateTime ? this.cutoffDateTime.toISOString() : <any>undefined;
        data["submitterId"] = this.submitterId;
        data["ccn"] = this.ccn;
        data["submitterName"] = this.submitterName;
        data["receiverId"] = this.receiverId;
        data["receiverName"] = this.receiverName;
        data["taxonomy"] = this.taxonomy;
        data["contactName"] = this.contactName;
        data["npi"] = this.npi;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["fedTaxID"] = this.fedTaxID;
        data["api"] = this.api;
        return data;
    }
}

export interface ISearchParamsForReviewDTO {
    batchId?: number;
    batchNumber?: string | undefined;
    mbccnId?: number;
    status?: number;
    payor?: string | undefined;
    programId?: string | undefined;
    programConfiguration?: string | undefined;
    programConfigurationDescription?: string | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    timelyOnly?: string | undefined;
    claimTypes?: string[] | undefined;
    claimType?: string | undefined;
    participants?: string | undefined;
    authCode?: string[] | undefined;
    servCode?: string[] | undefined;
    serviceCodes?: string | undefined;
    authCodes?: string | undefined;
    icn?: string | undefined;
    rejectReason?: string | undefined;
    batchStatus?: string | undefined;
    cutoffDateTime?: Date | undefined;
    submitterId?: string | undefined;
    ccn?: string | undefined;
    submitterName?: string | undefined;
    receiverId?: string | undefined;
    receiverName?: string | undefined;
    taxonomy?: string | undefined;
    contactName?: string | undefined;
    npi?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    fedTaxID?: string | undefined;
    api?: string | undefined;
}

export class ServiceCode implements IServiceCode {
    code?: string | undefined;
    docType?: string | undefined;

    constructor(data?: IServiceCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.docType = _data["docType"];
        }
    }

    static fromJS(data: any): ServiceCode {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["docType"] = this.docType;
        return data;
    }
}

export interface IServiceCode {
    code?: string | undefined;
    docType?: string | undefined;
}

export class ShiftInjectorResponseModel implements IShiftInjectorResponseModel {
    rowNo?: number;
    message?: string | undefined;

    constructor(data?: IShiftInjectorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNo = _data["rowNo"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ShiftInjectorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftInjectorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNo"] = this.rowNo;
        data["message"] = this.message;
        return data;
    }
}

export interface IShiftInjectorResponseModel {
    rowNo?: number;
    message?: string | undefined;
}

export class StringGridResponseBase implements IStringGridResponseBase {
    items?: string[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: string | undefined;

    constructor(data?: IStringGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): StringGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new StringGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data;
        return data;
    }
}

export interface IStringGridResponseBase {
    items?: string[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: string | undefined;
}

export class SubmitterDetails implements ISubmitterDetails {
    submitterName?: string | undefined;
    submitterID?: string | undefined;
    programCode?: string | undefined;

    constructor(data?: ISubmitterDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitterName = _data["submitterName"];
            this.submitterID = _data["submitterID"];
            this.programCode = _data["programCode"];
        }
    }

    static fromJS(data: any): SubmitterDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitterDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitterName"] = this.submitterName;
        data["submitterID"] = this.submitterID;
        data["programCode"] = this.programCode;
        return data;
    }
}

export interface ISubmitterDetails {
    submitterName?: string | undefined;
    submitterID?: string | undefined;
    programCode?: string | undefined;
}

export class SystemUsageDto implements ISystemUsageDto {
    systemUsageId?: number;
    system?: string | undefined;

    constructor(data?: ISystemUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemUsageId = _data["systemUsageId"];
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): SystemUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemUsageId"] = this.systemUsageId;
        data["system"] = this.system;
        return data;
    }
}

export interface ISystemUsageDto {
    systemUsageId?: number;
    system?: string | undefined;
}

export class TcnCentralDBResponse implements ITcnCentralDBResponse {
    tcnId?: string | undefined;
    responseCode?: number;

    constructor(data?: ITcnCentralDBResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcnId = _data["tcnId"];
            this.responseCode = _data["responseCode"];
        }
    }

    static fromJS(data: any): TcnCentralDBResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TcnCentralDBResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcnId"] = this.tcnId;
        data["responseCode"] = this.responseCode;
        return data;
    }
}

export interface ITcnCentralDBResponse {
    tcnId?: string | undefined;
    responseCode?: number;
}

export class UnappliedPaymentSummaryDetails implements IUnappliedPaymentSummaryDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    batchId?: number;
    mcnId?: number;
    mcnCode?: string | undefined;
    unappliedAmount?: number | undefined;
    mcnAmount?: number | undefined;
    remainingAmount?: number | undefined;
    payorId?: number | undefined;
    payorName?: string | undefined;
    batchNumber?: string | undefined;
    batchStatus?: string | undefined;
    checkNumber?: string | undefined;
    checkDate?: Date | undefined;
    checkAmount?: number | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    writeOffAmount?: number | undefined;
    writeOffPending?: number | undefined;

    constructor(data?: IUnappliedPaymentSummaryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.batchId = _data["batchId"];
            this.mcnId = _data["mcnId"];
            this.mcnCode = _data["mcnCode"];
            this.unappliedAmount = _data["unappliedAmount"];
            this.mcnAmount = _data["mcnAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.batchNumber = _data["batchNumber"];
            this.batchStatus = _data["batchStatus"];
            this.checkNumber = _data["checkNumber"];
            this.checkDate = _data["checkDate"] ? new Date(_data["checkDate"].toString()) : <any>undefined;
            this.checkAmount = _data["checkAmount"];
            this.participantId = _data["participantId"];
            this.participantName = _data["participantName"];
            this.writeOffAmount = _data["writeOffAmount"];
            this.writeOffPending = _data["writeOffPending"];
        }
    }

    static fromJS(data: any): UnappliedPaymentSummaryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UnappliedPaymentSummaryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["batchId"] = this.batchId;
        data["mcnId"] = this.mcnId;
        data["mcnCode"] = this.mcnCode;
        data["unappliedAmount"] = this.unappliedAmount;
        data["mcnAmount"] = this.mcnAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["batchNumber"] = this.batchNumber;
        data["batchStatus"] = this.batchStatus;
        data["checkNumber"] = this.checkNumber;
        data["checkDate"] = this.checkDate ? this.checkDate.toISOString() : <any>undefined;
        data["checkAmount"] = this.checkAmount;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["writeOffAmount"] = this.writeOffAmount;
        data["writeOffPending"] = this.writeOffPending;
        return data;
    }
}

export interface IUnappliedPaymentSummaryDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    batchId?: number;
    mcnId?: number;
    mcnCode?: string | undefined;
    unappliedAmount?: number | undefined;
    mcnAmount?: number | undefined;
    remainingAmount?: number | undefined;
    payorId?: number | undefined;
    payorName?: string | undefined;
    batchNumber?: string | undefined;
    batchStatus?: string | undefined;
    checkNumber?: string | undefined;
    checkDate?: Date | undefined;
    checkAmount?: number | undefined;
    participantId?: string | undefined;
    participantName?: string | undefined;
    writeOffAmount?: number | undefined;
    writeOffPending?: number | undefined;
}

export class UnappliedPaymentSummaryDetailsUnappliedPaymentSummary implements IUnappliedPaymentSummaryDetailsUnappliedPaymentSummary {
    items?: UnappliedPaymentSummaryDetails[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: UnappliedPaymentSummaryDetails;
    mcnIds?: number[] | undefined;

    constructor(data?: IUnappliedPaymentSummaryDetailsUnappliedPaymentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UnappliedPaymentSummaryDetails.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? UnappliedPaymentSummaryDetails.fromJS(_data["data"]) : <any>undefined;
            if (Array.isArray(_data["mcnIds"])) {
                this.mcnIds = [] as any;
                for (let item of _data["mcnIds"])
                    this.mcnIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UnappliedPaymentSummaryDetailsUnappliedPaymentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UnappliedPaymentSummaryDetailsUnappliedPaymentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (Array.isArray(this.mcnIds)) {
            data["mcnIds"] = [];
            for (let item of this.mcnIds)
                data["mcnIds"].push(item);
        }
        return data;
    }
}

export interface IUnappliedPaymentSummaryDetailsUnappliedPaymentSummary {
    items?: UnappliedPaymentSummaryDetails[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: UnappliedPaymentSummaryDetails;
    mcnIds?: number[] | undefined;
}

export class UnappliedPaymentSummaryRequest implements IUnappliedPaymentSummaryRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string | undefined;
    batchStatus?: string | undefined;
    filterType?: string | undefined;

    constructor(data?: IUnappliedPaymentSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.filterType = _data["filterType"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.payor = _data["payor"];
            this.batchStatus = _data["batchStatus"];
        }
    }

    static fromJS(data: any): UnappliedPaymentSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnappliedPaymentSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["filterType"] = this.filterType;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["payor"] = this.payor;
        data["batchStatus"] = this.batchStatus;
        return data;
    }
}

export interface IUnappliedPaymentSummaryRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    filterType?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payor?: string | undefined;
    batchStatus?: string | undefined;
}

export enum UnitMethod {
    UnitBased = "UnitBased",
    MarkUp = "MarkUp",
    ExactCost = "ExactCost",
}

export class UpdateBillingSyncDto implements IUpdateBillingSyncDto {
    tcn?: string | undefined;
    isError?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUpdateBillingSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcn = _data["tcn"];
            this.isError = _data["isError"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpdateBillingSyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBillingSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcn"] = this.tcn;
        data["isError"] = this.isError;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUpdateBillingSyncDto {
    tcn?: string | undefined;
    isError?: boolean;
    errorMessage?: string | undefined;
}

export class UpdateCcnDetailsDTO implements IUpdateCcnDetailsDTO {
    ccn?: string | undefined;
    note?: string | undefined;

    constructor(data?: IUpdateCcnDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ccn = _data["ccn"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateCcnDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCcnDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ccn"] = this.ccn;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateCcnDetailsDTO {
    ccn?: string | undefined;
    note?: string | undefined;
}

export class UpdateIcnRequest implements IUpdateIcnRequest {
    id?: number;
    icn?: string | undefined;

    constructor(data?: IUpdateIcnRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.icn = _data["icn"];
        }
    }

    static fromJS(data: any): UpdateIcnRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIcnRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["icn"] = this.icn;
        return data;
    }
}

export interface IUpdateIcnRequest {
    id?: number;
    icn?: string | undefined;
}

export class UpdateManualClaimRequest implements IUpdateManualClaimRequest {
    batchNumber?: string | undefined;
    updateManualClaimsDto?: UpdateManualClaimsDto[] | undefined;

    constructor(data?: IUpdateManualClaimRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNumber = _data["batchNumber"];
            if (Array.isArray(_data["updateManualClaimsDto"])) {
                this.updateManualClaimsDto = [] as any;
                for (let item of _data["updateManualClaimsDto"])
                    this.updateManualClaimsDto!.push(UpdateManualClaimsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateManualClaimRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManualClaimRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        if (Array.isArray(this.updateManualClaimsDto)) {
            data["updateManualClaimsDto"] = [];
            for (let item of this.updateManualClaimsDto)
                data["updateManualClaimsDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateManualClaimRequest {
    batchNumber?: string | undefined;
    updateManualClaimsDto?: UpdateManualClaimsDto[] | undefined;
}

export class UpdateManualClaimsDto implements IUpdateManualClaimsDto {
    ccn?: string | undefined;
    billUnit?: number;
    billAmount?: number;

    constructor(data?: IUpdateManualClaimsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ccn = _data["ccn"];
            this.billUnit = _data["billUnit"];
            this.billAmount = _data["billAmount"];
        }
    }

    static fromJS(data: any): UpdateManualClaimsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManualClaimsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ccn"] = this.ccn;
        data["billUnit"] = this.billUnit;
        data["billAmount"] = this.billAmount;
        return data;
    }
}

export interface IUpdateManualClaimsDto {
    ccn?: string | undefined;
    billUnit?: number;
    billAmount?: number;
}

export class UpdateTcnStatusRequest implements IUpdateTcnStatusRequest {
    tcnDetails?: TcnCentralDBResponse[] | undefined;

    constructor(data?: IUpdateTcnStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tcnDetails"])) {
                this.tcnDetails = [] as any;
                for (let item of _data["tcnDetails"])
                    this.tcnDetails!.push(TcnCentralDBResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTcnStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTcnStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tcnDetails)) {
            data["tcnDetails"] = [];
            for (let item of this.tcnDetails)
                data["tcnDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTcnStatusRequest {
    tcnDetails?: TcnCentralDBResponse[] | undefined;
}

export class VoidInjectorDto implements IVoidInjectorDto {
    tcn?: string | undefined;
    rowId?: number;

    constructor(data?: IVoidInjectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcn = _data["tcn"];
            this.rowId = _data["rowId"];
        }
    }

    static fromJS(data: any): VoidInjectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoidInjectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcn"] = this.tcn;
        data["rowId"] = this.rowId;
        return data;
    }
}

export interface IVoidInjectorDto {
    tcn?: string | undefined;
    rowId?: number;
}

export class WriteOffErrorTypeByIdResponseDto implements IWriteOffErrorTypeByIdResponseDto {
    id?: number;
    woErrorType?: string | undefined;
    companyId?: number;
    descr?: string | undefined;
    status?: string | undefined;

    constructor(data?: IWriteOffErrorTypeByIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.woErrorType = _data["woErrorType"];
            this.companyId = _data["companyId"];
            this.descr = _data["descr"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WriteOffErrorTypeByIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffErrorTypeByIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["woErrorType"] = this.woErrorType;
        data["companyId"] = this.companyId;
        data["descr"] = this.descr;
        data["status"] = this.status;
        return data;
    }
}

export interface IWriteOffErrorTypeByIdResponseDto {
    id?: number;
    woErrorType?: string | undefined;
    companyId?: number;
    descr?: string | undefined;
    status?: string | undefined;
}

export class WriteOffErrorTypeRequestDto implements IWriteOffErrorTypeRequestDto {
    id?: number | undefined;
    woErrorType!: string;
    status?: string | undefined;
    descr?: string | undefined;
    companyId?: number;

    constructor(data?: IWriteOffErrorTypeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.woErrorType = _data["woErrorType"];
            this.status = _data["status"];
            this.descr = _data["descr"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): WriteOffErrorTypeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffErrorTypeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["woErrorType"] = this.woErrorType;
        data["status"] = this.status;
        data["descr"] = this.descr;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IWriteOffErrorTypeRequestDto {
    id?: number | undefined;
    woErrorType: string;
    status?: string | undefined;
    descr?: string | undefined;
    companyId?: number;
}

export class WriteOffErrorTypeResponseDto implements IWriteOffErrorTypeResponseDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    woErrorType?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;

    constructor(data?: IWriteOffErrorTypeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedByName = _data["updatedByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.woErrorType = _data["woErrorType"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WriteOffErrorTypeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffErrorTypeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedByName"] = this.updatedByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["woErrorType"] = this.woErrorType;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface IWriteOffErrorTypeResponseDto {
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    id?: number;
    woErrorType?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
}

export class WriteOffErrorTypeResponseDtoGridResponseBase implements IWriteOffErrorTypeResponseDtoGridResponseBase {
    items?: WriteOffErrorTypeResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: WriteOffErrorTypeResponseDto;

    constructor(data?: IWriteOffErrorTypeResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WriteOffErrorTypeResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? WriteOffErrorTypeResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffErrorTypeResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffErrorTypeResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWriteOffErrorTypeResponseDtoGridResponseBase {
    items?: WriteOffErrorTypeResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: WriteOffErrorTypeResponseDto;
}

export class WriteOffResponse implements IWriteOffResponse {
    writeOffCause?: string | undefined;
    writeOffDate?: Date | undefined;
    batchStatus?: string | undefined;
    writeOffAmount?: number;
    userId?: string | undefined;
    writeOffBatchNumber?: string | undefined;
    lcn?: string | undefined;
    moneyControlNumber?: string | undefined;
    participantId?: string | undefined;
    mcnId?: number;
    payorId?: string | undefined;
    totalWriteoffAmount?: number;
    totalPendingWriteOffAmount?: number;
    writeOffErrorType?: string | undefined;

    constructor(data?: IWriteOffResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.writeOffCause = _data["writeOffCause"];
            this.writeOffDate = _data["writeOffDate"] ? new Date(_data["writeOffDate"].toString()) : <any>undefined;
            this.batchStatus = _data["batchStatus"];
            this.writeOffAmount = _data["writeOffAmount"];
            this.userId = _data["userId"];
            this.writeOffBatchNumber = _data["writeOffBatchNumber"];
            this.lcn = _data["lcn"];
            this.moneyControlNumber = _data["moneyControlNumber"];
            this.participantId = _data["participantId"];
            this.mcnId = _data["mcnId"];
            this.payorId = _data["payorId"];
            this.totalWriteoffAmount = _data["totalWriteoffAmount"];
            this.totalPendingWriteOffAmount = _data["totalPendingWriteOffAmount"];
            this.writeOffErrorType = _data["writeOffErrorType"];
        }
    }

    static fromJS(data: any): WriteOffResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["writeOffCause"] = this.writeOffCause;
        data["writeOffDate"] = this.writeOffDate ? this.writeOffDate.toISOString() : <any>undefined;
        data["batchStatus"] = this.batchStatus;
        data["writeOffAmount"] = this.writeOffAmount;
        data["userId"] = this.userId;
        data["writeOffBatchNumber"] = this.writeOffBatchNumber;
        data["lcn"] = this.lcn;
        data["moneyControlNumber"] = this.moneyControlNumber;
        data["participantId"] = this.participantId;
        data["mcnId"] = this.mcnId;
        data["payorId"] = this.payorId;
        data["totalWriteoffAmount"] = this.totalWriteoffAmount;
        data["totalPendingWriteOffAmount"] = this.totalPendingWriteOffAmount;
        data["writeOffErrorType"] = this.writeOffErrorType;
        return data;
    }
}

export interface IWriteOffResponse {
    writeOffCause?: string | undefined;
    writeOffDate?: Date | undefined;
    batchStatus?: string | undefined;
    writeOffAmount?: number;
    userId?: string | undefined;
    writeOffBatchNumber?: string | undefined;
    lcn?: string | undefined;
    moneyControlNumber?: string | undefined;
    participantId?: string | undefined;
    mcnId?: number;
    payorId?: string | undefined;
    totalWriteoffAmount?: number;
    totalPendingWriteOffAmount?: number;
    writeOffErrorType?: string | undefined;
}

export class WriteOffResponseGridResponseBase implements IWriteOffResponseGridResponseBase {
    items?: WriteOffResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: WriteOffResponse;

    constructor(data?: IWriteOffResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WriteOffResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? WriteOffResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWriteOffResponseGridResponseBase {
    items?: WriteOffResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: WriteOffResponse;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
